import { params, const_var } from "../../redux/reducers/reducer";
import * as utlis from "../../redux/reducers/utils";
import { LEAN_TYPE_NUM_TO_STR, ManufacturesDefaultDetails } from "../../Constants/constant";
import { getGaugeRoofCost } from "./buildingPricing.helper";
import { roofColorPriciCalculation, roofColorPricingCalculation, roofColorPricingLogic, trimColorPricingCalculation, wainscotColorPricingCalculation, wallColorPricingCalculation } from "./color_pricing/colorPricing";
import { endStoragePriceCalculation, leftRightStoragePriceCalculation } from "./utility_pricing/utilityPricingHelper";
import { getDrawingPricing, getPriceForExtraOptions } from "../extra_options_pricing/extra.pricing.helper";
import { calculateWalls, handleConnectionFeesCalculation, handleInsulationCalculation, handleRoofBaseCalculation, handleSidePanelEndData } from "./buildingCalculation.helper";
import { calculateWainscotPrice } from "../building/building_color/wainscotColor.helper";
import { extractDataFromInsulation, heritageNoInsulation } from "../insulation_pricing/insulationPricing.helper";
import { MayberryCommissionCal, MayberrySurchargeCal } from "./tax_discount_calculation/taxCalculation.helper";
import { trussCalcuate } from "../building_component/truss/truss.helper";
import { deleteUncheckWallsfromInsulationWalls } from "../lean_building_pricing/lean_building_wall/leanBuildingWall.helper";
import { prepareObjToShowValue } from "../building/building_config/componentConfig";
import { manufacturerDiscountCalculation } from "./tax_discount_calculation/manufacturerDiscount.helper";
import { calculateLegsPrice, calculateRoofPitchPrice, endJtrimCalculation, jtrimCalculation } from "./component_pricing/componentPricing";
export const createCenterBuildingPriceCalculationHelpers = (getDeps = () => ({})) => {
	const getRuntimeDeps = () => (getDeps ? getDeps() : {}) || {};
	const cP = (chk, isLean, componentIndex, componentVal, is_editChk, isPrompt) => {
		const { ConvStr, calculateDoorComponentPrice, calcPriceWithCostType, convertToTwoDecimalNumber, filtterArrayElements, isCustomInsulation, removeDataFromArray, setInsulation, uUdD, leanuUdD } = getRuntimeDeps();
		const p_c_i = params.p_c_i;
		const_var.callFromDoorAddOrRemove = false;
		const_var.BuildingPriceArrar["overhead_door_calculation"] = undefined;
		const_var.BuildingPriceArrar["insulation_calculation"] = undefined;
		const_var.newTaxCalcuArray = [];
		const_var.sendTaxarray = [];
		var CalculatesurchargeFees = 0;
		let CheckCut = chk;
		let data = const_var.isLTBuilding ? structuredClone(const_var.holdPricingResponse) : const_var.a_p_d_a;
		let cbData = structuredClone(const_var.holdPricingResponse);
		let t_c_b = 0;
		let t_c = 0;
		let post_data = {};
		post_data["building"] = {};
		let a_p_d_a = data;
		params.p_w = parseInt(params.p_w);
		params.p_d = parseInt(params.p_d);
		params.p_h = parseInt(params.p_h);
		var a,
			b = {};
		let extra_items = [];
		let extraItems = {
			right: [],
			left: [],
			front: [],
			back: [],
			centerBuilding: []
		};
		var extra_price_cal = [];
		var activeLean = "";
		let CalCulateRoofBasePrice = 0;
		let CalCulateRoofUtilityEndPrice = 0;
		let CalCulateRoofEndClosePrice = 0;
		let CalCulateRoofEndGablePrice = 0;
		let UpdatePriceRecord = false;
		let surchargeArray = const_var.stateManufacturerAcordingAPIDiscount?.surchargeArray?.[params.m_s_n];
		let commissionArray = const_var.stateManufacturerAcordingAPIDiscount?.commissions?.[params.m_s_n];
		var VUEData = const_var.CallApionAction == false ? const_var.defaultProData : "";
		if (const_var.UpdatedPriceData.length > 0) {
			UpdatePriceRecord = true;
		}
		if (const_var.loginSession == false) {
			const_var.UpdatedPriceData.down_payment_rate = undefined;
		}
		let heightFullData = "";
		let customOrientation = params.p_v_w;
		if (params.wallOrientation && params.wallOrientation != "") {
			customOrientation = params.p_v_w && params.wallOrientation == "vertical" ? true : false;
		}
		a = {
			state_name: const_var.stateNameAcordingAPI[params.p_s_n].name,
			state_list: params.p_s_n,
			state: params.p_s_n,
			manufacturer_name: const_var.stateManufacturerAcordingAPIDiscount["manuName"][params.m_s_n],
			manufacturer: params.m_s_n,
			building_type: params.p_b_t,
			building_type_name: params.building_type_name,
			display_building_type_name: params.building_type_name,
			checkeditName: params.checkeditName,
			other_building_type_name: params.other_building_type_name,
			roof_style: params.p_r_s,
			roof_style_name: const_var.TypeEnumID[params.p_r_s],
			installation_surface: ConvStr(const_var.installationValue[params.p_i_s]),
			width: params.p_b_t == "2" ? params.p_w + 24 : params.p_w,
			length: params.p_d,
			height: params.p_h,
			roof_length: params.frame_length,
			gauge: const_var.g_v,
			front_wall: params.p_f_w == "Extended Gable" ? "extended_gable" : ConvStr(params.p_f_w),
			back_wall: params.p_b_w == "Extended Gable" ? "extended_gable" : ConvStr(params.p_b_w),
			left_wall: ConvStr(params.p_l_w),
			right_wall: ConvStr(params.p_r_w),
			back_wall_price: 0,
			front_wall_price: 0,
			left_wall_price: 0,
			right_wall_price: 0,
			front_wall_vertical: customOrientation,
			back_wall_vertical: customOrientation,
			left_wall_vertical: customOrientation,
			right_wall_vertical: customOrientation,
			vertical_walls: customOrientation,
			wallTexture: params.wallTexture,
			heavy_snow: const_var.CheckSnowLoadValue == 35 ? 0 : 1,

			singleSlope: params.singleSlope,
			isBreezeway: params.isBreezeway,
			cupolas: const_var.cupolas,
			cupolaEntries: const_var.cupolaEntries,
			wallOrientation: params.wallOrientation
		};
		data = a_p_d_a;
		const roofColorConfig = const_var.c_m_a_Colors?.[params.p_r_c_id];
		const wallColorConfig = const_var.c_m_a_Colors?.[params.p_w_c_id];
		const trimColorConfig = const_var.c_m_a_Colors?.[params.p_t_c_id];
		const wainscotColorConfig = const_var.c_m_a_Colors?.[params.p_w_c_c_id];
		if (const_var.isLTBuilding) {
			utlis.updateCPAccordingToLNTBuilding();
		}
		if (const_var.crmSetting.is_Edit) {
			if (params.added_building_bracing.p_s_c_b_l == true && const_var.LNTCrossBracing["left"] != undefined && const_var.LNTCrossBracing["left"]["Side Cross Bracing"] != undefined) {
				extraItems["left"].push(const_var.LNTCrossBracing["left"]["Side Cross Bracing"]);
			}
			if (params.added_building_bracing.p_s_c_b_r == true && const_var.LNTCrossBracing["right"] != undefined && const_var.LNTCrossBracing["right"]["Side Cross Bracing"] != undefined) {
				extraItems["right"].push(const_var.LNTCrossBracing["right"]["Side Cross Bracing"]);
			}
			if (params.added_building_bracing.p_s_c_b_f == true && const_var.LNTCrossBracing["front"] != undefined && const_var.LNTCrossBracing["front"]["Side Cross Bracing"] != undefined) {
				extraItems["front"].push(const_var.LNTCrossBracing["front"]["Side Cross Bracing"]);
			}
			if (params.added_building_bracing.p_s_c_b_b == true && const_var.LNTCrossBracing["back"] != undefined && const_var.LNTCrossBracing["back"]["Side Cross Bracing"] != undefined) {
				extraItems["back"].push(const_var.LNTCrossBracing["back"]["Side Cross Bracing"]);
			}

			if (params.added_building_bracing.p_e_c_b_l == true && const_var.LNTCrossBracing["left"] != undefined && const_var.LNTCrossBracing["left"]["End Cross Bracing"] != undefined) {
				extraItems["left"].push(const_var.LNTCrossBracing["left"]["End Cross Bracing"]);
			}
			if (params.added_building_bracing.p_e_c_b_r == true && const_var.LNTCrossBracing["right"] != undefined && const_var.LNTCrossBracing["right"]["End Cross Bracing"] != undefined) {
				extraItems["right"].push(const_var.LNTCrossBracing["right"]["End Cross Bracing"]);
			}
			if (params.added_building_bracing.p_e_c_b_f == true && const_var.LNTCrossBracing["front"] != undefined && const_var.LNTCrossBracing["front"]["End Cross Bracing"] != undefined) {
				extraItems["front"].push(const_var.LNTCrossBracing["front"]["End Cross Bracing"]);
			}
			if (params.added_building_bracing.p_e_c_b_b == true && const_var.LNTCrossBracing["back"] != undefined && const_var.LNTCrossBracing["back"]["End Cross Bracing"] != undefined) {
				extraItems["back"].push(const_var.LNTCrossBracing["back"]["End Cross Bracing"]);
			}
		}
		const SideResult = handleSidePanelEndData({
			data,
			params,
			const_var,
			isLean
		});

		data = SideResult.data;
		heightFullData = SideResult?.heightFullData;
		let LeftWallSidePrice = data.side;
		if (params.singleSlope == true) {
			LeftWallSidePrice = data.side_slope_height != undefined && data.side_slope_height.length > 0 ? data.side_slope_height : data.side;
		}
		let connection_feesCost = 0;
		let connection_feesEnd = 0;
		if (const_var.leanGetDataFront != "" && const_var.leanGetDataFront != undefined && const_var.leanGetDataFront.connection_fees.length == 0) {
			const_var.leanGetDataFront.connection_fees = [];
			const_var.leanGetDataFront.connection_fees.push({ cost: 0, end_cost: 0 });
		}
		if (const_var.leanGetDataBack != "" && const_var.leanGetDataBack != undefined && const_var.leanGetDataBack.connection_fees.length == 0) {
			const_var.leanGetDataBack.connection_fees = [];
			const_var.leanGetDataBack.connection_fees.push({ cost: 0, end_cost: 0 });
		}
		const result = handleConnectionFeesCalculation({
			data,
			params,
			const_var,
			a,
			connection_feesCost,
			connection_feesEnd
		});

		a = result.a;
		connection_feesCost = result.connection_feesCost;
		connection_feesEnd = result.connection_feesEnd;
		post_data["building"] = { ...a, ...b };
		t_c = 0;
		var vertiP = 0;
		var vertiP2 = 0;
		var utilityLen = params.p_u_c == true ? Number(params.p_u_t) : params.p_d;
		let endCostV3_front =
			(params.cB_addStorage_check_left == true || params.cB_addStorage_check_right == true) && data?.side_combo_v3.length > 0 && params.p_f_w != "Close" && data?.end_combo_v3.length > 0
				? data?.end_combo_v3[0]
				: data?.end[0];
		let endCostV3_back =
			(params.cB_addStorage_check_left == true || params.cB_addStorage_check_right == true) && data?.side_combo_v3.length > 0 && params.p_b_w != "Close" && data?.end_combo_v3.length > 0
				? data?.end_combo_v3[0]
				: data?.end[0];
		const roofResult = handleRoofBaseCalculation({
			data,
			params,
			const_var,
			post_data,
			t_c
		});

		t_c = roofResult.t_c;
		post_data = roofResult.post_data;
		CalCulateRoofBasePrice = roofResult.CalCulateRoofBasePrice;

		if (params.cupola) {
			let cupolaPrice = 0;
			const_var.cupolaEntries.length > 0 &&
				const_var.cupolaEntries.map((cupola) => {
					cupolaPrice = parseFloat(cupolaPrice) + parseFloat(cupola.cupola_price);
				});
			post_data["building"].cupola_obj = const_var.cupolaEntries;
			post_data["building"]["cupolaEntries"] = const_var.cupolaEntries;
			t_c = parseFloat(t_c) + parseFloat(cupolaPrice);
		}

		if (post_data["building"].connection_fee_side != undefined) {
			t_c = parseFloat(t_c) + parseFloat(post_data["building"].connection_fee_side);
		}
		if (post_data["building"].connection_fee_end != undefined) {
			t_c = parseFloat(t_c) + parseFloat(post_data["building"].connection_fee_end);
		}

		if (params.add_left_front_lean_porch == true && const_var.leanGetDataLeft != "" && const_var.leanGetDataLeft.connection_fees.length > 0) {
			post_data["building"].connection_fee_left_front =
				const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed != true ? const_var.UpdatedPriceData?.connection_fee_left_front : const_var.leanGetDataLeft.connection_fees[0].wrap_around_cost;

			if (post_data["building"].connection_fee_left_front != undefined) {
				t_c = parseFloat(t_c) + parseFloat(post_data["building"].connection_fee_left_front);
			}
		}
		if (params.add_right_front_lean_porch == true && const_var.leanGetDataRight != "" && const_var.leanGetDataRight.connection_fees.length > 0) {
			post_data["building"].connection_fee_right_front =
				const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed != true ? const_var.UpdatedPriceData?.connection_fee_right_front : const_var.leanGetDataRight.connection_fees[0].wrap_around_cost;

			if (post_data["building"].connection_fee_right_front != undefined) {
				t_c = parseFloat(t_c) + parseFloat(post_data["building"].connection_fee_right_front);
			}
		}
		if (params.add_right_back_lean_porch == true && const_var.leanGetDataRight != "" && const_var.leanGetDataRight.connection_fees.length > 0) {
			post_data["building"].connection_fee_right_back =
				const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed != true ? const_var.UpdatedPriceData?.connection_fee_right_back : const_var.leanGetDataRight.connection_fees[0].wrap_around_cost;

			if (post_data["building"].connection_fee_right_back != undefined) {
				t_c = parseFloat(t_c) + parseFloat(post_data["building"].connection_fee_right_back);
			}
		}
		if (params.add_left_back_lean_porch == true && const_var.leanGetDataLeft != "" && const_var.leanGetDataLeft.connection_fees.length > 0) {
			post_data["building"].connection_fee_left_back =
				const_var.UpdatedPriceData.left_back_wrap_connection_fee_changed != true ? const_var.UpdatedPriceData?.connection_fee_left_back : const_var.leanGetDataLeft.connection_fees[0].wrap_around_cost;
			if (post_data["building"].connection_fee_left_back != undefined) {
				t_c = parseFloat(t_c) + parseFloat(post_data["building"].connection_fee_left_back);
			}
		}

		/******** CENTER BUILDING WALL PRICE CALCULATION -START***********/
		const WallPriceresult = calculateWalls({
			params,
			data,
			const_var,
			UpdatePriceRecord,
			post_data,
			t_c,
			CalCulateRoofEndClosePrice,
			LeftWallSidePrice,
			endCostV3_front,
			endCostV3_back,
			utlis,
			vertiP2,
			vertiP,
			CalCulateRoofEndGablePrice,
			convertToTwoDecimalNumber
		});

		t_c = WallPriceresult.t_c;
		CalCulateRoofEndClosePrice = WallPriceresult.CalCulateRoofEndClosePrice;
		post_data = WallPriceresult.post_data;

		/************* CENTER BUILDING WALL PRICE CALCULATION -END **************/

		if (params.p_c_p_l == true) {
			post_data["building"].left_wall_cutpanel = true;

			if (params.p_l_w == "Open" && params.p_c_p_l == true) {
				post_data["building"].left_wall_price =
					UpdatePriceRecord == true && const_var.UpdatedPriceData.left_wall_cut_panel_price_changed != true
						? utlis.convertToTwoDecimalNumber(const_var.UpdatedPriceData.left_wall_price)
						: utlis.convertToTwoDecimalNumber(data.panel[0].cut_panel_cost);
				t_c = parseFloat(t_c) + parseFloat(post_data["building"].left_wall_price);
			}
		}

		if (params.p_c_p_r == true) {
			post_data["building"].right_wall_cutpanel = true;
			if (params.p_r_w == "Open") {
				post_data["building"].right_wall_price =
					UpdatePriceRecord == true && const_var.UpdatedPriceData.right_wall_cut_panel_price_changed != true
						? utlis.convertToTwoDecimalNumber(const_var.UpdatedPriceData.right_wall_price)
						: utlis.convertToTwoDecimalNumber(data.panel[0].cut_panel_cost);
				t_c = parseFloat(t_c) + parseFloat(post_data["building"].right_wall_price);
			}
		}

		/************************ CENTER WALL - STORAGE PRICE CALCULATION - START */
		if (params.p_u_c == true && data.utility_side?.length > 0) {
			const endStorageValue = endStoragePriceCalculation(data, post_data, UpdatePriceRecord);
			CalCulateRoofUtilityEndPrice = endStorageValue;
			t_c += endStorageValue;
		} else if ((params.cB_addStorage_check_left == true || params.cB_addStorage_check_right == true) && data.side_combo_v3.length > 0) {
			const sideStoragePrice = leftRightStoragePriceCalculation(data, post_data, UpdatePriceRecord);
			CalCulateRoofUtilityEndPrice = sideStoragePrice;
			t_c += sideStoragePrice;
		} else {
			post_data["building"].has_utility = false;
			post_data["building"].utility_price = 0;
		}

		/************************ CENTER WALL - STORAGE PRICE CALCULATION - END */

		if (params.isBreezeway && params.cB_addStorage_check_front && data.front_utility_side && data.front_utility_side.length > 0) {
			post_data["building"].utility_front_price =
				UpdatePriceRecord == true && const_var.UpdatedPriceData.front_utility_price_changed != true
					? const_var.UpdatedPriceData.utility_front_price
					: params.p_v_w == true
						? data.front_utility_side[0].vertical_side_cost * 2 + data.end[0].vertical_ends_cost * 2 + data.front_utility_side[0].side_close_cost * 2 + data.end[0].end_close_cost * 2
						: data.front_utility_side[0].side_close_cost * 2 + data.end[0].end_close_cost * 2;
			t_c = parseFloat(t_c) + parseFloat(post_data["building"].utility_front_price);
			post_data["building"].utility_front_length = params.cB_addStorage_front;
			post_data["building"].has_utility_front = true;
			post_data["building"].utility_front_name = "front";
			post_data["building"].utility_front_vertical = params.p_v_w ? true : false;
			post_data["building"].utility_front_on_centers = const_var.DistanceArr[params.p_b_t][params.p_r_s] == undefined ? 5 : const_var.DistanceArr[params.p_b_t][params.p_r_s];
			CalCulateRoofUtilityEndPrice = parseFloat(CalCulateRoofUtilityEndPrice) + parseFloat(post_data["building"].utility_front_price);
		} else {
			post_data["building"].has_utility_front = false;
			post_data["building"].utility_front_price = 0;
		}
		if (params.isBreezeway) {
			post_data["building"].breezeway_length = const_var.breezewayLength;
		}
		// Start  roof pitch price calculation
		({ post_data, t_c } = calculateRoofPitchPrice({
			params,
			const_var,
			post_data,
			t_c,
			UpdatePriceRecord,
			CalCulateRoofBasePrice,
			CalCulateRoofUtilityEndPrice,
			CalCulateRoofEndClosePrice,
			CalCulateRoofEndGablePrice,
			convertToTwoDecimalNumber
		}));
		//   End roof pitch price calculation

		// Start Legs Price Calculation
		t_c = calculateLegsPrice({
			post_data,
			params,
			const_var,
			heightFullData,
			UpdatePriceRecord,
			t_c
		});

		if (const_var.b_o_J_1[params.p_b_t].includes("Free Standing Lean-to")) {
			post_data["building"].freestanding_height =
				const_var.c_m_a[params.p_b_t] != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0
					? Math.floor(params.p_h - (params.p_w * params.p_r_p) / 12)
					: Math.round(params.p_h - (params.p_w * params.p_r_p) / 12);
		}

		t_c = parseFloat(t_c_b) + parseFloat(t_c);

		// ########################## calculate price of siding material starts from here ##########################
		let selSidingObj = const_var.selSidingObj;
		post_data["building"].siding_name = const_var.selSidingOption;
		post_data["building"].siding_obj = const_var.selSidingObj;
		if (const_var.mainSidingOptions && const_var.mainSidingOptions.length > 0 && selSidingObj && selSidingObj.price_type == "%" && selSidingObj.cost != 0 && selSidingObj.name != "metal") {
			let splitVal = selSidingObj.price_of != undefined && selSidingObj.price_of.length > 0 ? selSidingObj.price_of : 0;
			let splval = 0;

			if (splitVal != 0) {
				post_data["building"].leanto = const_var.leanto;
				let leantoHeightPrice = 0;
				let leantoBasicPrice = 0;
				let leanToWallPrice = 0;

				let leanToPriceCalc = {
					totalLeanPrice: 0,
					totalBasePrice: 0,
					totalWallPrice: 0,
					totalHeightPrice: 0,
					totalDimension: 0,
					totalSideWallPrice: 0,
					totalEndWallPrice: 0
				};
				if (post_data["building"].leanto != undefined && post_data["building"].leanto.length > 0) {
					for (var i = 0; i <= post_data["building"].leanto.length - 1; i++) {
						if (post_data["building"].leanto[i].front_wall == "close" && post_data["building"].leanto[i].front_wall_price != undefined) {
							leanToWallPrice = parseFloat(leanToWallPrice) + post_data["building"].leanto[i].front_wall_price;
						}
						if (post_data["building"].leanto[i].back_wall == "close" && post_data["building"].leanto[i].back_wall_price != undefined) {
							leanToWallPrice = parseFloat(leanToWallPrice) + post_data["building"].leanto[i].back_wall_price;
						}
						if (post_data["building"].leanto[i].side_wall == "close" && post_data["building"].leanto[i].side_wall_price != undefined) {
							leanToWallPrice = parseFloat(leanToWallPrice) + post_data["building"].leanto[i].side_wall_price;
						}

						if (post_data["building"].leanto[i].height_price != undefined) {
							leantoHeightPrice = parseFloat(leantoHeightPrice) + post_data["building"].leanto[i].height_price;
						}
						if (post_data["building"].leanto[i].basic_price != undefined) {
							leantoBasicPrice = parseFloat(leantoBasicPrice) + post_data["building"].leanto[i].basic_price;
						}

						leanToPriceCalc.totalLeanPrice =
							leanToPriceCalc.totalLeanPrice == undefined
								? parseFloat(post_data["building"].leanto[i].t_c_b)
								: parseFloat(leanToPriceCalc.totalLeanPrice) + parseFloat(post_data["building"].leanto[i].t_c_b);

						if (post_data["building"].leanto[i].front_wall != "open" || post_data["building"].leanto[i].back_wall != "open" || post_data["building"].leanto[i].side_wall != "open") {
							leanToPriceCalc.totalBasePrice =
								leanToPriceCalc.totalBasePrice == undefined
									? parseFloat(post_data["building"].leanto[i].basic_price)
									: parseFloat(leanToPriceCalc.totalBasePrice) + parseFloat(post_data["building"].leanto[i].basic_price);
						}
						leanToPriceCalc.totalWallPrice =
							leanToPriceCalc.totalWallPrice == undefined
								? parseFloat(post_data["building"].leanto[i].front_wall_price) + parseFloat(post_data["building"].leanto[i].back_wall_price) + parseFloat(post_data["building"].leanto[i].side_wall_price)
								: parseFloat(leanToPriceCalc.totalWallPrice) +
									parseFloat(post_data["building"].leanto[i].front_wall_price) +
									parseFloat(post_data["building"].leanto[i].back_wall_price) +
									parseFloat(post_data["building"].leanto[i].side_wall_price);

						leanToPriceCalc.totalSideWallPrice =
							leanToPriceCalc.totalSideWallPrice == undefined
								? parseFloat(post_data["building"].leanto[i].side_wall_price)
								: parseFloat(leanToPriceCalc.totalSideWallPrice) + parseFloat(post_data["building"].leanto[i].side_wall_price);
						leanToPriceCalc.totalEndWallPrice =
							leanToPriceCalc.totalEndWallPrice == undefined
								? parseFloat(post_data["building"].leanto[i].front_wall_price) + parseFloat(post_data["building"].leanto[i].back_wall_price)
								: parseFloat(leanToPriceCalc.totalEndWallPrice) + parseFloat(post_data["building"].leanto[i].front_wall_price) + parseFloat(post_data["building"].leanto[i].back_wall_price);

						if (post_data["building"].leanto[i].utility_price != undefined && post_data["building"].leanto[i].utility_price != 0) {
							leanToPriceCalc.totalWallPrice = parseFloat(leanToPriceCalc.totalWallPrice) + parseFloat(post_data["building"].leanto[i].utility_price);
						}
						leanToPriceCalc.totalHeightPrice =
							leanToPriceCalc.totalHeightPrice == undefined
								? parseFloat(post_data["building"].leanto[i].height_price)
								: parseFloat(leanToPriceCalc.totalHeightPrice) + parseFloat(post_data["building"].leanto[i].height_price);
						leanToPriceCalc.totalDimension =
							leanToPriceCalc.totalDimension != undefined
								? parseFloat(leanToPriceCalc.totalDimension) + parseFloat(post_data["building"].leanto[i].width * post_data["building"].leanto[i].total_length)
								: parseFloat(post_data["building"].leanto[i].width * post_data["building"].leanto[i].total_length);
					}
				} else {
					leanToPriceCalc.totalLeanPrice = 0;
					leanToPriceCalc.totalBasePrice = 0;
					leanToPriceCalc.totalWallPrice = 0;
					leanToPriceCalc.totalHeightPrice = 0;
					leanToPriceCalc.totalDimension = 0;
					leanToPriceCalc.totalSideWallPrice = 0;
					leanToPriceCalc.totalEndWallPrice = 0;
				}
				if (splitVal.includes("base_price") != false) {
					splval = parseFloat(splval) + parseFloat(post_data["building"].roof_style_price) + parseFloat(leanToPriceCalc.totalBasePrice != undefined ? leanToPriceCalc.totalBasePrice : 0);
				}
				if (splitVal.includes("wall_price") != false) {
					if (params.p_u_c == true || params.cB_addStorage_check_left == true || params.cB_addStorage_check_right == true) {
						splval =
							parseFloat(splval) +
							parseFloat(post_data["building"].utility_price) +
							parseFloat(post_data["building"].front_wall_price) +
							parseFloat(post_data["building"].left_wall_price) +
							parseFloat(post_data["building"].right_wall_price) +
							parseFloat(post_data["building"].back_wall_price) +
							parseFloat(leanToPriceCalc.totalWallPrice);
					} else {
						splval =
							parseFloat(splval) +
							parseFloat(post_data["building"].front_wall_price) +
							parseFloat(post_data["building"].left_wall_price) +
							parseFloat(post_data["building"].right_wall_price) +
							parseFloat(post_data["building"].back_wall_price) +
							parseFloat(leanToPriceCalc.totalWallPrice);
					}
					if (post_data["building"].utility_front_price != undefined && params.isBreezeway && params.cB_addStorage_check_front) {
						splval = parseFloat(splval) + parseFloat(post_data["building"].utility_front_price);
					}
				}
				if (splitVal.includes("height_price") != false) {
					splval = parseFloat(splval) + parseFloat(post_data["building"].height_price) + parseFloat(leanToPriceCalc.totalHeightPrice);
				}
			}

			let finalCost = (splval * selSidingObj.cost) / 100;
			let exactCost /* additionalFeatureCost */ = finalCost % 1 == 0 ? finalCost : finalCost.toFixed(2);
			if (
				parseFloat(const_var.wallsData["center"].closedEndWalls) != 0 ||
				parseFloat(const_var.wallsData["leftLean"].closedEndWalls) != 0 ||
				parseFloat(const_var.wallsData["rightLean"].closedEndWalls) != 0 ||
				parseFloat(const_var.wallsData["frontLean"].closedEndWalls) != 0 ||
				parseFloat(const_var.wallsData["backLean"].closedEndWalls) != 0 ||
				parseFloat(const_var.wallsData["center"].closedSideWalls) != 0 ||
				parseFloat(const_var.wallsData["leftLean"].closedSideWalls) != 0 ||
				parseFloat(const_var.wallsData["rightLean"].closedSideWalls) != 0 ||
				parseFloat(const_var.wallsData["frontLean"].closedSideWalls) != 0 ||
				parseFloat(const_var.wallsData["backLean"].closedSideWalls) != 0
			) {
				if ((splitVal.includes("full_building_price") != true && splitVal.includes("sub_total_price") != true) || params.p_c_p_r == true || params.p_c_p_l == true) {
					post_data["building"].siding_material_price =
						UpdatePriceRecord == true && const_var.check_siding_material_price == true ? const_var.UpdatedPriceData.siding_material_price : parseFloat(exactCost).toFixed(2);
					t_c = parseFloat(t_c) + parseFloat(post_data["building"].siding_material_price);
				} else {
					post_data["building"].siding_material_price = 0;
				}
			} else {
				post_data["building"].siding_material_price = 0;
			}
		} else {
			const_var.check_siding_material_price = false;
			post_data["building"].siding_material_price = 0;
		}
		// ########################## calculate price of siding material starts end here ##########################

		let editCheckForHeritage =
			const_var.crmSetting.is_Edit == true && params.m_s_n == 153 && (params.p_r_s == 1 || params.p_r_s == 2) && const_var.editAPIDataByResponse != undefined && const_var.editAPIDataByResponse.data != undefined;

		let heritageNoInsulationCaseCenterBuilding = heritageNoInsulation(params, editCheckForHeritage, false, "center");
		let heritageNoInsulationCaseAllBuilding = heritageNoInsulation(params, editCheckForHeritage, false, "all");

		t_c = handleInsulationCalculation({
			const_var,
			params,
			utlis,
			post_data,
			UpdatePriceRecord,
			convertToTwoDecimalNumber,
			t_c,
			isLean,
			heritageNoInsulationCaseCenterBuilding,
			heritageNoInsulationCaseAllBuilding
		});

		if (heritageNoInsulationCaseAllBuilding == true) {
			if (post_data["building"].leanto == undefined) {
				post_data["building"].leanto = const_var.leanto;
			}
			if (post_data["building"].leanto != undefined && post_data["building"].leanto.length > 0) {
				for (var i = 0; i <= post_data["building"].leanto.length - 1; i++) {
					if (post_data["building"].leanto[i].insulation_type != undefined) {
						delete post_data["building"].leanto[i].insulation;
						delete post_data["building"].leanto[i].insulation_type;
					}
				}
			}
		}

		if (!const_var.isInsulaltionForOldQuotes) post_data["building"].isInsulaltionForOldQuotes = false;
		if (const_var.Componentinputs != undefined && const_var.Componentinputs.length > 0) {
			const_var.Componentinputs.map((val, index) => {
				if (val != null) {
					if (val.additional_name != null && val.additional_quantity != null) {
						if (val.additional_quantity != 0) {
							const updatedPriceElements = const_var.isLTBuilding ? const_var.lNTBuildingData.updatePriceDataElements.centerBuilding : const_var.UpdatedPriceData.elements;
							extra_items.push({
								item_name: val.additional_name,
								other_item_name: "add_extra_components",
								item_quantity: parseInt(val.additional_quantity),
								item_price:
									UpdatePriceRecord == true && updatedPriceElements != undefined && updatedPriceElements[val.additional_name.toString()] != undefined
										? updatedPriceElements[val.additional_name.toString()]?.item_price
										: 0
							});
							t_c =
								UpdatePriceRecord == true && updatedPriceElements != undefined && updatedPriceElements[val.additional_name.toString()] != undefined
									? parseFloat(t_c) + parseFloat(updatedPriceElements[val.additional_name.toString()]?.item_price)
									: parseFloat(t_c) + 0;
						}
					}
				}
			});
			post_data["building"].Componentinputs = const_var.Componentinputs;
		}

		let buildingStructureDoc = const_var.a_p_d_a?.building_structure?.[0]?.distance_on_center ? const_var.a_p_d_a?.building_structure?.[0]?.distance_on_center : const_var?.defaultDistanceOnCenter;

		t_c += getPriceForExtraOptions(const_var, params, post_data, extraItems, extra_items, UpdatePriceRecord, t_c);
		//  start Jtrim calculation
		if (params.p_j_t == true && cbData.jtrim.length > 0) {
			t_c = jtrimCalculation({
				params,
				cbData,
				const_var,
				extra_items,
				UpdatePriceRecord,
				convertToTwoDecimalNumber,
				t_c
			});
		}
		if (params.p_j_t_end == true && cbData.jtrim.length > 0) {
			t_c = endJtrimCalculation({
				params,
				cbData,
				const_var,
				extra_items,
				UpdatePriceRecord,
				convertToTwoDecimalNumber,
				t_c
			});
		}
		// End J-trim calculation
		let updatedPriceDataCB = const_var.UpdatedPriceData["elements"];
		if (const_var.isLTBuilding && const_var.lNTBuildingData) {
			updatedPriceDataCB = const_var.lNTBuildingData["updatePriceDataElements"]["centerBuilding"];
		}

		// ########################## calculate price of wainscot siding starts here ##########################

		t_c = calculateWainscotPrice({
			post_data,
			t_c,
			data,
			UpdatePriceRecord,
			utlis
		});
		//  ########################## calculate price of wainscot siding ends here ##########################

		/*******  DOOR PRICE CALCULATION ******/
		if (const_var.entry_points != undefined && const_var.entry_points.length > 0) {
			let dataPriceC = 0;
			let dataPriceCoverHead = 0;
			const_var.entry_points.map((value, key) => {
				dataPriceCoverHead = 0;
				dataPriceC = parseFloat(dataPriceC) + parseFloat(value.entry_price);
				dataPriceCoverHead = parseFloat(dataPriceCoverHead) + parseFloat(value.entry_price);
				if (value.entry_header_seal == true) {
					dataPriceC = value.entry_header_seal_price != undefined ? parseFloat(dataPriceC) + parseFloat(value.entry_header_seal_price) : parseFloat(dataPriceC) + parseFloat(0);
					dataPriceCoverHead = value.entry_header_seal_price != undefined ? parseFloat(dataPriceCoverHead) + parseFloat(value.entry_header_seal_price) : parseFloat(dataPriceCoverHead) + parseFloat(0);
				} else {
					dataPriceC = parseFloat(dataPriceC) + parseFloat(0);
					dataPriceCoverHead = parseFloat(dataPriceCoverHead) + parseFloat(0);
				}

				if (value.entry_trim_kit == true) {
					dataPriceC = value.entry_trim_kit_price != undefined ? parseFloat(dataPriceC) + parseFloat(value.entry_trim_kit_price) : parseFloat(dataPriceC) + parseFloat(0);
					dataPriceCoverHead = value.entry_trim_kit_price != undefined ? parseFloat(dataPriceCoverHead) + parseFloat(value.entry_trim_kit_price) : parseFloat(dataPriceCoverHead) + parseFloat(0);
				} else {
					dataPriceC = parseFloat(dataPriceC) + parseFloat(0);
					dataPriceCoverHead = parseFloat(dataPriceCoverHead) + parseFloat(0);
				}

				if (value.entry_chain_hoist == true) {
					dataPriceC = value.entry_chain_hoist_price != undefined ? parseFloat(dataPriceC) + parseFloat(value.entry_chain_hoist_price) : parseFloat(dataPriceC) + parseFloat(0);
					dataPriceCoverHead = value.entry_chain_hoist_price != undefined ? parseFloat(dataPriceCoverHead) + parseFloat(value.entry_chain_hoist_price) : parseFloat(dataPriceCoverHead) + parseFloat(0);
				} else {
					dataPriceC = parseFloat(dataPriceC) + parseFloat(0);
					dataPriceCoverHead = parseFloat(dataPriceCoverHead) + parseFloat(0);
				}
				if (value.threshold == true && params.m_s_n == 9) {
					dataPriceC = value.threshold_price != undefined ? parseFloat(dataPriceC) + parseFloat(value.threshold_price) : parseFloat(dataPriceC) + parseFloat(0);
					dataPriceCoverHead = value.threshold_price != undefined ? parseFloat(dataPriceCoverHead) + parseFloat(value.threshold_price) : parseFloat(dataPriceCoverHead) + parseFloat(0);
				}

				Object.keys(value).map((e) => {
					if (e.includes("add_on_options") && !e.includes("_price")) {
						if (value[e] === true) {
							dataPriceC = value[e + "_price"] != undefined ? parseFloat(dataPriceC) + parseFloat(value[e + "_price"]) : parseFloat(dataPriceC) + parseFloat(0);
							dataPriceCoverHead =
								value[e + "_price"] != undefined && e != "entry_frame_out_add_on_options"
									? parseFloat(dataPriceCoverHead) + parseFloat(value[e + "_price"])
									: parseFloat(dataPriceCoverHead) + parseFloat(0);
						} else {
							dataPriceC = parseFloat(dataPriceC) + parseFloat(0);
							dataPriceCoverHead = parseFloat(dataPriceCoverHead) + parseFloat(0);
						}
					}
				});

				if (value.component_name.includes("overhead_door_door")) {
					let doorname = value.component_name.replace(/\d/g, "").replace("overhead_door_door_", "");
					if (value.entry_size.door_add_ons && value.entry_size.door_add_ons.length) {
						let woption = value.entry_size.door_add_ons.find((e) => e.door == "window_option");
						let door = woption?.category?.find((e) => e.category.replace(" ", "_").toLowerCase() == doorname);
						if (door) {
							dataPriceC = parseFloat(dataPriceC) + parseFloat(door.cost);
							dataPriceCoverHead = parseFloat(dataPriceCoverHead) + parseFloat(door.cost);
						}
					}
				}

				if (value.entry_motor == true) {
					dataPriceC = value.entry_motor_price != undefined ? parseFloat(dataPriceC) + parseFloat(value.entry_motor_price) : parseFloat(dataPriceC) + parseFloat(0);
					dataPriceCoverHead = value.entry_motor_price != undefined ? parseFloat(dataPriceCoverHead) + parseFloat(value.entry_motor_price) : parseFloat(dataPriceCoverHead) + parseFloat(0);
				} else {
					dataPriceC = parseFloat(dataPriceC) + parseFloat(0);
					dataPriceCoverHead = parseFloat(dataPriceCoverHead) + parseFloat(0);
				}

				if (value.entry_automatic_openers == true) {
					dataPriceC = value.entry_automatic_openers_price != undefined ? parseFloat(dataPriceC) + parseFloat(value.entry_automatic_openers_price) : parseFloat(dataPriceC) + parseFloat(0);
					dataPriceCoverHead =
						value.entry_automatic_openers_price != undefined ? parseFloat(dataPriceCoverHead) + parseFloat(value.entry_automatic_openers_price) : parseFloat(dataPriceCoverHead) + parseFloat(0);
				} else {
					dataPriceC = parseFloat(dataPriceC) + parseFloat(0);
					dataPriceCoverHead = parseFloat(dataPriceCoverHead) + parseFloat(0);
				}
				let currentObjData = "";
				if (
					const_var.newComponentArray[value.parent_array_key][value.child_array_key] != undefined &&
					const_var.newComponentArray[value.parent_array_key][value.child_array_key][value.nested_array_key] != undefined
				) {
					currentObjData =
						const_var.newComponentArray[value.parent_array_key][value.child_array_key][value.nested_array_key]["Size"][value.name] != undefined
							? const_var.newComponentArray[value.parent_array_key][value.child_array_key][value.nested_array_key]["Size"][value.name]
							: "";
				}
				if (value.installation_is_end_wall != undefined && currentObjData != "") {
					if (currentObjData != undefined && currentObjData.installation_is_end_wall == undefined) {
						delete value.installation_is_end_wall;
						delete value.installation_end_wall_fee;
					}
				}
				if (value.installation_is_side_wall != undefined && currentObjData != "") {
					if (currentObjData != undefined && currentObjData.installation_is_side_wall == undefined) {
						delete value.installation_is_side_wall;
						delete value.installation_side_wall_fee;
					}
				}
				if (value.installation_is_end_wall != undefined && value.installation_is_end_wall == "yes") {
					dataPriceC = parseFloat(dataPriceC) + parseFloat(value.installation_end_wall_fee);
					dataPriceCoverHead = parseFloat(dataPriceCoverHead) + parseFloat(value.installation_end_wall_fee);
				} else {
					dataPriceC = parseFloat(dataPriceC) + parseFloat(0);
					dataPriceCoverHead = parseFloat(dataPriceCoverHead) + parseFloat(0);
				}

				if (value.installation_is_side_wall != undefined && value.installation_is_side_wall == "yes") {
					dataPriceC = parseFloat(dataPriceC) + parseFloat(value.installation_side_wall_fee);
					dataPriceCoverHead = parseFloat(dataPriceCoverHead) + parseFloat(value.installation_side_wall_fee);
				} else {
					dataPriceC = parseFloat(dataPriceC) + parseFloat(0);
					dataPriceCoverHead = parseFloat(dataPriceCoverHead) + parseFloat(0);
				}
				if (value.parent_array_key != "Garage_Frameout") {
					dataPriceC = parseFloat(dataPriceC) + parseFloat(value.entry_garageDoor_color_price == undefined ? 0 : Number(value.entry_garageDoor_color_price));
					dataPriceCoverHead = parseFloat(dataPriceCoverHead) + parseFloat(value.entry_garageDoor_color_price == undefined ? 0 : Number(value.entry_garageDoor_color_price));
				}
				const_var.entry_points[key].overheadDoorSum = parseFloat(dataPriceCoverHead);
			});
			t_c = parseFloat(t_c) + parseFloat(dataPriceC);
		} else {
			t_c = parseFloat(t_c) + parseFloat(0);
		}

		/*******  DOOR PRICE CALCULATION ******/
		if (params.m_s_n == 33 && post_data["building"] && const_var.installationsurfaceChange == true) {
			let checkOverHeadDoor;
			if (const_var.entry_points?.length > 0) checkOverHeadDoor = const_var.entry_points.find((s) => s.child_array_key.includes("overhead_door_door"));
			if (checkOverHeadDoor !== undefined) {
				post_data["building"].installation_surface = "concrete";
				params.p_i_s = "1";
			}
		}
		if (const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n] != undefined && const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n].length > 0) {
			let AddPriceCalculation = false;
			for (var i = 0; i < const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n].length; i++) {
				if (
					const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].category != undefined ||
					const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].category != null
				) {
					if (const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].component == "garage_doors") {
						if (const_var.entry_points.length > 0) {
							const sumOfEvens = const_var.entry_points.reduce((accumulator, currentValue) => {
								if (currentValue.overheadDoorSum != undefined && currentValue.child_array_key === const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].category) {
									if (
										const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].sub_category == null ||
										(const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].sub_category != null &&
											const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].sub_category.length > 0 &&
											currentValue.nested_array_key != undefined &&
											const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].sub_category.indexOf(currentValue.nested_array_key) != -1)
									) {
										return currentValue.parent_array_key != "Garage_Frameout" ? parseFloat(accumulator) + parseFloat(currentValue.overheadDoorSum || 0) : parseFloat(accumulator) + 0;
									} else {
										return parseFloat(accumulator);
									}
								} else {
									return parseFloat(accumulator);
								}
							}, 0);
							if (sumOfEvens != 0) {
								if (
									sumOfEvens >= parseInt(const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].from) &&
									sumOfEvens <= parseInt(const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].to)
								) {
									const_var.UpdatedPriceData.custom_overhead_down_payment_rate = undefined;
									t_c = parseFloat(t_c) - parseFloat(sumOfEvens);
									AddPriceCalculation = true;
								} else {
									const_var.UpdatedPriceData.custom_overhead_down_payment_rate = undefined;
								}
							}
						}
					}
				}
			}
		}
		t_c = params.p_t_u != 0 ? parseFloat(t_c) + Number(params.p_t_u) : parseFloat(t_c) + parseFloat(0);

		let calCulatePriceByDis = "";

		post_data["building"].leanto = const_var.leanto;
		var leantoPriceCalculation = {};
		let leanCertPrice = 0;
		let leanToTotalInsultaionPrice = 0;
		let checkInsulationArray = [];
		/********************************************New Logic to calculate surcharge for mayberry start****************************************/
		if (
			surchargeArray &&
			post_data.building.insulation &&
			surchargeArray?.filter((item) => item.percentage_of == "insulation")?.length > 0 &&
			commissionArray?.filter((item) => item.component == "insulation")?.length > 0
		) {
			let componentSurcharge = MayberrySurchargeCal(
				"insulation",
				post_data.building,
				surchargeArray?.filter((item) => item.percentage_of == "insulation"),
				commissionArray?.filter((item) => item.component == "insulation")
			);
			let insulationObjs = extractDataFromInsulation(const_var.thirdPartyComponent.surcharge.insulation);
			let itemPriceAdded = insulationObjs?.reduce((sum, item) => sum + item.itemPrice, 0);
			const_var.newThirdPartySurcharge["insulation_price"] = parseFloat(componentSurcharge) + parseFloat(itemPriceAdded);
		}

		if (
			surchargeArray?.length > 0 &&
			const_var.entry_points?.length >= 0 &&
			surchargeArray?.filter((item) => item.percentage_of == "garage_doors")?.length > 0 &&
			commissionArray?.filter((item) => item.component == "garage_doors")?.length > 0
		) {
			let componentSurcharge = MayberrySurchargeCal(
				"garage_doors",
				const_var.entry_points,
				surchargeArray?.filter((item) => item.percentage_of == "garage_doors"),
				commissionArray.filter((item) => item.component == "garage_doors")
			);
			let componentObjs = utlis.extractDataFromInner(const_var.thirdPartyComponent.surcharge.garage);
			let itemPriceAdded = componentObjs?.reduce((sum, item) => sum + item.itemPrice, 0);
			const_var.newThirdPartySurcharge["door_price"] = parseFloat(componentSurcharge);
		}

		/********************************************New Logic to calculate surcharge for mayberry end****************************************/

		if (post_data.building.insulation && post_data.building.insulation != "none") {
			if (commissionArray?.filter((item) => item.component == "insulation")?.length > 0 && commissionArray?.filter((item) => item.component == "insulation")?.length > 0) {
				let componentCommissionPrice = MayberryCommissionCal(
					"insulation",
					post_data.building,
					commissionArray?.filter((item) => item.component == "insulation")
				);
			} else if (commissionArray?.filter((item) => item.component == "insulation")?.length == 0) {
				const_var.thirdPartyComponent.commissions.insulation = {};
				const_var.thirdPartyComponent.surcharge.insulation = {};
				const_var.thirdPartyComponent.tax.insulation = {};
			}

			if (const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n] != undefined && const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n].length > 0) {
				if (
					post_data["building"]?.insulation_type &&
					const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n].find((data) => data.category == post_data["building"]?.insulation_type?.insulation_id) != undefined
				) {
					checkInsulationArray.push(post_data["building"].insulation_type.insulation_id);
					params.selectedInsulationId = post_data["building"].insulation_type.insulation_id;
					leanToTotalInsultaionPrice = parseFloat(leanToTotalInsultaionPrice) + post_data["building"].insulation_price;
				}
			}
		}

		let WrapLength_for_liniear_feet_left = 0;
		let WrapLength_for_liniear_feet_right = 0;
		let WrapLength_for_liniear_feet_front = 0;
		let WrapLength_for_liniear_feet_back = 0;
		if (post_data["building"].leanto.length > 0) {
			for (var i = 0; i <= post_data["building"].leanto.length - 1; i++) {
				let porchLength = 0;
				post_data["building"].leanto[i].porch = undefined;
				if (post_data["building"].leanto[i].leanto_type == 1) {
					if (const_var.reinforcedtype["left"] == "reinforced") {
						post_data["building"].leanto[i].legstype = const_var.reinforcedtype["left"];
					}

					post_data["building"].leanto[i].alignment = const_var.TypeAlingnment[params.leantoAlignmentLeft];
					post_data["building"].leanto[i].position = params.lean_p_pos;
					post_data["building"].leanto[i].total_length = params.lean_p_d;
					const_var.lengthData.leftLean.porchLength = 0;
					if (params.add_left_back_lean_porch == true) {
						post_data["building"].leanto[i].porch = { type: "left", length: params.lean_p_d + params.leanB_p_w, cost: parseInt(post_data["building"].connection_fee_left_back), wrap_with: ["back"] };
						post_data["building"].leanto[i].total_length = params.lean_p_d + params.leanB_p_w;
						const_var.lengthData.leftLean.porchLength = params.leanB_p_w;
					}
					if (params.add_left_front_lean_porch == true) {
						post_data["building"].leanto[i].porch = { type: "left", length: params.lean_p_d + params.leanF_p_w, cost: parseInt(post_data["building"].connection_fee_left_front), wrap_with: ["front"] };
						post_data["building"].leanto[i].total_length = params.lean_p_d + params.leanF_p_w;
						const_var.lengthData.leftLean.porchLength = params.leanF_p_w;
					}
					if (params.add_left_back_lean_porch == true && params.add_left_front_lean_porch == true) {
						post_data["building"].leanto[i].porch = {
							type: "left",
							length: params.lean_p_d + params.leanB_p_w + params.leanF_p_w,
							cost: parseInt(post_data["building"].connection_fee_left_front) + parseInt(post_data["building"].connection_fee_left_back),
							wrap_with: ["front", "back"]
						};
						post_data["building"].leanto[i].total_length = params.lean_p_d + params.leanF_p_w + params.leanB_p_w;
						const_var.lengthData.leftLean.porchLength = params.leanF_p_w + params.leanB_p_w;
					}
				}
				if (post_data["building"].leanto[i].leanto_type == 2) {
					if (const_var.reinforcedtype["right"] == "reinforced") {
						post_data["building"].leanto[i].legstype = const_var.reinforcedtype["right"];
					}
					post_data["building"].leanto[i].alignment = const_var.TypeAlingnment[params.leantoAlignmentRight];
					post_data["building"].leanto[i].position = params.leanR_p_pos;
					post_data["building"].leanto[i].total_length = params.leanR_p_d;
					const_var.lengthData.rightLean.porchLength = 0;
					if (params.add_right_back_lean_porch == true) {
						post_data["building"].leanto[i].porch = { type: "right", length: params.leanR_p_d + params.leanB_p_w, cost: parseInt(post_data["building"].connection_fee_right_back), wrap_with: ["back"] };
						post_data["building"].leanto[i].total_length = params.leanR_p_d + params.leanB_p_w;
						const_var.lengthData.rightLean.porchLength = params.leanB_p_w;
					}
					if (params.add_right_front_lean_porch == true) {
						post_data["building"].leanto[i].porch = { type: "right", length: params.leanR_p_d + params.leanF_p_w, cost: parseInt(post_data["building"].connection_fee_right_front), wrap_with: ["front"] };
						post_data["building"].leanto[i].total_length = params.leanR_p_d + params.leanF_p_w;
						const_var.lengthData.rightLean.porchLength = params.leanF_p_w;
					}
					if (params.add_right_back_lean_porch == true && params.add_right_front_lean_porch == true) {
						post_data["building"].leanto[i].porch = {
							type: "right",
							length: params.leanR_p_d + params.leanB_p_w + params.leanF_p_w,
							cost: parseInt(post_data["building"].connection_fee_right_front) + parseInt(post_data["building"].connection_fee_right_back),
							wrap_with: ["front", "back"]
						};
						post_data["building"].leanto[i].total_length = params.leanR_p_d + params.leanF_p_w + params.leanB_p_w;
						const_var.lengthData.rightLean.porchLength = params.leanF_p_w + params.leanB_p_w;
					}
				}
				if (post_data["building"].leanto[i].leanto_type == 3) {
					if (const_var.reinforcedtype["front"] == "reinforced") {
						post_data["building"].leanto[i].legstype = const_var.reinforcedtype["front"];
					}
					post_data["building"].leanto[i].alignment = const_var.endLeanAlingnmentType[params.leantoAlignmentFront];
					post_data["building"].leanto[i].position = params.leanF_p_pos;
					post_data["building"].leanto[i].total_length = post_data["building"].leanto[i].length;
					if (post_data["building"].leanto[i].porch != undefined) {
						if (params.add_left_front_lean_porch == true) {
							post_data["building"].leanto[i].porch.wrap_with = ["left"];
						}
						if (params.add_right_front_lean_porch == true) {
							post_data["building"].leanto[i].porch.wrap_with = ["right"];
						}
						if (params.add_left_front_lean_porch == true && params.add_right_front_lean_porch == true) {
							post_data["building"].leanto[i].porch.wrap_with = ["left", "right"];
						}
					}
				}
				if (post_data["building"].leanto[i].leanto_type == 4) {
					if (const_var.reinforcedtype["back"] == "reinforced") {
						post_data["building"].leanto[i].legstype = const_var.reinforcedtype["back"];
					}
					post_data["building"].leanto[i].alignment = const_var.endLeanAlingnmentType[params.leantoAlignmentBack];
					post_data["building"].leanto[i].position = params.leanB_p_pos;
					post_data["building"].leanto[i].total_length = post_data["building"].leanto[i].length;
					if (post_data["building"].leanto[i].porch != undefined) {
						if (params.add_left_back_lean_porch == true) {
							post_data["building"].leanto[i].porch.wrap_with = ["left"];
						}
						if (params.add_right_back_lean_porch == true) {
							post_data["building"].leanto[i].porch.wrap_with = ["right"];
						}
						if (params.add_left_back_lean_porch == true && params.add_right_back_lean_porch == true) {
							post_data["building"].leanto[i].porch.wrap_with = ["left", "right"];
						}
					}
				}

				if (post_data["building"].leanto[i].leanto_type != 2 && post_data["building"].leanto[i].leanto_type != 1) {
					if (post_data["building"].leanto[i].porch != undefined) {
						post_data["building"].leanto[i].porch.cost = 0;
					}
				}

				leantoPriceCalculation.totalLeanPrice =
					leantoPriceCalculation.totalLeanPrice == undefined
						? parseFloat(post_data["building"].leanto[i].t_c_b)
						: parseFloat(leantoPriceCalculation.totalLeanPrice) + parseFloat(post_data["building"].leanto[i].t_c_b);
				leantoPriceCalculation.totalBasePrice =
					leantoPriceCalculation.totalBasePrice == undefined
						? parseFloat(post_data["building"].leanto[i].basic_price)
						: parseFloat(leantoPriceCalculation.totalBasePrice) + parseFloat(post_data["building"].leanto[i].basic_price);
				if (post_data["building"].leanto[i]?.leanto_style == "gable") {
					leantoPriceCalculation.totalWallPrice =
						leantoPriceCalculation.totalWallPrice == undefined
							? parseFloat(post_data["building"].leanto[i].front_wall_price) +
								parseFloat(post_data["building"].leanto[i].back_wall_price) +
								parseFloat(post_data["building"].leanto[i].side_wall_price) +
								parseFloat(post_data["building"].leanto[i].right_wall_price)
							: parseFloat(leantoPriceCalculation.totalWallPrice) +
								parseFloat(post_data["building"].leanto[i].front_wall_price) +
								parseFloat(post_data["building"].leanto[i].back_wall_price) +
								parseFloat(post_data["building"].leanto[i].side_wall_price) +
								parseFloat(post_data["building"].leanto[i].right_wall_price);
				} else {
					leantoPriceCalculation.totalWallPrice =
						leantoPriceCalculation.totalWallPrice == undefined
							? parseFloat(post_data["building"].leanto[i].front_wall_price) + parseFloat(post_data["building"].leanto[i].back_wall_price) + parseFloat(post_data["building"].leanto[i].side_wall_price)
							: parseFloat(leantoPriceCalculation.totalWallPrice) +
								parseFloat(post_data["building"].leanto[i].front_wall_price) +
								parseFloat(post_data["building"].leanto[i].back_wall_price) +
								parseFloat(post_data["building"].leanto[i].side_wall_price);
				}

				if (post_data["building"].leanto[i]?.leanto_style == "gable") {
					leantoPriceCalculation.totalSideWallPrice =
						leantoPriceCalculation.totalSideWallPrice == undefined
							? parseFloat(post_data["building"].leanto[i].side_wall_price) + parseFloat(post_data["building"].leanto[i].right_wall_price)
							: parseFloat(leantoPriceCalculation.totalSideWallPrice) + parseFloat(post_data["building"].leanto[i].side_wall_price) + parseFloat(post_data["building"].leanto[i].right_wall_price);
				} else {
					leantoPriceCalculation.totalSideWallPrice =
						leantoPriceCalculation.totalSideWallPrice == undefined
							? parseFloat(post_data["building"].leanto[i].side_wall_price)
							: parseFloat(leantoPriceCalculation.totalSideWallPrice) + parseFloat(post_data["building"].leanto[i].side_wall_price);
				}
				leantoPriceCalculation.totalEndWallPrice =
					leantoPriceCalculation.totalEndWallPrice == undefined
						? parseFloat(post_data["building"].leanto[i].front_wall_price) + parseFloat(post_data["building"].leanto[i].back_wall_price)
						: parseFloat(leantoPriceCalculation.totalEndWallPrice) + parseFloat(post_data["building"].leanto[i].front_wall_price) + parseFloat(post_data["building"].leanto[i].back_wall_price);

				if (post_data["building"].leanto[i].utility_price != undefined && post_data["building"].leanto[i].utility_price != 0) {
					leantoPriceCalculation.totalWallPrice = parseFloat(leantoPriceCalculation.totalWallPrice) + parseFloat(post_data["building"].leanto[i].utility_price);
				}
				leantoPriceCalculation.totalHeightPrice =
					leantoPriceCalculation.totalHeightPrice == undefined
						? parseFloat(post_data["building"].leanto[i].height_price)
						: parseFloat(leantoPriceCalculation.totalHeightPrice) + parseFloat(post_data["building"].leanto[i].height_price);
				leantoPriceCalculation.totalDimension =
					leantoPriceCalculation.totalDimension != undefined
						? parseFloat(leantoPriceCalculation.totalDimension) + parseFloat(post_data["building"].leanto[i].width * post_data["building"].leanto[i].total_length)
						: parseFloat(post_data["building"].leanto[i].width * post_data["building"].leanto[i].total_length);

				if (post_data["building"].leanto[i].insulation_price != undefined) {
					if (post_data["building"].leanto[i].insulation_type != undefined) {
						if (const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n] != undefined && const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n].length > 0) {
							if (const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n].find((data) => data.category == post_data["building"].leanto[i].insulation_type.insulation_id) != undefined) {
								if (checkInsulationArray.length == 0 && p_c_i) {
									params.selectedInsulationId = post_data["building"].leanto[i].insulation_type.insulation_id;
								}
								if (p_c_i == true) {
									post_data["building"].leanto[i]["insulation_commission"] = true;
								}
								checkInsulationArray.push(post_data["building"].leanto[i].insulation_type.insulation_id);
								leanToTotalInsultaionPrice = parseFloat(leanToTotalInsultaionPrice) + parseFloat(post_data["building"].leanto[i].insulation_price);
							}
						} else {
							if (p_c_i == true) {
								post_data["building"].leanto[i]["insulation_commission"] = false;
							}
						}
					}
				}
				deleteUncheckWallsfromInsulationWalls(post_data["building"]);
				if (isNaN(parseFloat(leantoPriceCalculation.totalBasePrice)) == true) {
					leantoPriceCalculation.totalBasePrice = 0;
				}
			}
		} else {
			leantoPriceCalculation.totalLeanPrice = 0;
			leantoPriceCalculation.totalBasePrice = 0;
			leantoPriceCalculation.totalWallPrice = 0;
			leantoPriceCalculation.totalHeightPrice = 0;
			leantoPriceCalculation.totalDimension = 0;
			leantoPriceCalculation.totalEndWallPrice = 0;
			leantoPriceCalculation.totalSideWallPrice = 0;
		}

		// to calculate extra item cost when cost type is %/sqft when lean to is active
		if (const_var.a_p_d_a != undefined && const_var.a_p_d_a.length > 0 && const_var.ExtraItemsFeaturesArray != undefined && const_var.ExtraItemsFeaturesArray.length > 0) {
			let checkCenterCost = false;
			const_var.ExtraItemsFeaturesArray.map((val, index) => {
				if (val != null && val.name == undefined && val.sheet_name != undefined) {
					val["name"] = "overhang";
					val["label"] = val.sheet_name;
				}
				if (val != null && val.is_checked == true) {
					let leantoExtraItemCheckBoxCost = 0;

					if (params.add_left_lean == true && const_var.leanGetDataLeft) {
						if (const_var.leanGetDataLeft.overhang != undefined && const_var.leanGetDataLeft.overhang.end != undefined && const_var.leanGetDataLeft.overhang.end.length > 0) {
							if (params.m_s_n == 153) {
								let tmp = const_var.isOverhang.side.selected == "1' Overhang on Ends" ? "10'' Overhang on Ends" : const_var.isOverhang.end.selected;
								let sel = const_var.leanGetDataLeft.overhang.end.filter((obj) => obj.sheet_name == tmp);
								let selCost = sel.length != 0 ? calcPriceWithCostType(sel[0], leantoPriceCalculation) : 0;
								leantoExtraItemCheckBoxCost = leantoExtraItemCheckBoxCost + selCost;
							} else {
								let sel = const_var.leanGetDataLeft.overhang.end.filter((obj) => obj.sheet_name == const_var.isOverhang.end.selected);
								let selCost = sel.length != 0 ? calcPriceWithCostType(sel[0], leantoPriceCalculation) : 0;
								leantoExtraItemCheckBoxCost = leantoExtraItemCheckBoxCost + selCost;
							}
						}
						if (const_var.leanGetDataLeft.overhang != undefined && const_var.leanGetDataLeft.overhang.side != undefined && const_var.leanGetDataLeft.overhang.side.length > 0) {
							if (params.m_s_n == 153) {
								let tmp = const_var.isOverhang.side.selected == "1' Overhang on Sides" ? "10'' Overhang on Sides" : const_var.isOverhang.side.selected;
								let sel = const_var.leanGetDataLeft.overhang.side.filter((obj) => obj.sheet_name == tmp);
								let selCost = sel.length != 0 ? calcPriceWithCostType(sel[0], leantoPriceCalculation) : 0;
								leantoExtraItemCheckBoxCost = leantoExtraItemCheckBoxCost + selCost;
							} else {
								let sel = const_var.leanGetDataLeft.overhang.side.filter((obj) => obj.sheet_name == const_var.isOverhang.side.selected);
								let selCost = sel.length != 0 ? calcPriceWithCostType(sel[0], leantoPriceCalculation) : 0;
								leantoExtraItemCheckBoxCost = leantoExtraItemCheckBoxCost + selCost;
							}
						}
						if (
							const_var.leanGetDataLeft.overhang != undefined &&
							const_var.leanGetDataLeft.overhang.both != undefined &&
							const_var.leanGetDataLeft.overhang.both != null &&
							const_var.leanGetDataLeft.overhang.both != ""
						) {
							// let selCost = const_var.leanGetDataLeft.overhang.both.cost != undefined ? const_var.leanGetDataLeft.overhang.both.cost :0;
							let selCost = const_var.leanGetDataLeft.overhang.both.cost != undefined ? calcPriceWithCostType(const_var.leanGetDataLeft.overhang.both, leantoPriceCalculation) : 0;
							leantoExtraItemCheckBoxCost = leantoExtraItemCheckBoxCost + selCost;
						}
					}
					if (params.add_front_lean == true && const_var.leanGetDataFront) {
						if (const_var.leanGetDataFront.overhang != undefined && const_var.leanGetDataFront.overhang.end != undefined && const_var.leanGetDataFront.overhang.end.length > 0) {
							if (params.m_s_n == 153) {
								let tmp = const_var.isOverhang.end.selected == "1' Overhang on Ends" ? "10'' Overhang on Ends" : const_var.isOverhang.end.selected;
								let sel = const_var.leanGetDataFront.overhang.end.filter((obj) => obj.sheet_name == tmp);
								let selCost = sel.length != 0 ? calcPriceWithCostType(sel[0], leantoPriceCalculation) : 0;
								leantoExtraItemCheckBoxCost = leantoExtraItemCheckBoxCost + selCost;
							} else {
								let sel = const_var.leanGetDataFront.overhang.end.filter((obj) => obj.sheet_name == const_var.isOverhang.end.selected);
								let selCost = sel.length != 0 ? calcPriceWithCostType(sel[0], leantoPriceCalculation) : 0;
								leantoExtraItemCheckBoxCost = leantoExtraItemCheckBoxCost + selCost;
							}
						}
						if (const_var.leanGetDataFront.overhang != undefined && const_var.leanGetDataFront.overhang.side != undefined && const_var.leanGetDataFront.overhang.side.length > 0) {
							if (params.m_s_n == 153) {
								let tmp = const_var.isOverhang.side.selected == "1' Overhang on Sides" ? "10'' Overhang on Sides" : const_var.isOverhang.side.selected;
								let sel = const_var.leanGetDataFront.overhang.side.filter((obj) => obj.sheet_name == tmp);
								let selCost = sel.length != 0 ? calcPriceWithCostType(sel[0], leantoPriceCalculation) : 0;
								leantoExtraItemCheckBoxCost = leantoExtraItemCheckBoxCost + selCost;
							} else {
								let sel = const_var.leanGetDataFront.overhang.side.filter((obj) => obj.sheet_name == const_var.isOverhang.side.selected);
								let selCost = sel.length != 0 ? calcPriceWithCostType(sel[0], leantoPriceCalculation) : 0;
								leantoExtraItemCheckBoxCost = leantoExtraItemCheckBoxCost + selCost;
							}
						}
						if (
							const_var.leanGetDataFront.overhang != undefined &&
							const_var.leanGetDataFront.overhang.both != undefined &&
							const_var.leanGetDataFront.overhang.both != null &&
							const_var.leanGetDataFront.overhang.both != ""
						) {
							let selCost = const_var.leanGetDataFront.overhang.both.cost != undefined ? calcPriceWithCostType(const_var.leanGetDataFront.overhang.both, leantoPriceCalculation) : 0;
							leantoExtraItemCheckBoxCost = leantoExtraItemCheckBoxCost + selCost;
						}
					}
					if (params.add_back_lean == true && const_var.leanGetDataBack) {
						if (const_var.leanGetDataBack.overhang != undefined && const_var.leanGetDataBack.overhang.end != undefined && const_var.leanGetDataBack.overhang.end.length > 0) {
							if (params.m_s_n == 153) {
								let tmp = const_var.isOverhang.end.selected == "1' Overhang on Ends" ? "10'' Overhang on Ends" : const_var.isOverhang.end.selected;
								let sel = const_var.leanGetDataBack.overhang.end.filter((obj) => obj.sheet_name == tmp);
								let selCost = sel.length != 0 ? calcPriceWithCostType(sel[0], leantoPriceCalculation) : 0;
								leantoExtraItemCheckBoxCost = leantoExtraItemCheckBoxCost + selCost;
							} else {
								let sel = const_var.leanGetDataBack.overhang.end.filter((obj) => obj.sheet_name == const_var.isOverhang.end.selected);
								let selCost = sel.length != 0 ? calcPriceWithCostType(sel[0], leantoPriceCalculation) : 0;
								leantoExtraItemCheckBoxCost = leantoExtraItemCheckBoxCost + selCost;
							}
						}
						if (const_var.leanGetDataBack.overhang != undefined && const_var.leanGetDataBack.overhang.side != undefined && const_var.leanGetDataBack.overhang.side.length > 0) {
							if (params.m_s_n == 153) {
								let tmp = const_var.isOverhang.side.selected == "1' Overhang on Sides" ? "10'' Overhang on Sides" : const_var.isOverhang.side.selected;
								let sel = const_var.leanGetDataBack.overhang.side.filter((obj) => obj.sheet_name == tmp);
								let selCost = sel.length != 0 ? calcPriceWithCostType(sel[0], leantoPriceCalculation) : 0;
								leantoExtraItemCheckBoxCost = leantoExtraItemCheckBoxCost + selCost;
							} else {
								let sel = const_var.leanGetDataBack.overhang.side.filter((obj) => obj.sheet_name == const_var.isOverhang.side.selected);
								let selCost = sel.length != 0 ? calcPriceWithCostType(sel[0], leantoPriceCalculation) : 0;
								leantoExtraItemCheckBoxCost = leantoExtraItemCheckBoxCost + selCost;
							}
						}
						if (
							const_var.leanGetDataBack.overhang != undefined &&
							const_var.leanGetDataBack.overhang.both != undefined &&
							const_var.leanGetDataBack.overhang.both != null &&
							const_var.leanGetDataBack.overhang.both != ""
						) {
							let selCost = const_var.leanGetDataBack.overhang.both.cost != undefined ? calcPriceWithCostType(const_var.leanGetDataBack.overhang.both, leantoPriceCalculation) : 0;
							leantoExtraItemCheckBoxCost = leantoExtraItemCheckBoxCost + selCost;
						}
					}
					if (params.add_right_lean == true && const_var.leanGetDataRight) {
						if (const_var.leanGetDataRight.overhang != undefined && const_var.leanGetDataRight.overhang.end != undefined && const_var.leanGetDataRight.overhang.end.length > 0) {
							if (params.m_s_n == 153) {
								let tmp = const_var.isOverhang.end.selected == "1' Overhang on Ends" ? "10'' Overhang on Ends" : const_var.isOverhang.end.selected;
								let sel = const_var.leanGetDataRight.overhang.end.filter((obj) => obj.sheet_name == tmp);
								let selCost = sel.length != 0 ? calcPriceWithCostType(sel[0], leantoPriceCalculation) : 0;
								leantoExtraItemCheckBoxCost = leantoExtraItemCheckBoxCost + selCost;
							} else {
								let sel = const_var.leanGetDataRight.overhang.end.filter((obj) => obj.sheet_name == const_var.isOverhang.end.selected);
								let selCost = sel.length != 0 ? calcPriceWithCostType(sel[0], leantoPriceCalculation) : 0;
								leantoExtraItemCheckBoxCost = leantoExtraItemCheckBoxCost + selCost;
							}
						}
						if (const_var.leanGetDataRight.overhang != undefined && const_var.leanGetDataRight.overhang.side != undefined && const_var.leanGetDataRight.overhang.side.length > 0) {
							if (params.m_s_n == 153) {
								let tmp = const_var.isOverhang.side.selected == "1' Overhang on Sides" ? "10'' Overhang on Sides" : const_var.isOverhang.side.selected;
								let sel = const_var.leanGetDataRight.overhang.side.filter((obj) => obj.sheet_name == tmp);
								let selCost = sel.length != 0 ? calcPriceWithCostType(sel[0], leantoPriceCalculation) : 0;
								leantoExtraItemCheckBoxCost = leantoExtraItemCheckBoxCost + selCost;
							} else {
								let sel = const_var.leanGetDataRight.overhang.side.filter((obj) => obj.sheet_name == const_var.isOverhang.side.selected);
								let selCost = sel.length != 0 ? calcPriceWithCostType(sel[0], leantoPriceCalculation) : 0;
								leantoExtraItemCheckBoxCost = leantoExtraItemCheckBoxCost + selCost;
							}
						}
						if (
							const_var.leanGetDataRight.overhang != undefined &&
							const_var.leanGetDataRight.overhang.both != undefined &&
							const_var.leanGetDataRight.overhang.both != null &&
							const_var.leanGetDataRight.overhang.both != ""
						) {
							let selCost = const_var.leanGetDataRight.overhang.both.cost != undefined ? calcPriceWithCostType(const_var.leanGetDataRight.overhang.both, leantoPriceCalculation) : 0;
							leantoExtraItemCheckBoxCost = leantoExtraItemCheckBoxCost + selCost;
						}
					}
					if (val.name != "fourth_center_cost") {
						if (val.cost_type == "%") {
							var splitVal = val.price_of != undefined && val.price_of.length > 0 ? val.price_of : 0;
							var splval = 0;
							if (splitVal != 0) {
								if (splitVal.includes("full_building_price") != false) {
									splval = parseFloat(splval) + parseFloat(t_c) + parseFloat(leantoPriceCalculation.totalLeanPrice);
								}
								if (splitVal.includes("base_price") != false) {
									splval = parseFloat(splval) + parseFloat(post_data["building"].roof_style_price) + parseFloat(leantoPriceCalculation.totalBasePrice);
								}
								if (splitVal.includes("wall_price") != false) {
									if (val.label.toLowerCase().includes("end")) {
										if (params.p_u_c == true || params.cB_addStorage_check_left == true || params.cB_addStorage_check_right == true) {
											splval =
												parseFloat(splval) +
												parseFloat(post_data["building"].utility_price) +
												parseFloat(post_data["building"].front_wall_price) +
												parseFloat(post_data["building"].back_wall_price) +
												parseFloat(leantoPriceCalculation.totalEndWallPrice);
										} else {
											splval =
												parseFloat(splval) +
												parseFloat(post_data["building"].front_wall_price) +
												parseFloat(post_data["building"].back_wall_price) +
												parseFloat(leantoPriceCalculation.totalEndWallPrice);
										}
										if (post_data["building"].utility_front_price != undefined && params.isBreezeway && params.cB_addStorage_check_front) {
											splval = parseFloat(splval) + parseFloat(post_data["building"].utility_front_price);
										}
									} else if (val.label.toLowerCase().includes("side")) {
										if (params.p_u_c == true || params.cB_addStorage_check_left == true || params.cB_addStorage_check_right == true) {
											splval =
												parseFloat(splval) +
												parseFloat(post_data["building"].utility_price) +
												parseFloat(post_data["building"].left_wall_price) +
												parseFloat(post_data["building"].right_wall_price) +
												parseFloat(leantoPriceCalculation.totalSideWallPrice);
										} else {
											splval =
												parseFloat(splval) +
												parseFloat(post_data["building"].left_wall_price) +
												parseFloat(post_data["building"].right_wall_price) +
												parseFloat(leantoPriceCalculation.totalSideWallPrice);
										}
										if (post_data["building"].utility_front_price != undefined && params.isBreezeway && params.cB_addStorage_check_front) {
											splval = parseFloat(splval) + parseFloat(post_data["building"].utility_front_price);
										}
									} else {
										if (params.p_u_c == true || params.cB_addStorage_check_left == true || params.cB_addStorage_check_right == true) {
											splval =
												parseFloat(splval) +
												parseFloat(post_data["building"].utility_price) +
												parseFloat(post_data["building"].front_wall_price) +
												parseFloat(post_data["building"].left_wall_price) +
												parseFloat(post_data["building"].right_wall_price) +
												parseFloat(post_data["building"].back_wall_price) +
												parseFloat(leantoPriceCalculation.totalWallPrice);
										} else {
											splval =
												parseFloat(splval) +
												parseFloat(post_data["building"].front_wall_price) +
												parseFloat(post_data["building"].left_wall_price) +
												parseFloat(post_data["building"].right_wall_price) +
												parseFloat(post_data["building"].back_wall_price) +
												parseFloat(leantoPriceCalculation.totalWallPrice);
										}
										if (post_data["building"].utility_front_price != undefined && params.isBreezeway && params.cB_addStorage_check_front) {
											splval = parseFloat(splval) + parseFloat(post_data["building"].utility_front_price);
										}
									}
								}
								if (splitVal.includes("height_price") != false) {
									splval = parseFloat(splval) + parseFloat(post_data["building"].height_price) + parseFloat(leantoPriceCalculation.totalHeightPrice);
								}
							} else {
								splval = parseFloat(splval) + parseFloat(totalPriceWithoutAdditionalItem);
							}
							let finalCost = (splval * val.cost) / 100;
							let additionalFeatureCost = finalCost % 1 == 0 ? finalCost : finalCost.toFixed(2);

							t_c =
								UpdatePriceRecord == true &&
								const_var.UpdatedPriceData["elements"] != undefined &&
								const_var.UpdatedPriceData["elements"][val.label.toString()] != undefined &&
								const_var.UpdatedPriceData["elements"][val.label.toString()].is_edit == true
									? parseFloat(t_c) + parseFloat(const_var.UpdatedPriceData["elements"][val.label.toString()]?.item_price)
									: parseFloat(t_c) + parseFloat(additionalFeatureCost) + parseFloat(leantoExtraItemCheckBoxCost);
							extra_items.push({
								is_edit:
									UpdatePriceRecord == true &&
									const_var.UpdatedPriceData["elements"] != undefined &&
									const_var.UpdatedPriceData["elements"][val.label.toString()] != undefined &&
									const_var.UpdatedPriceData["elements"][val.label.toString()].is_edit != undefined
										? const_var.UpdatedPriceData["elements"][val.label.toString()].is_edit
										: false,
								item_name: val.label,
								other_item_name: val.name,
								item_quantity: parseInt(val.quantity),
								item_price:
									UpdatePriceRecord == true &&
									const_var.UpdatedPriceData["elements"] != undefined &&
									const_var.UpdatedPriceData["elements"][val.label.toString()] != undefined &&
									const_var.UpdatedPriceData["elements"][val.label.toString()].is_edit == true
										? const_var.UpdatedPriceData["elements"][val.label.toString()]?.item_price
										: parseFloat(additionalFeatureCost) + parseFloat(leantoExtraItemCheckBoxCost)
							});
						} else if (val.cost_type == "sqft") {
							let sideWallsCount = const_var.cbClosedSideWalls + const_var.flClosedSideWalls + const_var.llClosedSideWalls + const_var.rlClosedSideWalls + const_var.blClosedSideWalls;
							let endWallsCount = const_var.cbClosedEndWalls + const_var.flClosedEndWalls + const_var.llClosedEndWalls + const_var.rlClosedEndWalls + const_var.blClosedEndWalls;

							let roofPrice = 0;
							let sidePrice = 0;
							let endPrice = 0;
							let endCount = 0;
							let sideCount = 0;

							if (Object.keys(const_var.wallsData["center"]).length > 0) {
								sideCount = parseFloat(sideCount) + parseFloat(const_var.wallsData["center"].closedSideWalls);
								endCount = parseFloat(endCount) + parseFloat(const_var.wallsData["center"].closedEndWalls);
								roofPrice = parseFloat(roofPrice) + parseFloat((params.p_w + 1) * params.p_d * val.cost);
								sidePrice = parseFloat(sidePrice) + parseFloat(params.p_d * params.p_h * val.cost * sideCount);
								endPrice = parseFloat(endPrice) + parseFloat((params.p_h + 1) * params.p_w * val.cost * endCount);
							}
							if (Object.keys(const_var.wallsData["frontLean"]).length > 0 && params.add_front_lean == true) {
								if (const_var.wallsData["frontLean"].closedSideWalls != 0) {
									sideCount = parseFloat(sideCount) + parseFloat(const_var.wallsData["frontLean"].closedSideWalls);
									sidePrice = parseFloat(sidePrice) + parseFloat(params.leanF_p_d * params.leanF_p_h * val.cost * sideCount);
								}
								if (const_var.wallsData["frontLean"].closedEndWalls != 0) {
									endCount = parseFloat(endCount) + parseFloat(const_var.wallsData["frontLean"].closedEndWalls);
									endPrice = parseFloat(endPrice) + parseFloat((params.leanF_p_h + 1) * params.leanF_p_w * val.cost * endCount);
								}

								roofPrice = parseFloat(roofPrice) + parseFloat((params.leanF_p_w + 1) * params.leanF_p_d * val.cost);
							}
							if (Object.keys(const_var.wallsData["backLean"]).length > 0 && params.add_back_lean == true) {
								if (const_var.wallsData["backLean"].closedSideWalls != 0) {
									sideCount = parseFloat(sideCount) + parseFloat(const_var.wallsData["backLean"].closedSideWalls);
									sidePrice = parseFloat(sidePrice) + parseFloat(params.leanB_p_d * params.leanB_p_h * val.cost * sideCount);
								}
								if (const_var.wallsData["backLean"].closedEndWalls != 0) {
									endCount = parseFloat(endCount) + parseFloat(const_var.wallsData["backLean"].closedEndWalls);
									endPrice = parseFloat(endPrice) + parseFloat((params.leanB_p_h + 1) * params.leanB_p_w * val.cost * endCount);
								}
								roofPrice = parseFloat(roofPrice) + parseFloat((params.leanB_p_w + 1) * params.leanB_p_d * val.cost);
							}
							if (Object.keys(const_var.wallsData["leftLean"]).length > 0 && params.add_left_lean == true) {
								if (const_var.wallsData["leftLean"].closedSideWalls != 0) {
									sideCount = parseFloat(sideCount) + parseFloat(const_var.wallsData["leftLean"].closedSideWalls);
									sidePrice = parseFloat(sidePrice) + parseFloat(params.lean_p_d * params.lean_p_h * val.cost * sideCount);
								}
								if (const_var.wallsData["leftLean"].closedEndWalls != 0) {
									endCount = parseFloat(endCount) + parseFloat(const_var.wallsData["leftLean"].closedEndWalls);
									endPrice = parseFloat(endPrice) + parseFloat((params.lean_p_h + 1) * params.lean_p_w * val.cost * endCount);
								}

								roofPrice = parseFloat(roofPrice) + parseFloat((params.lean_p_w + 1) * params.lean_p_d * val.cost);
							}
							if (Object.keys(const_var.wallsData["rightLean"]).length > 0 && params.add_right_lean == true) {
								if (const_var.wallsData["rightLean"].closedSideWalls != 0) {
									sideCount = parseFloat(sideCount) + parseFloat(const_var.wallsData["rightLean"].closedSideWalls);
									sidePrice = parseFloat(sidePrice) + parseFloat(params.leanR_p_d * params.leanR_p_h * val.cost * sideCount);
								}
								if (const_var.wallsData["rightLean"].closedEndWalls != 0) {
									endCount = parseFloat(endCount) + parseFloat(const_var.wallsData["rightLean"].closedEndWalls);
									endPrice = parseFloat(endPrice) + parseFloat((params.leanR_p_h + 1) * params.leanR_p_w * val.cost * endCount);
								}
								roofPrice = parseFloat(roofPrice) + parseFloat((params.leanR_p_w + 1) * params.leanR_p_d * val.cost);
							}
							if (
								const_var.UpdatedPriceData["elements"][val.label.toString()] != undefined &&
								(const_var.UpdatedPriceData["elements"][val.label.toString()].is_edit == undefined || const_var.UpdatedPriceData["elements"][val.label.toString()].is_edit == false)
							) {
								let FullCalculatedPrice = parseFloat(roofPrice) + parseFloat(sidePrice) + parseFloat(endPrice);
								var splval = parseFloat(params.p_w * params.p_d) + parseFloat(leantoPriceCalculation.totalDimension);
								t_c = parseFloat(t_c) + parseFloat(FullCalculatedPrice);

								extra_items.push({
									is_edit:
										UpdatePriceRecord == true &&
										const_var.UpdatedPriceData["elements"] != undefined &&
										const_var.UpdatedPriceData["elements"][val.label.toString()] != undefined &&
										const_var.UpdatedPriceData["elements"][val.label.toString()].is_edit != undefined
											? const_var.UpdatedPriceData["elements"][val.label.toString()].is_edit
											: false,
									item_name: val.label,
									other_item_name: val.name,
									item_quantity: parseInt(val.quantity),
									item_price: parseFloat(FullCalculatedPrice)
								});
							} else {
								let FullCalculatedPrice = parseFloat(roofPrice) + parseFloat(sidePrice) + parseFloat(endPrice);
								var splval = parseFloat(params.p_w * params.p_d) + parseFloat(leantoPriceCalculation.totalDimension);

								t_c =
									UpdatePriceRecord == true &&
									const_var.UpdatedPriceData["elements"] != undefined &&
									const_var.UpdatedPriceData["elements"][val.label.toString()] != undefined &&
									const_var.UpdatedPriceData["elements"][val.label.toString()].is_edit == true
										? parseFloat(t_c) + parseFloat(const_var.UpdatedPriceData["elements"][val.label.toString()]?.item_price)
										: parseFloat(t_c) + parseFloat(FullCalculatedPrice) + parseFloat(leantoExtraItemCheckBoxCost);
								extra_items.push({
									is_edit:
										UpdatePriceRecord == true &&
										const_var.UpdatedPriceData["elements"] != undefined &&
										const_var.UpdatedPriceData["elements"][val.label.toString()] != undefined &&
										const_var.UpdatedPriceData["elements"][val.label.toString()].is_edit != undefined
											? const_var.UpdatedPriceData["elements"][val.label.toString()].is_edit
											: false,
									item_name: val.label,
									other_item_name: val.name,
									item_quantity: parseInt(val.quantity),
									item_price:
										UpdatePriceRecord == true &&
										const_var.UpdatedPriceData["elements"] != undefined &&
										const_var.UpdatedPriceData["elements"][val.label.toString()] != undefined &&
										const_var.UpdatedPriceData["elements"][val.label.toString()].is_edit == true
											? const_var.UpdatedPriceData["elements"][val.label.toString()]?.item_price
											: parseFloat(FullCalculatedPrice) + parseFloat(leantoExtraItemCheckBoxCost)
								});
							}
						} else {
							t_c =
								UpdatePriceRecord == true &&
								const_var.UpdatedPriceData["elements"] != undefined &&
								const_var.UpdatedPriceData["elements"][val.label.toString()] != undefined &&
								const_var.UpdatedPriceData["elements"][val.label.toString()].is_edit == true
									? parseFloat(t_c) + parseFloat(const_var.UpdatedPriceData["elements"][val.label.toString()]?.item_price)
									: parseFloat(t_c) + parseFloat(val.cost) + parseFloat(leantoExtraItemCheckBoxCost);
							extra_items.push({
								is_edit:
									UpdatePriceRecord == true &&
									const_var.UpdatedPriceData["elements"] != undefined &&
									const_var.UpdatedPriceData["elements"][val.label.toString()] != undefined &&
									const_var.UpdatedPriceData["elements"][val.label.toString()].is_edit != undefined
										? const_var.UpdatedPriceData["elements"][val.label.toString()].is_edit
										: false,
								item_name: val.label,
								other_item_name: val.name,
								item_quantity: parseInt(val.quantity),
								item_price:
									UpdatePriceRecord == true &&
									const_var.UpdatedPriceData["elements"] != undefined &&
									const_var.UpdatedPriceData["elements"][val.label.toString()] != undefined &&
									const_var.UpdatedPriceData["elements"][val.label.toString()].is_edit == true
										? const_var.UpdatedPriceData["elements"][val.label.toString()]?.item_price
										: parseFloat(val.cost) + parseFloat(leantoExtraItemCheckBoxCost)
							});
						}
					}
				}
			});
			post_data["building"].ExtraItemsFeaturesArray = const_var.ExtraItemsFeaturesArray;
		}

		post_data["building"].leanto &&
			post_data["building"].leanto.length > 0 &&
			post_data["building"].leanto.forEach((lean) => {
				let updatedPriceDataForAddedBuilding = const_var.lNTBuildingData["updatePriceDataElements"];
				if (lean && lean.leanto_type == 1 && params.added_building_bracing.p_s_c_b_l == true && const_var.LNTCrossBracing.left?.["Side Cross Bracing"] == undefined) {
					let leanPriceDataObj = updatedPriceDataForAddedBuilding[LEAN_TYPE_NUM_TO_STR[lean.leanto_type]];
					let updatedPriceObjectKey;
					updatedPriceObjectKey = Object.keys(leanPriceDataObj).find((key) => leanPriceDataObj[key]?.other_item_name && leanPriceDataObj[key]?.other_item_name == "Side Cross Bracing");

					if (updatedPriceObjectKey == undefined || leanPriceDataObj[updatedPriceObjectKey] == undefined) {
						const_var.UpdatedPriceData.common_left_lean_length_changed = true;
					}
					let selectedSidingObj = lean.pricing_data.side_cross_bracing.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.left_lean_side);
					var extPrice =
						UpdatePriceRecord == true &&
						updatedPriceDataForAddedBuilding != undefined &&
						const_var.UpdatedPriceData.common_left_lean_length_changed != true &&
						leanPriceDataObj[updatedPriceObjectKey] != undefined &&
						const_var.UpdatedPriceData.left_lean_height_price_changed != true
							? leanPriceDataObj[updatedPriceObjectKey]?.item_price
							: selectedSidingObj != undefined
								? selectedSidingObj.cost
								: lean.pricing_data.side_cross_bracing[0].cost;
					extraItems["left"].push({
						other_item_name: "Side Cross Bracing",
						item_key: selectedSidingObj.sheet_name,
						item_quantity: params.added_building_bracing.p_s_c_b_l == true ? 1 : 0,
						item_price: extPrice,
						item_name: "Side: " + selectedSidingObj.sheet_label
					});
					t_c = parseFloat(t_c) + parseFloat(extPrice);
				}
				if (lean && lean.leanto_type == 2 && params.added_building_bracing.p_s_c_b_r == true && const_var.LNTCrossBracing.right?.["Side Cross Bracing"] == undefined) {
					let leanPriceDataObj = updatedPriceDataForAddedBuilding[LEAN_TYPE_NUM_TO_STR[lean.leanto_type]];
					let updatedPriceObjectKey;
					updatedPriceObjectKey = Object.keys(leanPriceDataObj).find((key) => leanPriceDataObj[key]?.other_item_name && leanPriceDataObj[key]?.other_item_name == "Side Cross Bracing");
					if (updatedPriceObjectKey == undefined || leanPriceDataObj[updatedPriceObjectKey] == undefined) {
						const_var.UpdatedPriceData.common_right_lean_length_changed = true;
					}
					let selectedSidingObj = lean.pricing_data.side_cross_bracing.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.right_lean_side);

					var extPrice =
						UpdatePriceRecord == true &&
						updatedPriceDataForAddedBuilding != undefined &&
						const_var.UpdatedPriceData.common_right_lean_length_changed != true &&
						leanPriceDataObj[updatedPriceObjectKey] != undefined &&
						const_var.UpdatedPriceData.right_lean_height_price_changed != true
							? leanPriceDataObj[updatedPriceObjectKey]?.item_price
							: selectedSidingObj != undefined
								? selectedSidingObj.cost
								: lean.pricing_data.side_cross_bracing[0].cost;
					extraItems["right"].push({
						other_item_name: "Side Cross Bracing",
						item_key: selectedSidingObj.sheet_name,
						item_quantity: params.added_building_bracing.p_s_c_b_l == true ? 1 : 0,
						item_price: extPrice,
						item_name: "Side: " + selectedSidingObj.sheet_label
					});
					t_c = parseFloat(t_c) + parseFloat(extPrice);
				}
				if (lean && lean.leanto_type == 3 && params.added_building_bracing.p_s_c_b_f == true && const_var.LNTCrossBracing.front?.["Side Cross Bracing"] == undefined) {
					let leanPriceDataObj = updatedPriceDataForAddedBuilding[LEAN_TYPE_NUM_TO_STR[lean.leanto_type]];
					let updatedPriceObjectKey;
					updatedPriceObjectKey = Object.keys(leanPriceDataObj).find((key) => leanPriceDataObj[key]?.other_item_name && leanPriceDataObj[key]?.other_item_name == "Side Cross Bracing");
					if (updatedPriceObjectKey == undefined || leanPriceDataObj[updatedPriceObjectKey] == undefined) {
						const_var.UpdatedPriceData.common_front_lean_length_changed = true;
					}
					let selectedSidingObj = lean.pricing_data.side_cross_bracing.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.front_lean_side);

					var extPrice =
						UpdatePriceRecord == true &&
						updatedPriceDataForAddedBuilding != undefined &&
						const_var.UpdatedPriceData.common_front_lean_length_changed != true &&
						leanPriceDataObj[updatedPriceObjectKey] != undefined &&
						const_var.UpdatedPriceData.front_lean_height_price_changed != true
							? leanPriceDataObj[updatedPriceObjectKey]?.item_price
							: selectedSidingObj != undefined
								? selectedSidingObj.cost
								: lean.pricing_data.side_cross_bracing[0].cost;
					extraItems["front"].push({
						other_item_name: "Side Cross Bracing",
						item_key: selectedSidingObj.sheet_name,
						item_quantity: params.added_building_bracing.p_s_c_b_l == true ? 1 : 0,
						item_price: extPrice,
						item_name: "Side: " + selectedSidingObj.sheet_label
					});
					t_c = parseFloat(t_c) + parseFloat(extPrice);
				}
				if (lean && lean.leanto_type == 4 && params.added_building_bracing.p_s_c_b_b == true && const_var.LNTCrossBracing.back?.["Side Cross Bracing"] == undefined) {
					let leanPriceDataObj = updatedPriceDataForAddedBuilding[LEAN_TYPE_NUM_TO_STR[lean.leanto_type]];
					let updatedPriceObjectKey;
					updatedPriceObjectKey = Object.keys(leanPriceDataObj).find((key) => leanPriceDataObj[key]?.other_item_name && leanPriceDataObj[key]?.other_item_name == "Side Cross Bracing");
					if (updatedPriceObjectKey == undefined || leanPriceDataObj[updatedPriceObjectKey] == undefined) {
						const_var.UpdatedPriceData.common_back_lean_length_changed = true;
					}
					let selectedSidingObj = lean.pricing_data.side_cross_bracing.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.back_lean_side);

					var extPrice =
						UpdatePriceRecord == true &&
						updatedPriceDataForAddedBuilding != undefined &&
						const_var.UpdatedPriceData.common_back_lean_length_changed != true &&
						leanPriceDataObj[updatedPriceObjectKey] != undefined &&
						const_var.UpdatedPriceData.back_lean_height_price_changed != true
							? leanPriceDataObj[updatedPriceObjectKey]?.item_price
							: selectedSidingObj != undefined
								? selectedSidingObj.cost
								: lean.pricing_data.side_cross_bracing[0].cost;
					extraItems["back"].push({
						other_item_name: "Side Cross Bracing",
						item_key: selectedSidingObj.sheet_name,
						item_quantity: params.added_building_bracing.p_s_c_b_l == true ? 1 : 0,
						item_price: extPrice,
						item_name: "Side: " + selectedSidingObj.sheet_label
					});
					t_c = parseFloat(t_c) + parseFloat(extPrice);
				}
				if (lean && lean.leanto_type == 1 && params.added_building_bracing.p_e_c_b_l == true && const_var.LNTCrossBracing.left?.["End Cross Bracing"] == undefined) {
					let leanPriceDataObj = updatedPriceDataForAddedBuilding[LEAN_TYPE_NUM_TO_STR[lean.leanto_type]];
					let updatedPriceObjectKey;
					updatedPriceObjectKey = Object.keys(leanPriceDataObj).find((key) => leanPriceDataObj[key]?.other_item_name && leanPriceDataObj[key]?.other_item_name == "End Cross Bracing");
					if (updatedPriceObjectKey == undefined || leanPriceDataObj[updatedPriceObjectKey] == undefined) {
						const_var.UpdatedPriceData.common_left_lean_width_changed = true;
					}
					let selectedSidingObj = lean.pricing_data.end_cross_bracing.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.left_lean_end);
					var extPrice =
						UpdatePriceRecord == true &&
						updatedPriceDataForAddedBuilding != undefined &&
						const_var.UpdatedPriceData.common_left_lean_width_changed != true &&
						leanPriceDataObj[updatedPriceObjectKey] != undefined &&
						const_var.UpdatedPriceData.left_lean_height_price_changed != true
							? leanPriceDataObj[updatedPriceObjectKey]?.item_price
							: selectedSidingObj != undefined
								? selectedSidingObj.cost
								: lean.pricing_data.end_cross_bracing[0].cost;

					extraItems["left"].push({
						other_item_name: "End Cross Bracing",
						item_key: selectedSidingObj.sheet_name,
						item_quantity: params.added_building_bracing.p_e_c_b_l == true ? 1 : 0,
						item_price: extPrice,
						item_name: "End: " + selectedSidingObj.sheet_label
					});
					t_c = parseFloat(t_c) + parseFloat(extPrice);
				}
				if (lean && lean.leanto_type == 2 && params.added_building_bracing.p_e_c_b_r == true && const_var.LNTCrossBracing.right?.["End Cross Bracing"] == undefined) {
					let leanPriceDataObj = updatedPriceDataForAddedBuilding[LEAN_TYPE_NUM_TO_STR[lean.leanto_type]];
					let updatedPriceObjectKey;
					updatedPriceObjectKey = Object.keys(leanPriceDataObj).find((key) => leanPriceDataObj[key]?.other_item_name && leanPriceDataObj[key]?.other_item_name == "End Cross Bracing");
					if (updatedPriceObjectKey == undefined || leanPriceDataObj[updatedPriceObjectKey] == undefined) {
						const_var.UpdatedPriceData.common_right_lean_width_changed = true;
					}
					let selectedSidingObj = lean.pricing_data.end_cross_bracing.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.right_lean_end);

					var extPrice =
						UpdatePriceRecord == true &&
						updatedPriceDataForAddedBuilding != undefined &&
						const_var.UpdatedPriceData.common_right_lean_width_changed != true &&
						leanPriceDataObj[updatedPriceObjectKey] != undefined &&
						const_var.UpdatedPriceData.right_lean_height_price_changed != true
							? leanPriceDataObj[updatedPriceObjectKey]?.item_price
							: selectedSidingObj != undefined
								? selectedSidingObj.cost
								: lean.pricing_data.end_cross_bracing?.[0]?.cost;
					extraItems["right"].push({
						other_item_name: "End Cross Bracing",
						item_key: selectedSidingObj.sheet_name,
						item_quantity: params.added_building_bracing.p_e_c_b_l == true ? 1 : 0,
						item_price: extPrice,
						item_name: "End: " + selectedSidingObj.sheet_label
					});
					t_c = parseFloat(t_c) + parseFloat(extPrice);
				}
				if (lean && lean.leanto_type == 3 && params.added_building_bracing.p_e_c_b_f == true && const_var.LNTCrossBracing.front?.["End Cross Bracing"] == undefined) {
					let leanPriceDataObj = updatedPriceDataForAddedBuilding[LEAN_TYPE_NUM_TO_STR[lean.leanto_type]];
					let updatedPriceObjectKey;
					updatedPriceObjectKey = Object.keys(leanPriceDataObj).find((key) => leanPriceDataObj[key]?.other_item_name && leanPriceDataObj[key]?.other_item_name == "End Cross Bracing");
					if (updatedPriceObjectKey == undefined || leanPriceDataObj[updatedPriceObjectKey] == undefined) {
						const_var.UpdatedPriceData.common_front_lean_width_changed = true;
					}
					let selectedSidingObj = lean.pricing_data.end_cross_bracing.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.front_lean_end);

					var extPrice =
						UpdatePriceRecord == true &&
						updatedPriceDataForAddedBuilding != undefined &&
						const_var.UpdatedPriceData.common_front_lean_width_changed != true &&
						leanPriceDataObj[updatedPriceObjectKey] != undefined &&
						const_var.UpdatedPriceData.front_lean_height_price_changed != true
							? leanPriceDataObj[updatedPriceObjectKey]?.item_price
							: selectedSidingObj != undefined
								? selectedSidingObj.cost
								: lean.pricing_data.end_cross_bracing[0].cost;
					extraItems["front"].push({
						other_item_name: "End Cross Bracing",
						item_key: selectedSidingObj.sheet_name,
						item_quantity: params.added_building_bracing.p_e_c_b_l == true ? 1 : 0,
						item_price: extPrice,
						item_name: "End: " + selectedSidingObj.sheet_label
					});
					t_c = parseFloat(t_c) + parseFloat(extPrice);
				}
				if (lean && lean.leanto_type == 4 && params.added_building_bracing.p_e_c_b_b == true && const_var.LNTCrossBracing.back?.["End Cross Bracing"] == undefined) {
					let leanPriceDataObj = updatedPriceDataForAddedBuilding[LEAN_TYPE_NUM_TO_STR[lean.leanto_type]];
					let updatedPriceObjectKey;
					updatedPriceObjectKey = Object.keys(leanPriceDataObj).find((key) => leanPriceDataObj[key]?.other_item_name && leanPriceDataObj[key]?.other_item_name == "End Cross Bracing");
					if (updatedPriceObjectKey == undefined || leanPriceDataObj[updatedPriceObjectKey] == undefined) {
						const_var.UpdatedPriceData.common_back_lean_width_changed = true;
					}
					let selectedSidingObj = lean.pricing_data.end_cross_bracing.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.back_lean_end);

					var extPrice =
						UpdatePriceRecord == true &&
						updatedPriceDataForAddedBuilding != undefined &&
						const_var.UpdatedPriceData.common_back_lean_width_changed != true &&
						leanPriceDataObj[updatedPriceObjectKey] != undefined &&
						const_var.UpdatedPriceData.back_lean_height_price_changed != true
							? leanPriceDataObj[updatedPriceObjectKey]?.item_price
							: selectedSidingObj != undefined
								? selectedSidingObj.cost
								: lean.pricing_data.end_cross_bracing[0].cost;
					extraItems["back"].push({
						other_item_name: "End Cross Bracing",
						item_key: selectedSidingObj.sheet_name,
						item_quantity: params.added_building_bracing.p_e_c_b_l == true ? 1 : 0,
						item_price: extPrice,
						item_name: "End: " + selectedSidingObj.sheet_label
					});
					t_c = parseFloat(t_c) + parseFloat(extPrice);
				}
			});

		let totalPriceWithoutAdditionalItem = parseFloat(t_c);
		let chk_is_cumulative = 0;

		if (const_var.isLTBuilding && const_var.selectedLeanType !== "" && const_var.lNTBuildingData.ExtraItemsFeaturesArray?.centerBuilding?.length > 0) {
			const fccIndex = const_var.lNTBuildingData.ExtraItemsFeaturesArray.centerBuilding.findIndex((item) => item?.name == "fourth_center_cost");
			if (fccIndex > -1) {
				const_var.ExtraItemsFeaturesArray[fccIndex] = JSON.parse(JSON.stringify(const_var.lNTBuildingData.ExtraItemsFeaturesArray.centerBuilding[fccIndex]));
			}
		}

		let leantoRoofColorPrice = 0;
		let leantoWallColorPrice = 0;
		let leantoTrimColorPrice = 0;
		let leantoSquareFeetPrice = 0;
		if (isNaN(parseFloat(t_c)) == true) {
			t_c = 0;
		}
		const drawingName = const_var?.order_extra_items?.engineer_drawings_name;
		if (drawingName && drawingName.toLowerCase() != "none") {
			const drawings = const_var?.c_m_a[params.p_b_t]?.drawings;
			if (drawings) {
				const selectedName = const_var.order_extra_items.engineer_drawings_name.toLowerCase();
				let selDrawingObj = drawings.find((obj) => obj.name.toLowerCase() == selectedName);
				let finalCost = getDrawingPricing(selDrawingObj, post_data);
				const_var.order_extra_items["engineer_drawings"] = const_var.engineer_drawings_price_changed == false ? (const_var.updated_engineer_drawings_price ?? 0) : (finalCost ?? 0);
			}
		}
		if (post_data["building"].leanto.length > 0) {
			let leanDrawingCost = 0;
			if (
				params.m_s_n == "178" &&
				const_var.order_extra_items != undefined &&
				const_var.order_extra_items.engineer_drawings_name != undefined &&
				const_var.order_extra_items.engineer_drawings_name.toLowerCase() != "none" &&
				const_var.engineer_drawings_price_changed != false &&
				const_var.b_o_J_1[params.p_b_t] != "Custom Buildings"
			) {
				let leanToDrawing = const_var.c_m_a[const_var.c_m_a[params.p_b_t].default_lean_id];
				leanToDrawing = leanToDrawing?.drawings;
				let selLeanDrawingObj =
					leanToDrawing != undefined && leanToDrawing.length != 0 ? leanToDrawing.find((obj) => const_var.order_extra_items.engineer_drawings_name.toLowerCase() == obj.name.toLowerCase()) : undefined;
				leanDrawingCost = selLeanDrawingObj != undefined ? selLeanDrawingObj.cost : 0;
			}
			for (var i = 0; i <= post_data["building"].leanto.length - 1; i++) {
				var leftleanPrice = post_data["building"].leanto[i].t_c_b == undefined ? const_var.leanto[i].t_c_b : post_data["building"].leanto[i].t_c_b;
				let leantoLength = post_data["building"].leanto[i].total_length != undefined ? post_data["building"].leanto[i].total_length : post_data["building"].leanto[i].length;
				leantoSquareFeetPrice = parseFloat(leantoSquareFeetPrice) + parseFloat(post_data["building"].leanto[i].width * leantoLength);
				if (params.m_s_n == "178" && const_var.engineer_drawings_price_changed != false) {
					const_var.order_extra_items["engineer_drawings"] = const_var.order_extra_items["engineer_drawings"] + leanDrawingCost;
				}
				if (isNaN(parseFloat(leftleanPrice)) == true) {
					leftleanPrice = 0;
				}

				if (roofColorConfig?.cost != 0) {
					leantoRoofColorPrice = parseFloat(leantoRoofColorPrice) + (parseFloat(post_data["building"].leanto[i].basic_price) * parseFloat(roofColorConfig?.cost)) / 100;
				}
				if (wallColorConfig && wallColorConfig.cost != 0) {
					if (post_data["building"].leanto[i].utility_price != undefined) {
						leantoWallColorPrice =
							parseFloat(leantoWallColorPrice) +
							parseFloat(post_data["building"].leanto[i].front_wall_price) +
							parseFloat(post_data["building"].leanto[i].utility_price) +
							parseFloat(post_data["building"].leanto[i].side_wall_price);
					} else {
						leantoWallColorPrice =
							parseFloat(post_data["building"].leanto[i].front_wall_price) + parseFloat(post_data["building"].leanto[i].back_wall_price) + parseFloat(post_data["building"].leanto[i].side_wall_price);
					}
				}
				if (trimColorConfig && trimColorConfig.cost != 0) {
					leantoTrimColorPrice = parseFloat(leantoTrimColorPrice) + parseFloat(post_data["building"].leanto[i].height_price);
				}

				t_c = parseFloat(t_c + parseFloat(leftleanPrice));
			}
		} else {
			t_c = parseFloat(t_c);
		}

		let orderTotalWithColorPrice = t_c;
		if (const_var.oldPriceForColorCost == 0) {
			const_var.oldPriceForColorCost = parseFloat(orderTotalWithColorPrice);
		}

		post_data["building"].edit_truss_name =
			const_var.c_m_a[params.p_b_t].trussType != undefined && const_var.c_m_a[params.p_b_t].trussType.length > 0 ? params["trussType"] : const_var.c_m_a[params.p_b_t].trussType[0]?.name?.replace(/[0-9]/g, "");
		const hasManufacture3and9 = params.m_s_n == 3 || params.m_s_n == 9;
		if (((hasManufacture3and9 && params.p_w >= 32) || data?.truss_name?.length >= 1) && data.is_show) {
			const _leantoPriceCalculation = utlis.getMeLeanToPrices(post_data);
			let filterDataTruss = [];
			let localTC = 0;
			if ((hasManufacture3and9 && data?.truss_name?.length >= 1) || (data?.truss_name?.length >= 1 && const_var.defaultBuildingImgName != "Custom_Buildings")) {
				filterDataTruss = data.truss_name.filter((data) => data.name.includes(post_data["building"].edit_truss_name));
				if (filterDataTruss.length > 0) {
					let trussCost = trussCalcuate(filterDataTruss, post_data, t_c, params, totalPriceWithoutAdditionalItem, _leantoPriceCalculation, "cp");
					t_c = trussCost;
				}
			}
			if ((hasManufacture3and9 && data?.truss_name?.length == 1) || (data?.truss_name?.length == 1 && const_var.defaultBuildingImgName != "Custom_Buildings")) {
				filterDataTruss = data.truss_name.filter((data) => data.name.includes(post_data["building"].edit_truss_name) && data.is_default && data.is_show);
				if (filterDataTruss.length == 0) {
					filterDataTruss = data.truss_name.filter((data) => data.is_default == true && data.is_show == true);
				}
				if (filterDataTruss.length > 0) {
					let trussCost = trussCalcuate(filterDataTruss, post_data, t_c, params, totalPriceWithoutAdditionalItem, _leantoPriceCalculation, "cp");
					t_c = trussCost;
				}
			}
		}
		//   start color calculation
		const roofCostConfig = roofColorConfig?.cost?.ROOF;
		const roofFinalCost = roofColorPricingCalculation(roofCostConfig, post_data, leantoRoofColorPrice, leantoSquareFeetPrice, t_c);
		t_c += roofFinalCost;

		const wallCostConfig = wallColorConfig?.cost?.WALL;
		const wallFinalCost = wallColorPricingCalculation(wallCostConfig, post_data, leantoWallColorPrice, leantoSquareFeetPrice, t_c);
		t_c += wallFinalCost;

		const trimCostConfig = trimColorConfig?.cost?.TRIM;
		const trimFinalCost = trimColorPricingCalculation(trimCostConfig, post_data, leantoTrimColorPrice, leantoRoofColorPrice, leantoSquareFeetPrice, t_c);
		t_c += trimFinalCost;

		const wainsCotCostConfig = wainscotColorConfig?.cost?.WAINSCOT;
		const wainsCoatFinalCost = wainscotColorPricingCalculation(wainsCotCostConfig, post_data, leantoSquareFeetPrice, data);
		t_c += wainsCoatFinalCost;
		//  End Color Calcualtion

		// extra add on option calculation
		let hasextraAddOnItemsArrayAnywhere = const_var.extraAddOnItemsArray;

		if (const_var.isLTBuilding) {
			hasextraAddOnItemsArrayAnywhere =
				const_var.lNTBuildingData?.extraAddOnItemsArray &&
				Object.values(const_var.lNTBuildingData?.extraAddOnItemsArray)
					?.flatMap((item) => item)
					.filter((item) => item != undefined);
		}
		let addOnItemPriceArray = [];
		if (isNaN(parseFloat(leantoPriceCalculation.totalWallPrice)) == true) {
			leantoPriceCalculation.totalWallPrice = 0;
		}
		if (isNaN(parseFloat(leantoPriceCalculation.totalBasePrice)) == true) {
			leantoPriceCalculation.totalBasePrice = 0;
		}
		if (isNaN(parseFloat(leantoPriceCalculation.totalLeanPrice)) == true) {
			leantoPriceCalculation.totalLeanPrice = 0;
		}
		if (isNaN(parseFloat(leantoPriceCalculation.totalHeightPrice)) == true) {
			leantoPriceCalculation.totalHeightPrice = 0;
		}
		if (isNaN(parseFloat(leantoPriceCalculation.totalDimension)) == true) {
			leantoPriceCalculation.totalDimension = 0;
		}

		let certVal = 1;

		if (isNaN(parseFloat(t_c)) == true) {
			t_c = 0;
		}

		post_data["building"].price = parseFloat(t_c);

		post_data["building"].order_total = parseFloat(t_c);
		post_data["building"].grand_total = parseFloat(t_c);

		post_data["building"].order_total = post_data["building"].order_total;
		post_data["building"].sub_order_total = post_data["building"].order_total;
		const_var.BuildingPriceArrar["order_total"] = post_data["building"].order_total;

		const_var.BuildingPriceArrar["sub_order_total"] = post_data["building"].order_total;

		let surcharge_by_mfg = [];
		if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"] != undefined && const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] == undefined) {
			if (const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"][params.m_s_n] != undefined) {
				const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] =
					const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"] != undefined && const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"][params.m_s_n].length > 0
						? const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"][params.m_s_n]
						: const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n];
			} else {
				const_var.stateManufacturerAcordingAPIDiscount["surcharge"] = [];
			}
		}
		if (
			const_var.stateManufacturerAcordingAPIDiscount["surcharge"] != undefined &&
			const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] != undefined &&
			Object.keys(const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n]).length > 0
		) {
			surcharge_by_mfg = const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"][params.m_s_n].filter(
				(data) => data.surcharge_on_discounted_subtotal == 1 && data.percentage_of != "garage_doors" && data.percentage_of != "insulation"
			);
			if (surcharge_by_mfg.length > 0) {
				post_data["building"].surcharge_on_discounted_subtotal = 1;
			} else {
				post_data["building"].surcharge_on_discounted_subtotal = 0;
			}
		}
		if (surcharge_by_mfg.length == 0) {
			post_data["building"].surcharge_on_discounted_subtotal = post_data["building"].surcharge_on_discounted_subtotal == undefined ? 0 : post_data["building"].surcharge_on_discounted_subtotal;
			if (CalculatesurchargeFees == undefined) {
				CalculatesurchargeFees = 0;
			} else {
				CalculatesurchargeFees = parseFloat(const_var.order_extra_items["surchargeFees"]);
			}

			if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"] != undefined && const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] == undefined) {
				if (const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"][params.m_s_n] != undefined) {
					const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] =
						const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"] != undefined && const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"][params.m_s_n].length > 0
							? const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"][params.m_s_n]
							: const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n];
				} else {
					const_var.stateManufacturerAcordingAPIDiscount["surcharge"] = [];
				}
			}
			let filterData = "";
			if (
				const_var.stateManufacturerAcordingAPIDiscount["surcharge"] != undefined &&
				const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] != undefined &&
				Object.keys(const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n]).length > 0
			) {
				if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].is_edit == undefined && const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"][params.m_s_n].length > 0) {
					let filterData1 = const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"][params.m_s_n].filter(
						(data) =>
							parseFloat(post_data["building"].roof_style_price) + parseFloat(leantoPriceCalculation.totalBasePrice) >= data.price_from &&
							parseFloat(post_data["building"].roof_style_price) + parseFloat(leantoPriceCalculation.totalBasePrice) <= data.price_to &&
							data.percentage_of == "basic_price"
					);
					filterData = const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"][params.m_s_n].filter(
						(data) => post_data["building"].order_total >= data.price_from && post_data["building"].order_total <= data.price_to && data.percentage_of == "building_amount"
					);
					filterData = filterData1.length == 0 ? filterData : filterData1;
					let len = filterData.length - 1;
					const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] = filterData[len] != undefined ? filterData[len] : const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n];
					if (filterData.length == 0) {
						const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] = filterData.length == 0 ? undefined : const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n];

						if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] == undefined) {
							const_var.order_extra_items["surchargeFees"] = isNaN(parseFloat(const_var.order_extra_items["surchargeFees"])) == true ? 0 : const_var.order_extra_items["surchargeFees"];
						}
					}
				} else {
					const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] = const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n];
				}
				if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] != undefined) {
					const_var.UpdatedPriceData.surcharge_taxable = const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].taxable;
				}
			}
			post_data["building"].surcharge_amount = const_var.order_extra_items["surchargeFees"];

			if (
				const_var.stateManufacturerAcordingAPIDiscount["surcharge"] != undefined &&
				const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] != undefined &&
				const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] != 0 &&
				Object.keys(const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n]).length > 0
			) {
				if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].taxable == 1) {
					if (const_var.surcharge_amount_is_edit != undefined && const_var.surcharge_amount_is_edit == true) {
						const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].is_edit = true;
					}
					if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].is_edit == undefined) {
						const_var.order_extra_items["surchargeFees"] = 0;
						post_data["building"].surcharge_amount_type = const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount_type;
						if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount_type == "per") {
							if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].percentage_of == "building_amount") {
								post_data["building"].surcharge_percentage_of = const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].percentage_of;
								CalculatesurchargeFees = parseFloat(
									(parseFloat(const_var.BuildingPriceArrar["order_total"]) * parseFloat(const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount)) / 100
								).toFixed(2);
							} else {
								if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].percentage_of == "basic_price") {
									post_data["building"].surcharge_percentage_of = const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].percentage_of;
									CalculatesurchargeFees = parseFloat(
										((parseFloat(post_data["building"].roof_style_price) + parseFloat(leantoPriceCalculation.totalBasePrice)) *
											parseFloat(const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount)) /
											100
									).toFixed(2);
								} else {
									CalculatesurchargeFees = parseFloat(
										(parseFloat(const_var.BuildingPriceArrar["sub_order_total"]) * parseFloat(const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount)) / 100
									).toFixed(2);
								}
							}
							post_data["building"].surcharge_calculate_amount = const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount;
						} else {
							post_data["building"].surcharge_calculate_amount = const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount;
							CalculatesurchargeFees = parseFloat(const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount);
						}
						CalculatesurchargeFees =
							const_var.UpdatedPriceData.surcharge_amount != undefined && const_var.crmSetting.is_Edit == true && const_var.checkPickThisBuilding == false
								? const_var.UpdatedPriceData.surcharge_amount
								: CalculatesurchargeFees;
					} else {
						CalculatesurchargeFees = parseFloat(CalculatesurchargeFees);
					}
					CalculatesurchargeFees = CalculatesurchargeFees;
					post_data["building"].surcharge_taxable =
						const_var.UpdatedPriceData.surcharge_taxable == undefined || const_var.UpdatedPriceData.surcharge_taxable == 0
							? const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].taxable
							: const_var.UpdatedPriceData.surcharge_taxable;
					post_data["building"].surcharge_amount = CalculatesurchargeFees;
					const_var.BuildingPriceArrar["surcharge_amount"] = parseFloat(post_data["building"].surcharge_amount);
					post_data["building"].order_total = parseFloat(post_data["building"].order_total) + parseFloat(post_data["building"].surcharge_amount);
					const_var.BuildingPriceArrar["order_total"] = parseFloat(const_var.BuildingPriceArrar["order_total"]) + parseFloat(post_data["building"].surcharge_amount);
					if (const_var.order_extra_items["surchargeFees"] == 0) {
						const_var.order_extra_items["surchargeFees"] = parseFloat(CalculatesurchargeFees);
					}
				} else {
					if (const_var.UpdatedPriceData.surcharge_taxable != undefined) {
						if (const_var.UpdatedPriceData.surcharge_taxable == 1) {
							CalculatesurchargeFees = parseFloat(CalculatesurchargeFees);
							post_data["building"].surcharge_taxable = const_var.UpdatedPriceData.surcharge_taxable;
							post_data["building"].surcharge_amount = CalculatesurchargeFees;
							const_var.BuildingPriceArrar["surcharge_amount"] = parseFloat(post_data["building"].surcharge_amount);
							post_data["building"].order_total = parseFloat(post_data["building"].order_total) + parseFloat(post_data["building"].surcharge_amount);
							const_var.BuildingPriceArrar["order_total"] = parseFloat(const_var.BuildingPriceArrar["order_total"]) + parseFloat(post_data["building"].surcharge_amount);
						}
					}
				}
			}
			post_data["building"].sub_order_total = parseFloat(post_data["building"].order_total);
			const_var.BuildingPriceArrar["sub_order_total"] = parseFloat(post_data["building"].order_total);
		}

		// ########################## calculate price of siding material starts from here ##########################
		selSidingObj = const_var.selSidingObj;
		if (const_var.mainSidingOptions && const_var.mainSidingOptions.length > 0 && selSidingObj && selSidingObj.price_type == "%" && selSidingObj.cost != 0 && selSidingObj.name != "metal") {
			post_data["building"].siding_name = const_var.selSidingOption;
			post_data["building"].siding_obj = const_var.selSidingObj;
			let splitVal = selSidingObj.price_of != undefined && selSidingObj.price_of.length > 0 ? selSidingObj.price_of : 0;
			let splval = 0;

			if (splitVal != 0) {
				if (splitVal.includes("full_building_price") != false) {
					if (
						parseFloat(const_var.wallsData["center"].closedEndWalls) != 0 ||
						parseFloat(const_var.wallsData["leftLean"].closedEndWalls) != 0 ||
						parseFloat(const_var.wallsData["rightLean"].closedEndWalls) != 0 ||
						parseFloat(const_var.wallsData["frontLean"].closedEndWalls) != 0 ||
						parseFloat(const_var.wallsData["backLean"].closedEndWalls) != 0 ||
						parseFloat(const_var.wallsData["center"].closedSideWalls) != 0 ||
						parseFloat(const_var.wallsData["leftLean"].closedSideWalls) != 0 ||
						parseFloat(const_var.wallsData["rightLean"].closedSideWalls) != 0 ||
						parseFloat(const_var.wallsData["frontLean"].closedSideWalls) != 0 ||
						parseFloat(const_var.wallsData["backLean"].closedSideWalls) != 0 ||
						params.p_c_p_l == true ||
						params.p_c_p_r == true
					) {
						splval = parseFloat(post_data["building"].order_total);
						let finalCost = (splval * selSidingObj.cost) / 100;
						let exactCost = finalCost % 1 == 0 ? finalCost : finalCost.toFixed(2);

						post_data["building"].siding_material_price =
							UpdatePriceRecord == true && const_var.check_siding_material_price == true ? const_var.UpdatedPriceData.siding_material_price : parseFloat(exactCost).toFixed(2);

						post_data["building"].order_total = parseFloat(post_data["building"].order_total) + parseFloat(post_data["building"].siding_material_price);
						const_var.BuildingPriceArrar["order_total"] = parseFloat(const_var.BuildingPriceArrar["order_total"]) + parseFloat(post_data["building"].siding_material_price);
						post_data["building"].sub_order_total = parseFloat(post_data["building"].order_total);
						const_var.BuildingPriceArrar["sub_order_total"] = parseFloat(post_data["building"].order_total);
					} else {
						post_data["building"].siding_material_price = 0;
					}
				}
			}
		} else {
			post_data["building"].siding_material_price = 0;
			const_var.check_siding_material_price = false;
		}

		const_var.offer_applied_name = "";
		const_var.checkLimit = false;
		const_var.checkPriceRangeValid = false;
		const_var.selectedDicountOfferobj = {};

		/************************************ MFG DISCOUNT START ******************* */
		manufacturerDiscountCalculation({
			post_data,
			const_var,
			params,
			extraItems,
			extra_items,
			utlis,
			isPrompt
		});
		/************************************       MFG DISCOUNT END       ******************* */

		if (isPrompt != undefined && const_var.checkLimit) {
			const_var.showAppliedButton = true;
		}
		if (post_data["building"].discount_type == "amt" && post_data["building"].discount_amount > post_data["building"].order_total) {
			post_data["building"].discount_rate = const_var.UpdatedPriceData.discount_rate;
			post_data["building"].discount_rate_updated = const_var.UpdatedPriceData.discount_rate;
			const_var.BuildingPriceArrar["discount_order_total"] = 0;
			post_data["building"].discount_amount = 0;
			post_data["building"].sub_order_total = const_var.BuildingPriceArrar["order_total"];
			const_var.BuildingPriceArrar["sub_order_total"] = const_var.BuildingPriceArrar["order_total"];
		} else {
			if (const_var.BuildingPriceArrar["discount_order_total"] >= const_var.BuildingPriceArrar["order_total"]) {
				const_var.BuildingPriceArrar["sub_order_total"] = 0;
			}
		}

		if (surcharge_by_mfg.length > 0) {
			post_data["building"].sub_order_total = parseFloat(post_data["building"].sub_order_total);
			const_var.BuildingPriceArrar["sub_order_total"] = parseFloat(post_data["building"].sub_order_total);

			if (CalculatesurchargeFees == undefined) {
				CalculatesurchargeFees = 0;
			} else {
				CalculatesurchargeFees = parseFloat(const_var.order_extra_items["surchargeFees"]);
			}

			if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"] != undefined && const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] == undefined) {
				if (const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"][params.m_s_n] != undefined) {
					const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] =
						const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"] != undefined && const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"][params.m_s_n].length > 0
							? const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"][params.m_s_n]
							: const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n];
				} else {
					const_var.stateManufacturerAcordingAPIDiscount["surcharge"] = [];
				}
			}
			let filterData = "";
			if (
				const_var.stateManufacturerAcordingAPIDiscount["surcharge"] != undefined &&
				const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] != undefined &&
				Object.keys(const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n]).length > 0
			) {
				if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].is_edit == undefined && const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"][params.m_s_n].length > 0) {
					let filterData1 = const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"][params.m_s_n].filter(
						(data) =>
							parseFloat(post_data["building"].roof_style_price) + parseFloat(leantoPriceCalculation.totalBasePrice) >= data.price_from &&
							parseFloat(post_data["building"].roof_style_price) + parseFloat(leantoPriceCalculation.totalBasePrice) <= data.price_to &&
							data.percentage_of == "basic_price"
					);
					filterData = const_var.stateManufacturerAcordingAPIDiscount["surchargeArray"][params.m_s_n].filter(
						(data) => post_data["building"].sub_order_total >= data.price_from && post_data["building"].sub_order_total <= data.price_to && data.percentage_of == "building_amount"
					);
					filterData = filterData1.length == 0 ? filterData : filterData1;
					let len = filterData.length - 1;
					const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] = filterData[len] != undefined ? filterData[len] : const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n];
					if (filterData.length == 0) {
						const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] = filterData.length == 0 ? undefined : const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n];
						if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] == undefined) {
							const_var.order_extra_items["surchargeFees"] = isNaN(parseFloat(const_var.order_extra_items["surchargeFees"])) == true ? 0 : const_var.order_extra_items["surchargeFees"];
						}
					}
				} else {
					const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] = const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n];
				}
				if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] != undefined) {
					const_var.UpdatedPriceData.surcharge_taxable = const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].taxable;
				}
			}
			post_data["building"].surcharge_amount = const_var.order_extra_items["surchargeFees"];
			if (
				const_var.stateManufacturerAcordingAPIDiscount["surcharge"] != undefined &&
				const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] != undefined &&
				const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] != 0 &&
				Object.keys(const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n]).length > 0
			) {
				if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].taxable == 1) {
					if (const_var.surcharge_amount_is_edit != undefined && const_var.surcharge_amount_is_edit == true) {
						const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].is_edit = true;
					}
					if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].is_edit == undefined) {
						const_var.order_extra_items["surchargeFees"] = 0;
						post_data["building"].surcharge_amount_type = const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount_type;
						if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount_type == "per") {
							if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].percentage_of == "building_amount") {
								post_data["building"].surcharge_percentage_of = const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].percentage_of;
								CalculatesurchargeFees = parseFloat(
									(parseFloat(const_var.BuildingPriceArrar["sub_order_total"]) * parseFloat(const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount)) / 100
								).toFixed(2);
							} else {
								if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].percentage_of == "basic_price") {
									post_data["building"].surcharge_percentage_of = const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].percentage_of;
									CalculatesurchargeFees = parseFloat(
										((parseFloat(post_data["building"].roof_style_price) + parseFloat(leantoPriceCalculation.totalBasePrice)) *
											parseFloat(const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount)) /
											100
									).toFixed(2);
								} else {
									CalculatesurchargeFees = parseFloat(
										(parseFloat(const_var.BuildingPriceArrar["sub_order_total"]) * parseFloat(const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount)) / 100
									).toFixed(2);
								}
							}
							post_data["building"].surcharge_calculate_amount = const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount;
						} else {
							post_data["building"].surcharge_calculate_amount = const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount;
							CalculatesurchargeFees = parseFloat(const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount);
						}
						CalculatesurchargeFees =
							const_var.UpdatedPriceData.surcharge_amount != undefined && const_var.crmSetting.is_Edit == true && const_var.checkPickThisBuilding == false
								? const_var.UpdatedPriceData.surcharge_amount
								: CalculatesurchargeFees;
					} else {
						CalculatesurchargeFees = parseFloat(CalculatesurchargeFees);
					}
					CalculatesurchargeFees = CalculatesurchargeFees;
					post_data["building"].surcharge_taxable =
						const_var.UpdatedPriceData.surcharge_taxable == undefined || const_var.UpdatedPriceData.surcharge_taxable == 0
							? const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].taxable
							: const_var.UpdatedPriceData.surcharge_taxable;
					post_data["building"].surcharge_amount = CalculatesurchargeFees;
					const_var.BuildingPriceArrar["surcharge_amount"] = parseFloat(post_data["building"].surcharge_amount);
					post_data["building"].sub_order_total = parseFloat(post_data["building"].sub_order_total) + parseFloat(post_data["building"].surcharge_amount);
					const_var.BuildingPriceArrar["sub_order_total"] = parseFloat(const_var.BuildingPriceArrar["sub_order_total"]) + parseFloat(post_data["building"].surcharge_amount);
					if (const_var.order_extra_items["surchargeFees"] == 0) {
						const_var.order_extra_items["surchargeFees"] = parseFloat(CalculatesurchargeFees);
					}
				} else {
					if (const_var.UpdatedPriceData.surcharge_taxable != undefined) {
						if (const_var.UpdatedPriceData.surcharge_taxable == 1) {
							CalculatesurchargeFees = parseFloat(CalculatesurchargeFees);
							post_data["building"].surcharge_taxable = const_var.UpdatedPriceData.surcharge_taxable;
							post_data["building"].surcharge_amount = CalculatesurchargeFees;
							const_var.BuildingPriceArrar["surcharge_amount"] = parseFloat(post_data["building"].surcharge_amount);
							post_data["building"].sub_order_total = parseFloat(post_data["building"].sub_order_total) + parseFloat(post_data["building"].surcharge_amount);
							const_var.BuildingPriceArrar["sub_order_total"] = parseFloat(const_var.BuildingPriceArrar["sub_order_total"]) + parseFloat(post_data["building"].surcharge_amount);
						}
					}
				}
			}
		}

		// ########################## calculate price of siding material starts from here ##########################

		selSidingObj = const_var.selSidingObj;
		if (const_var.mainSidingOptions && const_var.mainSidingOptions.length > 0 && selSidingObj && selSidingObj.price_type == "%" && selSidingObj.cost != 0 && selSidingObj.name != "metal") {
			post_data["building"].siding_name = const_var.selSidingOption;
			post_data["building"].siding_obj = const_var.selSidingObj;
			let splitVal = selSidingObj.price_of != undefined && selSidingObj.price_of.length > 0 ? selSidingObj.price_of : 0;
			let splval = 0;

			if (splitVal != 0) {
				if (splitVal.includes("sub_total_price") != false) {
					if (
						parseFloat(const_var.wallsData["center"].closedEndWalls) != 0 ||
						parseFloat(const_var.wallsData["leftLean"].closedEndWalls) != 0 ||
						parseFloat(const_var.wallsData["rightLean"].closedEndWalls) != 0 ||
						parseFloat(const_var.wallsData["frontLean"].closedEndWalls) != 0 ||
						parseFloat(const_var.wallsData["backLean"].closedEndWalls) != 0 ||
						parseFloat(const_var.wallsData["center"].closedSideWalls) != 0 ||
						parseFloat(const_var.wallsData["leftLean"].closedSideWalls) != 0 ||
						parseFloat(const_var.wallsData["rightLean"].closedSideWalls) != 0 ||
						parseFloat(const_var.wallsData["frontLean"].closedSideWalls) != 0 ||
						parseFloat(const_var.wallsData["backLean"].closedSideWalls) != 0 ||
						params.p_c_p_l == true ||
						params.p_c_p_r == true
					) {
						splval = parseFloat(post_data["building"].sub_order_total);

						let finalCost = (splval * selSidingObj.cost) / 100;
						let exactCost = finalCost % 1 == 0 ? finalCost : finalCost.toFixed(2);

						post_data["building"].siding_material_price =
							UpdatePriceRecord == true && const_var.check_siding_material_price == true ? const_var.UpdatedPriceData.siding_material_price : parseFloat(exactCost).toFixed(2);

						post_data["building"].order_total = parseFloat(post_data["building"].order_total) + parseFloat(post_data["building"].siding_material_price);
						const_var.BuildingPriceArrar["order_total"] = post_data["building"].order_total;
						post_data["building"].sub_order_total = parseFloat(post_data["building"].sub_order_total) + parseFloat(post_data["building"].siding_material_price);
						const_var.BuildingPriceArrar["sub_order_total"] = post_data["building"].sub_order_total;
					} else {
						post_data["building"].siding_material_price = 0;
					}
				}
			}
		} else {
			post_data["building"].siding_material_price = 0;
			const_var.check_siding_material_price = false;
		}

		// ########################## calculate price of wainscot siding end here ##########################

		const_var.BuildingPriceArrar["new_sub_order_total"] = 0;
		if (const_var.UpdatedPriceData.down_payment_rate_Updated == undefined) {
			let calVar = 10;

			if (const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n] != undefined && const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n].length > 0) {
				let FilterData = const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n].filter((data) => data.component == undefined || data.component == "building_amount");
				if (FilterData.length > 0) {
					for (var i = 0; i < FilterData.length; i++) {
						if (post_data["building"].order_total >= parseInt(FilterData[i].from) && post_data["building"].order_total <= parseInt(FilterData[i].to)) {
							calVar = FilterData[i].percentage;
							const_var.downPersentage = FilterData[i].percentage;

							post_data["building"].down_payment_total = ((post_data["building"].sub_order_total * const_var.downPersentage) / 100).toFixed(2);

							post_data["building"].down_payment_rate = const_var.downPersentage;
							post_data["building"].down_payment_type = "per";
							post_data["building"].down_payment_discount_type = const_var.UpdatedPriceData.down_payment_discount_type != undefined ? const_var.UpdatedPriceData.down_payment_discount_type : "per";

							post_data["building"].discount_type = const_var.UpdatedPriceData.discount_type != undefined ? const_var.UpdatedPriceData.discount_type : "per";
							post_data["building"].dealer_deposit = (post_data["building"].sub_order_total * const_var.downPersentage) / 100;
							const_var.BuildingPriceArrar["down_payment_total"] = (parseFloat(const_var.BuildingPriceArrar["sub_order_total"]) * parseFloat(const_var.downPersentage)) / 100;
							const_var.BuildingPriceArrar["dealer_deposit"] = (parseFloat(const_var.BuildingPriceArrar["sub_order_total"]) * parseFloat(const_var.downPersentage)) / 100;
							const_var.BuildingPriceArrar["new_sub_order_total"] = parseFloat(const_var.BuildingPriceArrar["sub_order_total"]) - parseFloat(const_var.BuildingPriceArrar["down_payment_total"]);
						} else {
							const_var.downPersentage = calVar;

							post_data["building"].down_payment_rate = const_var.downPersentage;
							post_data["building"].down_payment_type = "per";
							post_data["building"].down_payment_discount_type = const_var.UpdatedPriceData.down_payment_discount_type != undefined ? const_var.UpdatedPriceData.down_payment_discount_type : "per";

							post_data["building"].down_payment_total = ((post_data["building"].sub_order_total * const_var.downPersentage) / 100).toFixed(2);

							post_data["building"].discount_type = const_var.UpdatedPriceData.discount_type != undefined ? const_var.UpdatedPriceData.discount_type : "per";
							post_data["building"].dealer_deposit = (post_data["building"].sub_order_total * const_var.downPersentage) / 100;
							const_var.BuildingPriceArrar["down_payment_total"] = (parseFloat(const_var.BuildingPriceArrar["sub_order_total"]) * parseFloat(const_var.downPersentage)) / 100;
							const_var.BuildingPriceArrar["dealer_deposit"] = (parseFloat(const_var.BuildingPriceArrar["sub_order_total"]) * parseFloat(const_var.downPersentage)) / 100;
							const_var.BuildingPriceArrar["new_sub_order_total"] = parseFloat(const_var.BuildingPriceArrar["sub_order_total"]) - parseFloat(const_var.BuildingPriceArrar["down_payment_total"]);
						}
					}
				} else {
					const_var.downPersentage = 10;
					post_data["building"].down_payment_total = ((post_data["building"].sub_order_total * const_var.downPersentage) / 100).toFixed(2); //((parseFloat(post_data['building'].sub_order_total) * parseFloat(const_var.downPersentage) )/100).toFixed(2);
					post_data["building"].down_payment_rate = const_var.downPersentage;
					post_data["building"].down_payment_type = "per";
					post_data["building"].down_payment_discount_type = const_var.UpdatedPriceData.down_payment_discount_type != undefined ? const_var.UpdatedPriceData.down_payment_discount_type : "per";
					post_data["building"].discount_type = const_var.UpdatedPriceData.discount_type != undefined ? const_var.UpdatedPriceData.discount_type : "per";
					post_data["building"].dealer_deposit = (post_data["building"].sub_order_total * const_var.downPersentage) / 100;
					const_var.BuildingPriceArrar["down_payment_total"] = (parseFloat(const_var.BuildingPriceArrar["sub_order_total"]) * parseFloat(const_var.downPersentage)) / 100;
					const_var.BuildingPriceArrar["dealer_deposit"] = (parseFloat(const_var.BuildingPriceArrar["sub_order_total"]) * parseFloat(const_var.downPersentage)) / 100;
					const_var.BuildingPriceArrar["new_sub_order_total"] = parseFloat(const_var.BuildingPriceArrar["sub_order_total"]) - parseFloat(const_var.BuildingPriceArrar["down_payment_total"]);
				}
			} else {
				const_var.downPersentage = 10;
				post_data["building"].down_payment_total = ((post_data["building"].sub_order_total * const_var.downPersentage) / 100).toFixed(2); //((parseFloat(post_data['building'].sub_order_total) * parseFloat(const_var.downPersentage) )/100).toFixed(2);
				post_data["building"].down_payment_rate = const_var.downPersentage;
				post_data["building"].down_payment_type = "per";
				post_data["building"].down_payment_discount_type = const_var.UpdatedPriceData.down_payment_discount_type != undefined ? const_var.UpdatedPriceData.down_payment_discount_type : "per";
				post_data["building"].discount_type = const_var.UpdatedPriceData.discount_type != undefined ? const_var.UpdatedPriceData.discount_type : "per";
				post_data["building"].dealer_deposit = (post_data["building"].sub_order_total * const_var.downPersentage) / 100;
				const_var.BuildingPriceArrar["down_payment_total"] = (parseFloat(const_var.BuildingPriceArrar["sub_order_total"]) * parseFloat(const_var.downPersentage)) / 100;
				const_var.BuildingPriceArrar["dealer_deposit"] = (parseFloat(const_var.BuildingPriceArrar["sub_order_total"]) * parseFloat(const_var.downPersentage)) / 100;
				const_var.BuildingPriceArrar["new_sub_order_total"] = parseFloat(const_var.BuildingPriceArrar["sub_order_total"]) - parseFloat(const_var.BuildingPriceArrar["down_payment_total"]);
			}
		} else {
			if (const_var.UpdatedPriceData.down_payment_rate == undefined && const_var.UpdatedPriceData.down_payment_rate_Updated != undefined) {
				const_var.UpdatedPriceData.down_payment_rate = Boolean(const_var.UpdatedPriceData.down_payment_rate_Updated) ? 10 : const_var.UpdatedPriceData.down_payment_rate_Updated;
			}
			post_data["building"].down_payment_total =
				const_var.UpdatedPriceData.down_payment_type == "amt"
					? const_var.UpdatedPriceData.down_payment_rate
					: ((post_data["building"].sub_order_total * const_var.UpdatedPriceData.down_payment_rate) / 100).toFixed(2);
			post_data["building"].down_payment_rate = const_var.UpdatedPriceData.down_payment_rate;
			post_data["building"].down_payment_rate_Updated = const_var.UpdatedPriceData.down_payment_rate;
			post_data["building"].down_payment_type = const_var.UpdatedPriceData.down_payment_type;
			post_data["building"].dealer_deposit =
				const_var.UpdatedPriceData.down_payment_type == "amt" ? const_var.UpdatedPriceData.down_payment_rate : (post_data["building"].sub_order_total * const_var.UpdatedPriceData.down_payment_rate) / 100;
			const_var.BuildingPriceArrar["down_payment_total"] =
				const_var.UpdatedPriceData.down_payment_type == "amt"
					? parseFloat(const_var.UpdatedPriceData.down_payment_rate)
					: (parseFloat(const_var.BuildingPriceArrar["sub_order_total"]) * parseFloat(const_var.UpdatedPriceData.down_payment_rate)) / 100;
			const_var.BuildingPriceArrar["dealer_deposit"] =
				const_var.UpdatedPriceData.down_payment_type == "amt"
					? parseFloat(const_var.UpdatedPriceData.down_payment_rate)
					: (parseFloat(const_var.BuildingPriceArrar["sub_order_total"]) * parseFloat(const_var.UpdatedPriceData.down_payment_rate)) / 100;
			const_var.BuildingPriceArrar["new_sub_order_total"] = parseFloat(const_var.BuildingPriceArrar["sub_order_total"]) - parseFloat(const_var.BuildingPriceArrar["down_payment_total"]);
		}
		if (const_var.UpdatedPriceData.custom_insulation_down_payment_rate == undefined) {
			if (
				const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n] != undefined &&
				const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n].length > 0 &&
				const_var.thirdPartyComponent?.commissions?.insulation?.incArrayCategory?.length > 0
			) {
				for (var i = 0; i < const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n].length; i++) {
					if (
						const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].category != undefined ||
						(const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].category != null &&
							const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].category == params.selectedInsulationId)
					) {
						if (const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].component == "insulation") {
							if (params.selectedInsulationId != 0) {
								if (const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].category == params.selectedInsulationId) {
									let totalInsulationPrice = p_c_i == true ? parseFloat(leanToTotalInsultaionPrice) : parseFloat(post_data["building"].insulation_price);

									let comName = const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].component;
									if (params.p_i_o) {
										let centerBuildingInc = const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n].filter((per) => {
											return per.category == params.p_i_o;
										});
										post_data["building"].custom_insulation_percentage =
											centerBuildingInc.length > 0
												? parseFloat(centerBuildingInc[0].percentage)
												: parseFloat(const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].percentage);
									} else {
										post_data["building"].custom_insulation_percentage = parseFloat(const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].percentage);
									}
									post_data["building"].custom_insulation_down_payment_total = ((parseFloat(totalInsulationPrice) * parseFloat(post_data["building"].custom_insulation_percentage)) / 100).toFixed(2);

									post_data["building"].custom_insulation_total_amount = parseFloat(totalInsulationPrice).toFixed(2);

									post_data["building"].custom_insulation_down_payment_rate = post_data["building"].custom_insulation_percentage;
									post_data["building"].custom_insulation_down_payment_type = "per";
									post_data["building"].custom_insulation_down_payment_category = const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].category;
									post_data["building"].custom_insulation_down_payment_from = const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].from;
									post_data["building"].custom_insulation_down_payment_to = const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].to;
									post_data["building"].custom_insulation_down_payment_component = const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].component;
									const_var.BuildingPriceArrar["insulation_calculation"] = {
										custom_insulation_total_amount: post_data["building"].custom_insulation_total_amount,
										custom_insulation_down_payment_total: post_data["building"].custom_insulation_down_payment_total,
										custom_insulation_down_payment_rate: post_data["building"].custom_insulation_down_payment_rate,
										custom_insulation_down_payment_category: post_data["building"].custom_insulation_down_payment_category,
										custom_insulation_down_payment_type: post_data["building"].custom_insulation_down_payment_type
									};
								}
							}
						}
					} else {
						if (const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].component == "insulation") {
							if (params.selectedInsulationId != 0) {
								let totalInsulationPrice = p_c_i == true ? parseFloat(leanToTotalInsultaionPrice) : parseFloat(post_data["building"].insulation_price);
								let comName = const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].component;
								post_data["building"].custom_insulation_percentage = parseFloat(const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].percentage);
								post_data["building"].custom_insulation_down_payment_total = ((parseFloat(totalInsulationPrice) * parseFloat(post_data["building"].custom_insulation_percentage)) / 100).toFixed(2);

								post_data["building"].custom_insulation_total_amount = parseFloat(totalInsulationPrice).toFixed(2);

								post_data["building"].custom_insulation_down_payment_rate = post_data["building"].custom_insulation_percentage;
								post_data["building"].custom_insulation_down_payment_type = "per";
								post_data["building"].custom_insulation_down_payment_category = const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].category;
								post_data["building"].custom_insulation_down_payment_from = const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].from;
								post_data["building"].custom_insulation_down_payment_to = const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].to;
								post_data["building"].custom_insulation_down_payment_component = const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].component;
								const_var.BuildingPriceArrar["insulation_calculation"] = {
									custom_insulation_total_amount: post_data["building"].custom_insulation_total_amount,
									custom_insulation_down_payment_total: post_data["building"].custom_insulation_down_payment_total,
									custom_insulation_down_payment_rate: post_data["building"].custom_insulation_down_payment_rate,
									custom_insulation_down_payment_category: post_data["building"].custom_insulation_down_payment_category,
									custom_insulation_down_payment_type: post_data["building"].custom_insulation_down_payment_type
								};
							}
						}
					}
				}
			}
		} else {
			if (params.selectedInsulationId != 0 && const_var.thirdPartyComponent?.commissions?.insulation?.incArrayCategory?.length > 0) {
				let chkExistingData = "";
				if (const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n] != undefined && const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n].length > 0) {
					chkExistingData = const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n].filter((data) => data.category != undefined && data.component == "insulation");
				}
				if (chkExistingData.length > 0 && const_var.thirdPartyComponent?.commissions?.insulation?.incArrayCategory?.length > 0) {
					let chkExistingDataCat = const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n].filter((data) => data.category == params.selectedInsulationId);
					let totalInsulationPrice = p_c_i == true ? parseFloat(leanToTotalInsultaionPrice) : parseFloat(post_data["building"].insulation_price);
					if (chkExistingDataCat.length > 0 && totalInsulationPrice >= parseInt(chkExistingDataCat[0].from) && totalInsulationPrice <= parseInt(chkExistingDataCat[0].to)) {
						if (const_var.UpdatedPriceData.custom_insulation_down_payment_rate == undefined && const_var.UpdatedPriceData.custom_insulation_down_payment_rate != undefined) {
							const_var.UpdatedPriceData.custom_insulation_down_payment_rate = const_var.UpdatedPriceData.custom_insulation_down_payment_rate;
						}

						post_data["building"].custom_insulation_percentage = parseFloat(const_var.UpdatedPriceData.custom_insulation_down_payment_rate);
						post_data["building"].custom_insulation_total_amount = parseFloat(totalInsulationPrice).toFixed(2);
						post_data["building"].custom_insulation_down_payment_total =
							const_var.UpdatedPriceData.custom_insulation_down_payment_type == "amt"
								? const_var.UpdatedPriceData.custom_insulation_down_payment_rate
								: ((post_data["building"].custom_insulation_total_amount * const_var.UpdatedPriceData.custom_insulation_down_payment_rate) / 100).toFixed(2);
						post_data["building"].custom_insulation_down_payment_rate = const_var.UpdatedPriceData.custom_insulation_down_payment_rate;
						post_data["building"].custom_insulation_down_payment_type = const_var.UpdatedPriceData.custom_insulation_down_payment_type;
						post_data["building"].custom_insulation_down_payment_category = const_var.UpdatedPriceData.custom_insulation_down_payment_type.category;
						post_data["building"].custom_insulation_down_payment_from = const_var.UpdatedPriceData.custom_insulation_down_payment_type.from;
						post_data["building"].custom_insulation_down_payment_to = const_var.UpdatedPriceData.custom_insulation_down_payment_type.to;
						post_data["building"].custom_insulation_down_payment_component = const_var.UpdatedPriceData.custom_insulation_down_payment_type.component;
						const_var.BuildingPriceArrar["insulation_calculation"] = {
							custom_insulation_total_amount: post_data["building"].custom_insulation_total_amount,
							custom_insulation_down_payment_total: post_data["building"].custom_insulation_down_payment_total,
							custom_insulation_down_payment_rate: post_data["building"].custom_insulation_down_payment_rate,
							custom_insulation_down_payment_category: post_data["building"].custom_insulation_down_payment_category,
							custom_insulation_down_payment_type: post_data["building"].custom_insulation_down_payment_type
						};
					}
				}
			}
		}
		if (const_var.entry_points?.length > 0 && const_var.entry_points?.length > 0 && commissionArray?.filter((item) => item.component == "garage_doors")?.length > 0) {
			let componentCommissionPrice = MayberryCommissionCal(
				"garage_doors",
				const_var.entry_points,
				commissionArray?.filter((item) => item.component == "garage_doors")
			);
		} else if (const_var.entry_points?.length == 0) {
			const_var.thirdPartyComponent.commissions.garage = {};
			const_var.thirdPartyComponent.surcharge.garage = {};
			const_var.thirdPartyComponent.tax.garage = {};
		}

		if (const_var.UpdatedPriceData.custom_overhead_down_payment_rate == undefined) {
			if (const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n] != undefined && const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n].length > 0) {
				for (var i = 0; i < const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n].length; i++) {
					if (
						const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].category != undefined ||
						const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].category != null
					) {
						if (const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].component == "garage_doors") {
							if (const_var.entry_points.length > 0) {
								const sumOfEvens = const_var.entry_points.reduce((accumulator, currentValue) => {
									if (currentValue.child_array_key === const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].category) {
										if (
											const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].sub_category == null ||
											(const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].sub_category != null &&
												const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].sub_category.length > 0 &&
												currentValue.nested_array_key != undefined &&
												const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].sub_category.indexOf(currentValue.nested_array_key) != -1)
										) {
											return parseFloat(accumulator) + parseFloat(currentValue.overheadDoorSum || 0);
										} else {
											return parseFloat(accumulator);
										}
									} else {
										return parseFloat(accumulator);
									}
								}, 0);
								if (sumOfEvens != 0) {
									let subCat = const_var.thirdPartyComponent?.commissions?.garage?.doorsCategory?.reduce((acc, val) => acc.concat(val), []);

									if (subCat.length > 0) {
										let comName = const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].component;
										post_data["building"].custom_overhead_percentage = parseFloat(const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].percentage);
										post_data["building"].custom_overhead_down_payment_total = ((parseFloat(sumOfEvens) * parseFloat(post_data["building"].custom_overhead_percentage)) / 100).toFixed(2);

										post_data["building"].custom_overhead_total_amount = parseFloat(sumOfEvens).toFixed(2);
										post_data["building"].custom_overhead_down_payment_rate = post_data["building"].custom_overhead_percentage;
										post_data["building"].custom_overhead_down_payment_type = "per";
										post_data["building"].custom_overhead_down_payment_category = const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].category;
										post_data["building"].custom_overhead_down_payment_from = const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].from;
										post_data["building"].custom_overhead_down_payment_to = const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].to;
										post_data["building"].custom_overhead_down_payment_component = const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].component;
										const_var.BuildingPriceArrar["overhead_door_calculation"] = {
											custom_overhead_total_amount: post_data["building"].custom_overhead_total_amount,
											custom_overhead_down_payment_total: post_data["building"].custom_overhead_down_payment_total,
											custom_overhead_down_payment_rate: post_data["building"].custom_overhead_down_payment_rate,
											custom_overhead_down_payment_category: post_data["building"].custom_overhead_down_payment_category,
											custom_overhead_down_payment_type: post_data["building"].custom_overhead_down_payment_type,
											category: const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].category,
											sub_category: const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n][i].sub_category
										};
									}
								}
							}
						}
					}
				}
			}
		} else {
			if (const_var.entry_points.length > 0) {
				let chkExistingData = "";
				if (const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n] != undefined && const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n].length > 0) {
					chkExistingData = const_var.stateManufacturerAcordingAPIDiscount["commissions"][params.m_s_n].filter((data) => data.component != undefined && data.component == "garage_doors");
				}
				if (chkExistingData.length > 0) {
					const sumOfEvens = const_var.entry_points.reduce((accumulator, currentValue) => {
						if (currentValue.child_array_key == chkExistingData[0].category) {
							if (
								chkExistingData[0].sub_category == null ||
								(chkExistingData[0].sub_category != null &&
									chkExistingData[0].sub_category.length > 0 &&
									currentValue.nested_array_key != undefined &&
									chkExistingData[0].sub_category.indexOf(currentValue.nested_array_key) != -1)
							) {
								return parseFloat(accumulator) + parseFloat(currentValue.overheadDoorSum || 0);
							} else {
								return parseFloat(accumulator);
							}
						} else {
							return parseFloat(accumulator);
						}
					}, 0);
					if (sumOfEvens != 0) {
						if (const_var.UpdatedPriceData.custom_overhead_down_payment_rate == undefined && const_var.UpdatedPriceData.custom_overhead_down_payment_rate != undefined) {
							const_var.UpdatedPriceData.custom_overhead_down_payment_rate = const_var.UpdatedPriceData.custom_overhead_down_payment_rate;
						}
						post_data["building"].custom_overhead_percentage = parseFloat(const_var.UpdatedPriceData.custom_overhead_down_payment_rate);

						post_data["building"].custom_overhead_total_amount = parseFloat(sumOfEvens).toFixed(2);
						post_data["building"].custom_overhead_down_payment_total =
							const_var.UpdatedPriceData.custom_overhead_down_payment_type == "amt"
								? const_var.UpdatedPriceData.custom_overhead_down_payment_rate
								: ((post_data["building"].custom_overhead_total_amount * const_var.UpdatedPriceData.custom_overhead_down_payment_rate) / 100).toFixed(2);
						post_data["building"].custom_overhead_down_payment_rate = const_var.UpdatedPriceData.custom_overhead_down_payment_rate;
						post_data["building"].custom_overhead_down_payment_type = const_var.UpdatedPriceData.custom_overhead_down_payment_type;
						post_data["building"].custom_overhead_down_payment_category =
							const_var.UpdatedPriceData.custom_overhead_down_payment_category != undefined ? const_var.UpdatedPriceData.custom_overhead_down_payment_category : chkExistingData[0].category;
						post_data["building"].custom_overhead_down_payment_from =
							const_var.UpdatedPriceData.custom_overhead_down_payment_from != undefined ? const_var.UpdatedPriceData.custom_overhead_down_payment_from : chkExistingData[0].from;
						post_data["building"].custom_overhead_down_payment_to =
							const_var.UpdatedPriceData.custom_overhead_down_payment_to != undefined ? const_var.UpdatedPriceData.custom_overhead_down_payment_to : chkExistingData[0].to;
						post_data["building"].custom_overhead_down_payment_component =
							const_var.UpdatedPriceData.custom_overhead_down_payment_component != undefined ? const_var.UpdatedPriceData.custom_overhead_down_payment_component : chkExistingData[0].component;
						const_var.BuildingPriceArrar["overhead_door_calculation"] = {
							custom_overhead_total_amount: post_data["building"].custom_overhead_total_amount,
							custom_overhead_down_payment_total: post_data["building"].custom_overhead_down_payment_total,
							custom_overhead_down_payment_rate: post_data["building"].custom_overhead_down_payment_rate,
							custom_overhead_down_payment_category: post_data["building"].custom_overhead_down_payment_category,
							custom_overhead_down_payment_type: post_data["building"].custom_overhead_down_payment_type,
							category: chkExistingData[0].category,
							sub_category: chkExistingData[0].sub_category
						};
					}
				}
			}
		}
		const_var.BuildingPriceArrar["custom_subTotal"] = 0;
		const_var.BuildingPriceArrar["custom_down_payment_total"] = 0;
		const_var.BuildingPriceArrar["insulation_tax_price"] = 0;
		const_var.BuildingPriceArrar["overhead_tax_price"] = 0;
		if (const_var.BuildingPriceArrar["overhead_door_calculation"] != undefined) {
			post_data["building"].overhead_door_calculation = const_var.BuildingPriceArrar["overhead_door_calculation"];
		}
		if (const_var.BuildingPriceArrar["insulation_calculation"] != undefined) {
			post_data["building"].insulation_calculation = const_var.BuildingPriceArrar["insulation_calculation"];
		}

		if (const_var.BuildingPriceArrar["insulation_calculation"] != undefined || const_var.BuildingPriceArrar["overhead_door_calculation"] != undefined) {
			let excludeBuildingAmaount = 0;

			if (const_var.BuildingPriceArrar["insulation_calculation"] != undefined) {
				excludeBuildingAmaount = parseFloat(excludeBuildingAmaount) + parseFloat(const_var.BuildingPriceArrar["insulation_calculation"].custom_insulation_total_amount);
			}
			if (const_var.BuildingPriceArrar["overhead_door_calculation"] != undefined) {
				excludeBuildingAmaount = parseFloat(excludeBuildingAmaount) + parseFloat(const_var.BuildingPriceArrar["overhead_door_calculation"].custom_overhead_total_amount);
			}
			const_var.BuildingPriceArrar["custom_subTotal"] = convertToTwoDecimalNumber(parseFloat(excludeBuildingAmaount));
			if (const_var.BuildingPriceArrar["down_payment_total"] != undefined) {
				let excludeDownpaymentAmaount = 0;
				if (const_var.BuildingPriceArrar["insulation_calculation"] != undefined || const_var.BuildingPriceArrar["overhead_door_calculation"] != undefined) {
					if (const_var.BuildingPriceArrar["insulation_calculation"] != undefined) {
						excludeDownpaymentAmaount = parseFloat(excludeDownpaymentAmaount) + parseFloat(const_var.BuildingPriceArrar["insulation_calculation"].custom_insulation_down_payment_total);
					}
					if (const_var.BuildingPriceArrar["overhead_door_calculation"] != undefined) {
						excludeDownpaymentAmaount = parseFloat(excludeDownpaymentAmaount) + parseFloat(const_var.BuildingPriceArrar["overhead_door_calculation"].custom_overhead_down_payment_total);
					}
					const_var.BuildingPriceArrar["custom_down_payment_total"] = convertToTwoDecimalNumber(parseFloat(excludeDownpaymentAmaount));
				}
			}
		}

		const_var.BuildingPriceArrar["new_down_payment_total"] = parseFloat(post_data["building"].down_payment_total);
		if (const_var.UpdatedPriceData.down_payment_discount_rate_Updated == undefined) {
			if (
				const_var.stateManufacturerAcordingAPIDiscount["discount"][params.m_s_n] != undefined &&
				const_var.stateManufacturerAcordingAPIDiscount["discount"][params.m_s_n].length > 0 &&
				const_var.stateManufacturerAcordingAPIDiscount["discount"][params.m_s_n].dealer_discount != ""
			) {
				let checkMFGDiscount = false;
				let filterDataForDiscount = const_var.stateManufacturerAcordingAPIDiscount["discount"][params.m_s_n].filter(
					(data) => post_data["building"].order_total >= parseInt(data.from) && post_data["building"].order_total <= parseInt(data.to)
				);
				if (filterDataForDiscount.length > 0) {
					for (var i = 0; i < filterDataForDiscount.length; i++) {
						if (post_data["building"].order_total >= parseInt(filterDataForDiscount[i].from) && post_data["building"].order_total <= parseInt(filterDataForDiscount[i].to)) {
							checkMFGDiscount = true;
							let percentage = filterDataForDiscount[i].dealer_discount;
							if (percentage != undefined && post_data["building"].down_payment_total != undefined && parseFloat(percentage) > parseFloat(post_data["building"].down_payment_total)) {
								post_data["building"].down_payment_discount_type = "per";
								post_data["building"].down_payment_discount_rate = 0;
								post_data["building"].down_payment_discount_total = 0;
								const_var.UpdatedPriceData["down_payment_discount_total"] = 0;
								const_var.UpdatedPriceData["down_payment_discount_rate"] = 0;
								const_var.BuildingPriceArrar["down_payment_discount_total"] = 0;
							} else {
								post_data["building"].down_payment_discount_rate = percentage;
								post_data["building"].down_payment_discount_type = filterDataForDiscount[i].dealer_discount_in == "%" ? "per" : "amt";
								const_var.UpdatedPriceData.down_payment_discount_type = post_data["building"].down_payment_discount_type;
								post_data["building"].down_payment_discount_total =
									post_data["building"].down_payment_discount_type == "amt" ? parseFloat(percentage) : ((parseFloat(post_data["building"].down_payment_total) * parseFloat(percentage)) / 100).toFixed(2);
								const_var.BuildingPriceArrar["down_payment_discount_total"] =
									post_data["building"].down_payment_discount_type == "amt"
										? parseFloat(percentage)
										: parseFloat(parseFloat(const_var.BuildingPriceArrar["down_payment_total"]) * parseFloat(percentage)) / 100;
								const_var.BuildingPriceArrar["new_down_payment_total"] =
									parseFloat(const_var.BuildingPriceArrar["down_payment_total"]) - parseFloat(const_var.BuildingPriceArrar["down_payment_discount_total"]);
							}
						} else {
							if (checkMFGDiscount == false && post_data["building"].order_total > parseInt(filterDataForDiscount[i].from) && post_data["building"].order_total > parseInt(filterDataForDiscount[i].to)) {
								let percentage = 0;
								post_data["building"].down_payment_discount_rate = percentage;
								post_data["building"].down_payment_discount_type = const_var.UpdatedPriceData.down_payment_discount_type != undefined ? const_var.UpdatedPriceData.down_payment_discount_type : "per";
								post_data["building"].down_payment_discount_total =
									post_data["building"].down_payment_discount_type == "amt" ? parseFloat(percentage) : ((parseFloat(post_data["building"].down_payment_total) * parseFloat(percentage)) / 100).toFixed(2);
								const_var.BuildingPriceArrar["down_payment_discount_total"] =
									post_data["building"].down_payment_discount_type == "amt"
										? parseFloat(percentage)
										: parseFloat(parseFloat(const_var.BuildingPriceArrar["down_payment_total"]) * parseFloat(percentage)) / 100;
								const_var.BuildingPriceArrar["new_down_payment_total"] =
									parseFloat(const_var.BuildingPriceArrar["down_payment_total"]) - parseFloat(const_var.BuildingPriceArrar["down_payment_discount_total"]);
							} else {
								if (checkMFGDiscount == false) {
									let percentage = 0;
									post_data["building"].down_payment_discount_rate = percentage;
									post_data["building"].down_payment_discount_type = const_var.UpdatedPriceData.down_payment_discount_type != undefined ? const_var.UpdatedPriceData.down_payment_discount_type : "per";
									post_data["building"].down_payment_discount_total =
										post_data["building"].down_payment_discount_type == "amt"
											? parseFloat(percentage)
											: ((parseFloat(post_data["building"].down_payment_total) * parseFloat(percentage)) / 100).toFixed(2);
									const_var.BuildingPriceArrar["down_payment_discount_total"] =
										post_data["building"].down_payment_discount_type == "amt"
											? parseFloat(percentage)
											: parseFloat(parseFloat(const_var.BuildingPriceArrar["down_payment_total"]) * parseFloat(percentage)) / 100;
									const_var.BuildingPriceArrar["new_down_payment_total"] =
										parseFloat(const_var.BuildingPriceArrar["down_payment_total"]) - parseFloat(const_var.BuildingPriceArrar["down_payment_discount_total"]);
								}
							}
						}
					}
				} else {
					if (checkMFGDiscount == false) {
						let percentage = 0;
						post_data["building"].down_payment_discount_rate = percentage;
						post_data["building"].down_payment_discount_type = const_var.UpdatedPriceData.down_payment_discount_type != undefined ? const_var.UpdatedPriceData.down_payment_discount_type : "per";
						post_data["building"].down_payment_discount_total =
							post_data["building"].down_payment_discount_type == "amt" ? parseFloat(percentage) : ((parseFloat(post_data["building"].down_payment_total) * parseFloat(percentage)) / 100).toFixed(2);
						const_var.BuildingPriceArrar["down_payment_discount_total"] =
							post_data["building"].down_payment_discount_type == "amt" ? parseFloat(percentage) : parseFloat(parseFloat(const_var.BuildingPriceArrar["down_payment_total"]) * parseFloat(percentage)) / 100;
						const_var.BuildingPriceArrar["new_down_payment_total"] = parseFloat(const_var.BuildingPriceArrar["down_payment_total"]) - parseFloat(const_var.BuildingPriceArrar["down_payment_discount_total"]);
					}
				}
			} else {
				let percentage = 0;
				post_data["building"].down_payment_discount_rate = percentage;
				post_data["building"].down_payment_discount_type = const_var.UpdatedPriceData.down_payment_discount_type != undefined ? const_var.UpdatedPriceData.down_payment_discount_type : "per";
				post_data["building"].down_payment_discount_total =
					post_data["building"].down_payment_discount_type == "amt" ? parseFloat(percentage) : ((parseFloat(post_data["building"].down_payment_total) * parseFloat(percentage)) / 100).toFixed(2);
				const_var.BuildingPriceArrar["down_payment_discount_total"] =
					post_data["building"].down_payment_discount_type == "amt" ? parseFloat(percentage) : parseFloat(parseFloat(const_var.BuildingPriceArrar["down_payment_total"]) * parseFloat(percentage)) / 100;
				const_var.BuildingPriceArrar["new_down_payment_total"] = parseFloat(const_var.BuildingPriceArrar["down_payment_total"]) - parseFloat(const_var.BuildingPriceArrar["down_payment_discount_total"]);
			}
		} else {
			if (const_var.UpdatedPriceData.down_payment_discount_type == undefined) {
				post_data["building"].down_payment_discount_type = "per";
			}
			post_data["building"].down_payment_discount_total =
				const_var.UpdatedPriceData.down_payment_discount_type == "amt"
					? const_var.UpdatedPriceData.down_payment_discount_rate
					: ((parseFloat(post_data["building"].down_payment_total) * parseFloat(const_var.UpdatedPriceData.down_payment_discount_rate)) / 100).toFixed(2);
			post_data["building"].down_payment_discount_rate = const_var.UpdatedPriceData.down_payment_discount_rate;
			post_data["building"].down_payment_discount_rate_Updated = const_var.UpdatedPriceData.down_payment_discount_rate;
			post_data["building"].down_payment_discount_type = const_var.UpdatedPriceData.down_payment_discount_type;
			const_var.BuildingPriceArrar["down_payment_discount_total"] =
				post_data["building"].down_payment_discount_type == "amt"
					? parseFloat(const_var.UpdatedPriceData.down_payment_discount_rate)
					: parseFloat(parseFloat(const_var.BuildingPriceArrar["down_payment_total"]) * parseFloat(const_var.UpdatedPriceData.down_payment_discount_rate)) / 100;
			const_var.BuildingPriceArrar["new_down_payment_total"] = parseFloat(const_var.BuildingPriceArrar["down_payment_total"]) - parseFloat(const_var.BuildingPriceArrar["down_payment_discount_total"]);
		}
		if (post_data["building"].discount_type == undefined) {
			post_data["building"].discount_type = const_var.UpdatedPriceData.discount_type != undefined ? const_var.UpdatedPriceData.discount_type : "per";
		}
		if (post_data["building"].discount_rate == undefined) {
			post_data["building"].discount_rate = const_var.UpdatedPriceData.discount_rate != undefined ? const_var.UpdatedPriceData.discount_rate : 0;
		}
		if (post_data["building"].discount_amount == undefined) {
			post_data["building"].discount_amount = const_var.UpdatedPriceData.discount_amount != undefined ? const_var.UpdatedPriceData.discount_amount : 0;
		}

		if (post_data["building"].down_payment_discount_type == undefined) {
			post_data["building"].down_payment_discount_type = const_var.UpdatedPriceData.down_payment_discount_type != undefined ? const_var.UpdatedPriceData.down_payment_discount_type : "per";
		}
		if (post_data["building"].down_payment_discount_total == undefined) {
			post_data["building"].down_payment_discount_total = const_var.UpdatedPriceData.down_payment_discount_total != undefined ? const_var.UpdatedPriceData.down_payment_discount_total : 0;
		}
		if (post_data["building"].down_payment_discount_rate == undefined) {
			post_data["building"].down_payment_discount_rate = const_var.UpdatedPriceData.down_payment_discount_rate != undefined ? const_var.UpdatedPriceData.down_payment_discount_rate : 0;
		}
		if (const_var.tax.type == "%") {
			const_var.tax.type = "per";
		}
		if (const_var.tax.type == "$") {
			const_var.tax.type = "amt";
		}

		post_data["building"].grand_total = parseFloat(post_data["building"].order_total);
		const_var.BuildingPriceArrar["labor_fee"] = 0;
		if (const_var.order_extra_items != undefined) {
			let cal_labor_fee = 0;
			let checkFeesCalculation = true;
			let orderTotalForLaborFee = post_data["building"].order_total;
			let added_building_labor_fee = 0;
			if (const_var.loginSession == false && const_var.stateManufacturerAcordingAPI[params.p_s_n].is_labor_show_in_3d != true) {
				checkFeesCalculation = false;
			}
			if (checkFeesCalculation && params.m_s_n == 178 && const_var.order_extra_items["labor_fee_on"] != null && const_var.defaultBuildingImgName != "Custom_Buildings") {
				if (utlis.isNumberInRange(const_var.setCustomRangeR_and_B[params.p_r_s].width, params.p_w, "width") != null) {
					let rangeValue = utlis.isNumberInRange(const_var.setCustomRangeR_and_B[params.p_r_s].height, params.p_h, "height");
					if (rangeValue != null) {
						const_var.order_extra_items["labor_per_type"] = rangeValue;
					}
				}
				if (params.p_w > 50) {
					const_var.order_extra_items["labor_per_type"] = 25;
				}
				let checkEndWalls = 0;
				let checkSideWalls = 0;
				if (Object.keys(const_var.wallsData["center"]).length > 0) {
					checkSideWalls = parseFloat(checkSideWalls) + parseFloat(const_var.wallsData["center"].closedSideWalls);
					checkEndWalls = parseFloat(checkEndWalls) + parseFloat(const_var.wallsData["center"].closedEndWalls);
				}
				if (
					(!const_var.isLTBuilding || (const_var.isLTBuilding && params.leanStyle.front != "gable") || const_var.order_extra_items["labor_fee_on"] == "subtotal") &&
					Object.keys(const_var.wallsData["frontLean"]).length > 0 &&
					params.add_front_lean == true
				) {
					if (const_var.wallsData["frontLean"].closedSideWalls != 0) {
						checkSideWalls = parseFloat(checkSideWalls) + parseFloat(const_var.wallsData["frontLean"].closedSideWalls);
					}
					if (const_var.wallsData["frontLean"].closedEndWalls != 0) {
						checkEndWalls = parseFloat(checkEndWalls) + parseFloat(const_var.wallsData["frontLean"].closedEndWalls);
					}
				}
				if (
					(!const_var.isLTBuilding || (const_var.isLTBuilding && params.leanStyle.back != "gable") || const_var.order_extra_items["labor_fee_on"] == "subtotal") &&
					Object.keys(const_var.wallsData["backLean"]).length > 0 &&
					params.add_back_lean == true
				) {
					if (const_var.wallsData["backLean"].closedSideWalls != 0) {
						checkSideWalls = parseFloat(checkSideWalls) + parseFloat(const_var.wallsData["backLean"].closedSideWalls);
					}
					if (const_var.wallsData["backLean"].closedEndWalls != 0) {
						checkEndWalls = parseFloat(checkEndWalls) + parseFloat(const_var.wallsData["backLean"].closedEndWalls);
					}
				}
				if (
					(!const_var.isLTBuilding || (const_var.isLTBuilding && params.leanStyle.left != "gable") || const_var.order_extra_items["labor_fee_on"] == "subtotal") &&
					Object.keys(const_var.wallsData["leftLean"]).length > 0 &&
					params.add_left_lean == true
				) {
					if (const_var.wallsData["leftLean"].closedSideWalls != 0) {
						checkSideWalls = parseFloat(checkSideWalls) + parseFloat(const_var.wallsData["leftLean"].closedSideWalls);
					}
					if (const_var.wallsData["leftLean"].closedEndWalls != 0) {
						checkEndWalls = parseFloat(checkEndWalls) + parseFloat(const_var.wallsData["leftLean"].closedEndWalls);
					}
				}
				if (
					(!const_var.isLTBuilding || (const_var.isLTBuilding && params.leanStyle.right != "gable") || const_var.order_extra_items["labor_fee_on"] == "subtotal") &&
					Object.keys(const_var.wallsData["rightLean"]).length > 0 &&
					params.add_right_lean == true
				) {
					if (const_var.wallsData["rightLean"].closedSideWalls != 0) {
						checkSideWalls = parseFloat(checkSideWalls) + parseFloat(const_var.wallsData["rightLean"].closedSideWalls);
					}
					if (const_var.wallsData["rightLean"].closedEndWalls != 0) {
						checkEndWalls = parseFloat(checkEndWalls) + parseFloat(const_var.wallsData["rightLean"].closedEndWalls);
					}
				}
				if (const_var.order_extra_items["labor_fee_on"] == "building_amount" && const_var.isLTBuilding && params.leanStyle.front == "gable" && post_data["building"].leanto.length > 0) {
					let leanData = post_data["building"].leanto.find((leanto) => leanto.leanto_type === 3);
					let leanRangeValue = utlis.isNumberInRange(const_var.setCustomRangeR_and_B[params.p_r_s].height, params.leanF_p_h, "height");
					if (params.p_v_w == true || params.leanF_p_w > 50) {
						leanRangeValue = 25;
					}
					if (leanData) {
						orderTotalForLaborFee -= leanData.t_c_b;
						if (const_var.order_extra_items["labor_fee_on"] == "building_amount" && leanRangeValue != 0) {
							let currentBuildinglaborFee = parseFloat((leanData.t_c_b * leanRangeValue) / 100).toFixed(2);
							added_building_labor_fee = parseFloat(added_building_labor_fee) + parseFloat(currentBuildinglaborFee);
						}
					}
				}
				if (const_var.order_extra_items["labor_fee_on"] == "building_amount" && const_var.isLTBuilding && params.leanStyle.back == "gable" && post_data["building"].leanto.length > 0) {
					let leanData = post_data["building"].leanto.find((leanto) => leanto.leanto_type === 4);
					let leanRangeValue = utlis.isNumberInRange(const_var.setCustomRangeR_and_B[params.p_r_s].height, params.leanB_p_h, "height");
					if (params.p_v_w == true || params.leanB_p_w > 50) {
						leanRangeValue = 25;
					}
					if (leanData) {
						orderTotalForLaborFee -= leanData.t_c_b;
						if (const_var.order_extra_items["labor_fee_on"] == "building_amount" && leanRangeValue != 0) {
							let currentBuildinglaborFee = parseFloat((leanData.t_c_b * leanRangeValue) / 100).toFixed(2);
							added_building_labor_fee = parseFloat(added_building_labor_fee) + parseFloat(currentBuildinglaborFee);
						}
					}
				}
				if (const_var.order_extra_items["labor_fee_on"] == "building_amount" && const_var.isLTBuilding && params.leanStyle.left == "gable" && post_data["building"].leanto.length > 0) {
					let leanData = post_data["building"].leanto.find((leanto) => leanto.leanto_type === 1);
					let leanRangeValue = utlis.isNumberInRange(const_var.setCustomRangeR_and_B[params.p_r_s].height, params.lean_p_h, "height");
					if (params.p_v_w == true || params.lean_p_w > 50) {
						leanRangeValue = 25;
					}
					if (leanData) {
						orderTotalForLaborFee -= leanData.t_c_b;
						if (const_var.order_extra_items["labor_fee_on"] == "building_amount" && leanRangeValue != 0) {
							let currentBuildinglaborFee = parseFloat((leanData.t_c_b * leanRangeValue) / 100).toFixed(2);
							added_building_labor_fee = parseFloat(added_building_labor_fee) + parseFloat(currentBuildinglaborFee);
						}
					}
				}
				if (const_var.order_extra_items["labor_fee_on"] == "building_amount" && const_var.isLTBuilding && params.leanStyle.right == "gable" && post_data["building"].leanto.length > 0) {
					let leanData = post_data["building"].leanto.find((leanto) => leanto.leanto_type === 2);
					let leanRangeValue = utlis.isNumberInRange(const_var.setCustomRangeR_and_B[params.p_r_s].height, params.leanR_p_h, "height");
					if (params.p_v_w == true || params.leanR_p_w > 50) {
						leanRangeValue = 25;
					}
					if (leanData) {
						orderTotalForLaborFee -= leanData.t_c_b;
						if (const_var.order_extra_items["labor_fee_on"] == "building_amount" && leanRangeValue != 0) {
							let currentBuildinglaborFee = parseFloat((leanData.t_c_b * leanRangeValue) / 100).toFixed(2);
							added_building_labor_fee = parseFloat(added_building_labor_fee) + parseFloat(currentBuildinglaborFee);
						}
					}
				}

				if (params.p_v_w == true && (checkEndWalls != 0 || checkSideWalls != 0)) {
					const_var.order_extra_items["labor_per_type"] = 25;
				}
			}
			if (checkFeesCalculation && const_var.order_extra_items["labor_fee_on"] != null && const_var.defaultBuildingImgName != "Custom_Buildings") {
				if (const_var.order_extra_items["labor_fee_on"] == "building_amount" && const_var.order_extra_items["labor_per_type"] != 0) {
					cal_labor_fee = ((orderTotalForLaborFee * const_var.order_extra_items["labor_per_type"]) / 100).toFixed(2);
					cal_labor_fee = parseFloat(added_building_labor_fee) + parseFloat(cal_labor_fee);
				}
				if (const_var.order_extra_items["labor_fee_on"] == "subtotal" && const_var.order_extra_items["labor_per_type"] != 0) {
					cal_labor_fee = ((post_data["building"].sub_order_total * const_var.order_extra_items["labor_per_type"]) / 100).toFixed(2);
				}
			}
			if (const_var.order_extra_items["labor_fee_on"] == null) {
				cal_labor_fee = const_var.order_extra_items["extra_labour"];
			}
			if (const_var.order_extra_items["labor_fee_on"] != null && const_var.defaultBuildingImgName == "Custom_Buildings") {
				cal_labor_fee = 0;
			}

			if (params.p_s_n == 29 && (params.m_s_n == 3 || params.m_s_n == 9)) {
				if (const_var.order_extra_items["permit"] === "yes") {
					if (const_var.loginSession != undefined && const_var.loginSession == false) {
						if (const_var.stateManufacturerAcordingAPI[params.p_s_n].is_labor_show_in_3d == false && const_var.stateManufacturerAcordingAPI[params.p_s_n].is_permit_show_in_3d == true) {
							const_var.order_extra_items["extra_labour"] = parseFloat(const_var.stateManufacturerAcordingAPI[params.p_s_n].order_permit_fee);
							const_var.BuildingPriceArrar["labor_fee"] = const_var.order_extra_items["extra_labour"];
						} else {
							if (const_var.stateManufacturerAcordingAPI[params.p_s_n]["labor_fee_on"] == null) {
								const_var.order_extra_items["extra_labour"] =
									parseFloat(const_var.stateManufacturerAcordingAPI[params.p_s_n].order_permit_fee) + parseFloat(const_var.stateManufacturerAcordingAPI[params.p_s_n].labor_fee);
							} else {
								const_var.order_extra_items["extra_labour"] = parseFloat(cal_labor_fee) + parseFloat(const_var.stateManufacturerAcordingAPI[params.p_s_n].order_permit_fee);
							}
							if (const_var.order_extra_items.extra_labour && const_var.stateManufacturerAcordingAPI[params.p_s_n].labor_fee) {
								const_var.order_extra_items["order_permit_fee"] = 0;
								const_var.BuildingPriceArrar["order_permit_fee"] = 0;
							}
							const_var.BuildingPriceArrar["labor_fee"] = const_var.order_extra_items["extra_labour"];
						}
					} else {
						const_var.stateManufacturerAcordingAPI[params.p_s_n] != undefined &&
							const_var.stateManufacturerAcordingAPI[params.p_s_n].length > 0 &&
							const_var.stateManufacturerAcordingAPI[params.p_s_n].map((data) => {
								if (data.id == params.m_s_n) {
									if (params.p_s_n == 29 && (params.m_s_n == 3 || params.m_s_n == 9) && const_var.crmSetting.is_module_name !== "inventory") {
										const_var.order_extra_items["extra_labour"] =
											const_var.is_edit_labour == undefined
												? parseFloat(data.order_permit_fee) + (data.labor_fee_on != null ? parseFloat(cal_labor_fee) : parseFloat(data.labor_fee))
												: const_var.order_extra_items["extra_labour"];
										const_var.BuildingPriceArrar["labor_fee"] = const_var.order_extra_items["extra_labour"];
										const_var.order_extra_items.order_permit_fee = 0;
									}
									if (
										params.p_s_n == 29 &&
										(params.m_s_n == 3 || params.m_s_n == 9) &&
										((const_var.crmSetting.is_module_name == "quote" && const_var.crmSetting.duplicate_module == "quote" && const_var.crmSetting.sub_module == "") ||
											(const_var.crmSetting.is_module_name == "order" && const_var.crmSetting.duplicate_module == "order" && const_var.crmSetting.sub_module == "customer"))
									) {
										const_var.order_extra_items["extra_labour"] =
											const_var.is_edit_labour == undefined
												? parseFloat(data.order_permit_fee) + (data.labor_fee_on != null ? parseFloat(cal_labor_fee) : parseFloat(data.labor_fee))
												: const_var.order_extra_items["extra_labour"];
										const_var.BuildingPriceArrar["labor_fee"] = const_var.order_extra_items["extra_labour"];
										const_var.order_extra_items.order_permit_fee = 0;
									}
									if (params.p_s_n == 29 && (params.m_s_n == 3 || params.m_s_n == 9) && const_var.crmSetting.is_module_name == "inventory") {
										const_var.order_extra_items["extra_labour"] =
											const_var.is_edit_labour == undefined ? (data.labor_fee_on != null ? parseFloat(cal_labor_fee) : parseFloat(data.labor_fee)) : const_var.order_extra_items["extra_labour"];
										const_var.BuildingPriceArrar["labor_fee"] = const_var.order_extra_items["extra_labour"];
										const_var.order_extra_items.order_permit_fee = 0;
									}
								}
							});
					}
				} else if (const_var.order_extra_items["permit"] === "no" || const_var.order_extra_items["permit"] === "cust_verify") {
					if (params.p_s_n == 29 && (params.m_s_n == 3 || params.m_s_n == 9) && const_var.loginSession != undefined && const_var.loginSession == false) {
						const_var.order_extra_items["extra_labour"] =
							const_var.stateManufacturerAcordingAPI[params.p_s_n].labor_fee_on != null ? parseFloat(cal_labor_fee) : parseFloat(const_var.stateManufacturerAcordingAPI[params.p_s_n].labor_fee);
						if (const_var.stateManufacturerAcordingAPI[params.p_s_n].is_labor_show_in_3d == false) {
							const_var.order_extra_items["extra_labour"] = 0;
						}
						const_var.BuildingPriceArrar["labor_fee"] = const_var.order_extra_items["extra_labour"];
					} else {
						const_var.stateManufacturerAcordingAPI[params.p_s_n] != undefined &&
							const_var.stateManufacturerAcordingAPI[params.p_s_n].length > 0 &&
							const_var.stateManufacturerAcordingAPI[params.p_s_n].map((data) => {
								if (data.id == params.m_s_n && params.p_s_n == 29 && (params.m_s_n == 3 || params.m_s_n == 9)) {
									const_var.order_extra_items["extra_labour"] =
										const_var.is_edit_labour == undefined ? (data.labor_fee_on != null ? parseFloat(cal_labor_fee) : parseFloat(data.labor_fee)) : const_var.order_extra_items["extra_labour"];
									const_var.BuildingPriceArrar["labor_fee"] = const_var.order_extra_items["extra_labour"];
								}
							});
					}
				}
			} else {
				if (const_var.loginSession == true) {
					const_var.order_extra_items["extra_labour"] = const_var.is_edit_labour == undefined ? parseFloat(cal_labor_fee) : const_var.order_extra_items["extra_labour"];
				} else if (const_var.isPublicEdit == true) {
					const_var.order_extra_items["extra_labour"] = const_var.is_edit_labour == undefined ? parseFloat(cal_labor_fee) : const_var.order_extra_items["extra_labour"];
				} else {
					const_var.order_extra_items["extra_labour"] = parseFloat(cal_labor_fee);
				}
				const_var.BuildingPriceArrar["labor_fee"] = parseFloat(cal_labor_fee);
				if (const_var.order_extra_items["permit"] === "yes") {
					const_var.order_extra_items["order_permit_fee"] = const_var.order_extra_items["order_permit_fee"];
					const_var.BuildingPriceArrar["order_permit_fee"] = parseFloat(const_var.order_extra_items["order_permit_fee"]);
				} else {
					const_var.BuildingPriceArrar["order_permit_fee"] = 0;
				}
			}
		}

		let newTaxArray = [];
		var taxCalculation = 0;
		if (const_var.tax.percentage != 0 && const_var.tax.percentage != undefined && const_var.crmSetting.is_module_name != "inventory") {
			taxCalculation = const_var.tax.type == "per" ? (taxCalculation + (post_data["building"].sub_order_total * const_var.tax.percentage) / 100).toFixed(2) : parseFloat(taxCalculation + const_var.tax.percentage);
			const_var.tax.amount = taxCalculation;
			const_var.tax.name = const_var.tax.name == "" || const_var.tax.name == undefined ? "sales_tax" : const_var.tax.name;

			post_data["building"].parentTax = const_var.tax;
			const_var.sendTaxarray.push(const_var.tax);
		}

		var moretaxCalculation = 0;
		if (const_var.MoreTaxinputs != undefined && const_var.MoreTaxinputs.length > 0 && const_var.crmSetting.is_module_name != "inventory") {
			const_var.MoreTaxinputs.map((val, index) => {
				if (val.percentage == "") {
					val.percentage = 0;
				}
				if (val.amount == "") {
					val.amount = 0;
				}
				const_var.MoreTaxinputs[index].amount = val.type == "per" ? ((post_data["building"].sub_order_total * val.percentage) / 100).toFixed(2) : val.percentage;

				const_var.MoreTaxinputs[index].more_tax_amount = val.type == "per" ? ((post_data["building"].sub_order_total * val.percentage) / 100).toFixed(2) : val.percentage;
				moretaxCalculation = parseFloat(moretaxCalculation) + parseFloat(const_var.MoreTaxinputs[index].amount);
				const_var.MoreTaxinputs[index].name = const_var.MoreTaxinputs[index].name == "" || const_var.MoreTaxinputs[index].name == undefined ? "sales_tax" : const_var.MoreTaxinputs[index].name;
				const_var.sendTaxarray.push(const_var.MoreTaxinputs[index]);
			});
			post_data["building"].MoreTaxinputs = const_var.MoreTaxinputs;
		}
		if (commissionArray?.length > 0) {
			prepareObjToShowValue();
		}
		post_data["building"].all_tax_amount = const_var.tax.type == "per" ? parseFloat(taxCalculation) + parseFloat(moretaxCalculation) : parseFloat(taxCalculation) + parseFloat(moretaxCalculation);

		post_data["building"].tax_amount = const_var.tax.type == "per" ? parseFloat(taxCalculation) : parseFloat(taxCalculation);
		post_data["building"].tax_zipcode = params.tax_zipcode;
		post_data["building"].tax_exempt = params.tax_exempt == false ? 0 : 1;
		if (post_data["building"].tax_exempt == true) {
			const_var.MoreTaxinputs = [];
			const_var.tax = { percentage: 0, type: "%", name: "sales_tax", amount: 0 };
			post_data["building"].tax_amount = 0;
			post_data["building"].all_tax_amount = 0;
			taxCalculation = 0;
			moretaxCalculation = 0;
			const_var.sendTaxarray = [];
		}
		post_data["building"].tax = const_var.sendTaxarray;
		if (const_var.BuildingPriceArrar["insulation_calculation"] != undefined || const_var.BuildingPriceArrar["overhead_door_calculation"] != undefined) {
			if (const_var.sendTaxarray.length > 0) {
				Object.entries(post_data["building"].tax).map((val, key) => {
					let commonPrice = 0;
					if (val[1].percentage != undefined && val[1].percentage != 0) {
						if (const_var.BuildingPriceArrar["insulation_calculation"] != undefined) {
							val[1].insulation_tax_amount = convertToTwoDecimalNumber(
								parseFloat((parseFloat(val[1].percentage) * parseFloat(const_var.BuildingPriceArrar["insulation_calculation"].custom_insulation_total_amount)) / 100)
							);
							post_data["building"].all_tax_amount = parseFloat(post_data["building"].all_tax_amount) + parseFloat(val[1].insulation_tax_amount);
						}
						if (const_var.BuildingPriceArrar["overhead_door_calculation"] != undefined) {
							val[1].overhead_tax_amount = convertToTwoDecimalNumber(
								parseFloat((parseFloat(val[1].percentage) * parseFloat(const_var.BuildingPriceArrar["overhead_door_calculation"].custom_overhead_total_amount)) / 100)
							);
							post_data["building"].all_tax_amount = parseFloat(post_data["building"].all_tax_amount) + parseFloat(val[1].overhead_tax_amount);
						}
					}
				});
			}
		}
		if (
			p_c_i != true &&
			params.p_i_o == 0 &&
			params.insulation.leftLean.insulationId == 0 &&
			params.insulation.rightLean.insulationId == 0 &&
			params.insulation.frontLean.insulationId == 0 &&
			params.insulation.backLean.insulationId == 0
		) {
			const_var.BuildingPriceArrar["insulation_calculation"] = undefined;
		}

		post_data["building"].grand_total += parseFloat(const_var.newThirdPartySurcharge?.door_price || 0) + parseFloat(const_var.newThirdPartySurcharge?.insulation_price || 0);

		const_var.BuildingPriceArrar["additional_charges"] = 0;

		// ############################### for calculating CC price in edit case : SE3-I4392 ###############################
		if (
			const_var.card_processing_fee != undefined &&
			Object.keys(const_var.card_processing_fee).length > 0 &&
			const_var.card_processing_fee.is_edit == undefined &&
			const_var.card_processing_fee.percentage_of != undefined
		) {
			if (const_var.card_processing_fee.percentage_of == "base_price") {
				if (const_var.card_processing_fee.type == "%") {
					const_var.order_extra_items["processing_fee"] = const_var.card_processing_fee?.fee == 0 ? 0 : ((post_data["building"].roof_style_price * const_var.card_processing_fee.fee) / 100).toFixed(2);
				} else {
					const_var.order_extra_items["processing_fee"] = parseFloat(const_var.card_processing_fee.fee).toFixed(2);
				}
			}
			if (const_var.card_processing_fee.percentage_of == "building_amount") {
				if (const_var.card_processing_fee.type == "%") {
					const_var.order_extra_items["processing_fee"] = const_var.card_processing_fee?.fee == 0 ? 0 : ((post_data["building"].order_total * const_var.card_processing_fee.fee) / 100).toFixed(2);
				} else {
					const_var.order_extra_items["processing_fee"] = parseFloat(const_var.card_processing_fee.fee).toFixed(2);
				}
			}
			if (const_var.card_processing_fee.percentage_of == "dealer_deposit") {
				if (const_var.card_processing_fee.type == "%") {
					const_var.order_extra_items["processing_fee"] = const_var.card_processing_fee?.fee == 0 ? 0 : ((post_data["building"].dealer_deposit * const_var.card_processing_fee.fee) / 100).toFixed(2);
				} else {
					const_var.order_extra_items["processing_fee"] = parseFloat(const_var.card_processing_fee.fee).toFixed(2);
				}
			}
		}

		// ############ For old quotes cc fees ##############
		if (
			const_var.crmSetting.is_Edit == true &&
			const_var.editAPIDataByResponse.data.request_data.building.card_processing_fee == undefined &&
			const_var.card_processing_fee.is_edit == undefined &&
			const_var.isFromPickThis != true
		) {
			const_var.order_extra_items["processing_fee"] = const_var.editAPIDataByResponse.data.request_data.building.processing_fee;
		}

		if (const_var.order_extra_items["permit"] == null || const_var.order_extra_items["order_permit_fee"] == undefined || const_var.crmSetting.is_module_name == "inventory") {
			const_var.order_extra_items["order_permit_fee"] = 0;
		}
		if (const_var.order_extra_items != undefined) {
			post_data["building"].grand_total = utlis.num(post_data["building"].grand_total) + utlis.num(const_var.order_extra_items["equipment_rental"]);
			post_data["building"].grand_total = utlis.num(post_data["building"].grand_total) + utlis.num(const_var.order_extra_items["document_fee"]);
			post_data["building"].grand_total = utlis.num(post_data["building"].grand_total) + utlis.num(const_var.order_extra_items["order_processing_fee"]);
			post_data["building"].grand_total = utlis.num(post_data["building"].grand_total) + utlis.num(const_var.order_extra_items["delivery_fee"]);
			post_data["building"].grand_total = utlis.num(post_data["building"].grand_total) + utlis.num(const_var.order_extra_items["engineer_drawings"]);
			post_data["building"].grand_total = utlis.num(post_data["building"].grand_total) + utlis.num(const_var.order_extra_items["freight"]);
			post_data["building"].grand_total = utlis.num(post_data["building"].grand_total) + utlis.num(const_var.order_extra_items["extra_labour"]);
			post_data["building"].grand_total = utlis.num(post_data["building"].grand_total) + utlis.num(const_var.order_extra_items["grvy_value"]);
			post_data["building"].grand_total = utlis.num(post_data["building"].grand_total) + utlis.num(const_var.order_extra_items["concrete_work"]);
			post_data["building"].grand_total = utlis.num(post_data["building"].grand_total) + utlis.num(const_var.order_extra_items["ground_work"]);

			post_data["building"].grand_total = utlis.num(post_data["building"].grand_total) + utlis.num(const_var.order_extra_items["order_permit_fee"]);

			post_data["building"].grvy_value = const_var.order_extra_items["grvy_value"];
			const_var.order_extra_items["order_processing_fee"] = const_var.order_extra_items["order_processing_fee"] == undefined ? 0 : const_var.order_extra_items["order_processing_fee"];
			const_var.BuildingPriceArrar["grvy_value"] = parseFloat(post_data["building"].grvy_value);
			let isInventoryorNot =
				(const_var.crmSetting.duplicate_module != "inventory" && const_var.crmSetting.is_module_name != "inventory") ||
				(const_var.crmSetting.duplicate_module == "order" && const_var.crmSetting.is_module_name == "inventory") ||
				(const_var.crmSetting.duplicate_module == "quote" && const_var.crmSetting.is_module_name == "inventory");
			if (params.lift_type == true && data.side[0].lift_type != "" && isInventoryorNot) {
				post_data["building"].lift_type = params.lift_type;
				post_data["building"].lifttype_name = data.side[0].lift_type;
				let isLiftFeeInExtraAddOn = false;
				post_data["building"].lifttype_price = isLiftFeeInExtraAddOn
					? 0
					: UpdatePriceRecord == true && const_var.UpdatedPriceData.lifttype_price_changed != true
						? const_var.UpdatedPriceData.lifttype_price == undefined
							? 0
							: const_var.UpdatedPriceData.lifttype_price
						: data.side[0].lifttype_price;
				const_var.BuildingPriceArrar["additional_charges"] = parseFloat(const_var.BuildingPriceArrar["additional_charges"]) + parseFloat(post_data["building"].lifttype_price);
			} else {
				params.lifttype_price = 0;
				params.lift_type = false;
				post_data["building"].lifttype_price = 0;
				const_var.BuildingPriceArrar["additional_charges"] = parseFloat(const_var.BuildingPriceArrar["additional_charges"]) + parseFloat(post_data["building"].lifttype_price);
			}
			if (params.p_s_n == 29 && (params.m_s_n == 3 || params.m_s_n == 9)) {
				const_var.BuildingPriceArrar["additional_charges"] =
					parseFloat(const_var.BuildingPriceArrar["additional_charges"]) +
					parseFloat(const_var.order_extra_items["equipment_rental"]) +
					parseFloat(const_var.order_extra_items["concrete_work"]) +
					parseFloat(const_var.order_extra_items["ground_work"]) +
					parseFloat(const_var.order_extra_items["document_fee"]) +
					parseFloat(const_var.order_extra_items["order_processing_fee"]) +
					parseFloat(const_var.order_extra_items["delivery_fee"]) +
					parseFloat(const_var.order_extra_items["engineer_drawings"]) +
					parseFloat(const_var.order_extra_items["freight"]);
			} else {
				const_var.BuildingPriceArrar["additional_charges"] =
					parseFloat(const_var.BuildingPriceArrar["additional_charges"]) +
					parseFloat(const_var.order_extra_items["equipment_rental"]) +
					parseFloat(const_var.order_extra_items["concrete_work"]) +
					parseFloat(const_var.order_extra_items["ground_work"]) +
					parseFloat(const_var.order_extra_items["document_fee"]) +
					parseFloat(const_var.order_extra_items["order_processing_fee"]) +
					parseFloat(const_var.order_extra_items["delivery_fee"]) +
					parseFloat(const_var.order_extra_items["engineer_drawings"]) +
					parseFloat(const_var.order_extra_items["freight"]) +
					parseFloat(const_var.order_extra_items["extra_labour"]) +
					parseFloat(const_var.order_extra_items["order_permit_fee"]);
			}
			if (
				const_var.stateManufacturerAcordingAPIDiscount["surcharge"] != undefined &&
				const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] != undefined &&
				Object.keys(const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n]).length > 0
			) {
				if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].taxable == 0) {
					if (const_var.surcharge_amount_is_edit != undefined && const_var.surcharge_amount_is_edit == true) {
						const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].is_edit = true;
					}
					if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].is_edit == undefined) {
						const_var.order_extra_items["surchargeFees"] = 0;
						post_data["building"].surcharge_amount_type = const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount_type;
						if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount_type == "per") {
							if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].percentage_of == "building_amount") {
								post_data["building"].surcharge_percentage_of = const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].percentage_of;
								CalculatesurchargeFees = parseFloat(
									(parseFloat(const_var.BuildingPriceArrar["sub_order_total"]) * parseFloat(const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount)) / 100
								).toFixed(2);
							} else {
								if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].percentage_of == "basic_price") {
									post_data["building"].surcharge_percentage_of = const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].percentage_of;
									CalculatesurchargeFees = parseFloat(
										((parseFloat(post_data["building"].roof_style_price) + parseFloat(leantoPriceCalculation.totalBasePrice)) *
											parseFloat(const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount)) /
											100
									).toFixed(2);
								} else {
									CalculatesurchargeFees = parseFloat(
										(parseFloat(const_var.BuildingPriceArrar["sub_order_total"]) * parseFloat(const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount)) / 100
									).toFixed(2);
								}
							}
							post_data["building"].surcharge_calculate_amount = const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount;
						} else {
							post_data["building"].surcharge_calculate_amount =
								const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount != undefined ? const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount : 0;
							CalculatesurchargeFees =
								const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount != undefined
									? parseFloat(const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].amount)
									: 0;
						}
						CalculatesurchargeFees =
							const_var.UpdatedPriceData.surcharge_amount != undefined && const_var.crmSetting.is_Edit == true && const_var.checkPickThisBuilding == false
								? const_var.UpdatedPriceData.surcharge_amount
								: CalculatesurchargeFees;
					} else {
						CalculatesurchargeFees = CalculatesurchargeFees;
					}
					post_data["building"].surcharge_taxable =
						const_var.UpdatedPriceData.surcharge_taxable == undefined || const_var.UpdatedPriceData.surcharge_taxable == 0
							? const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].taxable
							: const_var.UpdatedPriceData.surcharge_taxable;
					if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].taxable == 0 && const_var.UpdatedPriceData.surcharge_taxable == 1) {
						post_data["building"].surcharge_taxable = const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n].taxable;
					}
					CalculatesurchargeFees = CalculatesurchargeFees;
					post_data["building"].surcharge_amount = CalculatesurchargeFees;
					post_data["building"].grand_total = parseFloat(post_data["building"].grand_total) + parseFloat(CalculatesurchargeFees);
					const_var.BuildingPriceArrar["additional_charges"] = parseFloat(const_var.BuildingPriceArrar["additional_charges"]) + parseFloat(CalculatesurchargeFees);
					if (const_var.order_extra_items["surchargeFees"] == 0) {
						const_var.order_extra_items["surchargeFees"] = parseFloat(CalculatesurchargeFees);
					}
				} else {
					if (const_var.UpdatedPriceData.surcharge_taxable != undefined) {
						if (const_var.UpdatedPriceData.surcharge_taxable == 0) {
							CalculatesurchargeFees = CalculatesurchargeFees != undefined ? parseFloat(CalculatesurchargeFees) : 0;
							post_data["building"].surcharge_taxable = const_var.UpdatedPriceData.surcharge_taxable;
							post_data["building"].surcharge_amount = parseFloat(CalculatesurchargeFees);
							post_data["building"].grand_total = parseFloat(post_data["building"].grand_total) + parseFloat(CalculatesurchargeFees);
							const_var.BuildingPriceArrar["surcharge_amount"] = 0;
							const_var.BuildingPriceArrar["additional_charges"] = parseFloat(const_var.BuildingPriceArrar["additional_charges"]) + parseFloat(CalculatesurchargeFees);
						}
					}
				}
			}
			if (const_var.stateManufacturerAcordingAPIDiscount["surcharge"] != undefined && const_var.stateManufacturerAcordingAPIDiscount["surcharge"][params.m_s_n] == undefined) {
				if (const_var.surcharge_amount_is_edit == false && const_var.UpdatedPriceData.surcharge_amount == undefined) {
					CalculatesurchargeFees = 0;
					const_var.order_extra_items["surchargeFees"] = parseFloat(CalculatesurchargeFees);
				}
				CalculatesurchargeFees = parseFloat(CalculatesurchargeFees);
				post_data["building"].surcharge_taxable = 0;
				post_data["building"].surcharge_amount = CalculatesurchargeFees;
				post_data["building"].grand_total = parseFloat(post_data["building"].grand_total) + parseFloat(CalculatesurchargeFees);
				const_var.BuildingPriceArrar["additional_charges"] = parseFloat(const_var.BuildingPriceArrar["additional_charges"]) + parseFloat(CalculatesurchargeFees);
			}
			if (const_var.order_extra_items["dont_show_processing_fee_pdf"] != undefined && const_var.order_extra_items["dont_show_processing_fee_pdf"] == "1") {
				const_var.BuildingPriceArrar["new_down_payment_total"] = const_var.BuildingPriceArrar["new_down_payment_total"] + parseFloat(const_var.order_extra_items["processing_fee"]);
				const_var.BuildingPriceArrar["processing_fee"] = parseFloat(const_var.order_extra_items["processing_fee"]);
				post_data["building"].grand_total = parseFloat(post_data["building"].grand_total) + parseFloat(const_var.order_extra_items["processing_fee"]);
			}
			if (const_var.order_extra_items["dont_show_processing_fee_pdf"] != undefined && const_var.order_extra_items["dont_show_processing_fee_pdf"] == "2") {
				const_var.BuildingPriceArrar["processing_fee"] = parseFloat(const_var.order_extra_items["processing_fee"]);
			}
			if (post_data["building"].discount_amount != undefined && post_data["building"].discount_amount != 0) {
				post_data["building"].has_grvy = 1;
				post_data["building"].grvy_value = 0;
			} else {
				post_data["building"].has_grvy = 0;
			}

			const_var.BuildingPriceArrar["has_grvy"] = post_data["building"].has_grvy;
			const_var.order_extra_items.has_grvy = post_data["building"].has_grvy;
			const_var.order_extra_items.grvy_value = post_data["building"].grvy_value;
			post_data["building"].order_extra_items = const_var.order_extra_items;
		}
		if (hasextraAddOnItemsArrayAnywhere?.length > 0 && addOnItemPriceArray) {
			const_var.BuildingPriceArrar["additional_charges"] = parseFloat(const_var.BuildingPriceArrar["additional_charges"]);
			post_data["building"].grand_total = parseFloat(post_data["building"].grand_total);
		}
		if (const_var.additionalChargeArr != undefined && const_var.additionalChargeArr.length > 0) {
			const_var.additionalChargeArr.map((val, index) => {
				if (val != null) {
					if (val.name != "" && val.price > 0) {
						const_var.BuildingPriceArrar["additional_charges"] = parseFloat(const_var.BuildingPriceArrar["additional_charges"]) + parseFloat(val.price);

						post_data["building"].grand_total = parseFloat(post_data["building"].grand_total) + parseFloat(val.price);
					}
				}
			});
		}
		post_data["building"].AdditionalCharges = const_var.additionalChargeArr;

		if (const_var.crmSetting.main_domain_url != undefined && const_var.crmSetting.main_domain_url == "eaglebuildings.com") {
			if (params.paymentmode == "cash") {
				params.paymentmode = "cod";
				const_var.paymentOptionObj[params.paymentmode] = { type: "cash_on_delivery", finance_company: "", application_id: "", plan_no: "" };
			}
		}

		post_data["building"].payment_mode = const_var.paymentOptionObj[params.paymentmode];

		if (const_var?.thirdPartyPricesObj?.garage?.garage_surcharge_val) {
			const_var.BuildingPriceArrar["custom_subTotal"] += parseFloat(const_var.thirdPartyPricesObj?.garage?.garage_surcharge_val) || 0;
			const_var.BuildingPriceArrar["grand_total"] += parseFloat(const_var.thirdPartyPricesObj?.garage?.garage_surcharge_val) || 0;
		}
		if (const_var.thirdPartyPricesObj?.garage?.garage_add_val) {
			const_var.BuildingPriceArrar["custom_subTotal"] += parseFloat(const_var.thirdPartyPricesObj?.garage?.garage_add_val) || 0;
			const_var.BuildingPriceArrar["grand_total"] += parseFloat(const_var.thirdPartyPricesObj?.garage?.garage_add_val) || 0;
		}
		if (const_var?.thirdPartyPricesObj?.insulation?.inc_surcharge_val) {
			const_var.BuildingPriceArrar["custom_subTotal"] += parseFloat(const_var.thirdPartyPricesObj?.insulation?.inc_surcharge_val) || 0;
			const_var.BuildingPriceArrar["grand_total"] += parseFloat(const_var.thirdPartyPricesObj?.insulation?.inc_surcharge_val) || 0;
		}
		if (const_var.thirdPartyPricesObj?.insulation?.inc_add_val) {
			const_var.BuildingPriceArrar["custom_subTotal"] += parseFloat(const_var.thirdPartyPricesObj?.insulation?.inc_add_val) || 0;
			const_var.BuildingPriceArrar["grand_total"] += parseFloat(const_var.thirdPartyPricesObj?.insulation?.inc_add_val) || 0;
		}
		if (post_data?.building?.overhead_door_calculation) {
			let subCat = const_var.thirdPartyComponent?.commissions?.garage?.doorsCategory?.reduce((acc, val) => acc.concat(val), []);
			if (subCat?.length > 0 && post_data?.building?.overhead_door_calculation) {
				post_data.building.overhead_door_calculation["sub_category"] = subCat;

				post_data.building.overhead_door_calculation["taxable_surcharge_amount"] = const_var.thirdPartyComponent?.surcharge?.garage?.taxValue || 0;
				post_data.building.overhead_door_calculation["non_taxable_surcharge_amount"] = const_var.thirdPartyComponent?.surcharge?.garage?.additionalValue || 0;

				const_var.BuildingPriceArrar["custom_down_payment_total"] = const_var.thirdPartyPricesObj.garage.garage_commission_amount;

				const_var.BuildingPriceArrar["custom_subTotal"] =
					const_var.thirdPartyPricesObj.garage.garage_subtotal + (parseFloat(Number(const_var.thirdPartyComponent?.surcharge?.garage?.additionalValue).toFixed(2)) || 0);

				post_data.building["custom_overhead_down_payment_total"] = parseFloat(Number(const_var.thirdPartyComponent.commissions.garage.totalPrice).toFixed(2)) || 0;
				const_var.BuildingPriceArrar.overhead_door_calculation["custom_overhead_down_payment_total"] = parseFloat(Number(const_var.thirdPartyComponent.commissions.garage.totalPrice).toFixed(2)) || 0;

				post_data.building["custom_overhead_total_amount"] = const_var.thirdPartyComponent.commissions.garage.allDoorPrices || 0;
				const_var.BuildingPriceArrar.overhead_door_calculation["custom_overhead_total_amount"] = const_var.thirdPartyComponent.commissions.garage.allDoorPrices || 0;
			}
		}
		if (post_data?.building?.insulation_calculation) {
			let filterArr = const_var.thirdPartyComponent?.commissions?.insulation?.incArrayCategory?.filter((value, index, self) => {
				return self.indexOf(value) === index;
			});
			if (filterArr?.length > 0 && post_data.building.insulation_calculation) {
				post_data.building.insulation_calculation["extra_chargeable_insulation"] = filterArr;

				post_data.building.insulation_calculation["taxable_surcharge_amount"] = const_var.thirdPartyComponent?.surcharge?.insulation?.taxValue || 0;
				post_data.building.insulation_calculation["non_taxable_surcharge_amount"] = const_var.thirdPartyComponent?.surcharge?.insulation?.additionalValue || 0;

				const_var.BuildingPriceArrar["custom_down_payment_total"] =
					(const_var.thirdPartyPricesObj?.insulation?.inc_commission_amount || 0) + (const_var.thirdPartyPricesObj?.garage?.garage_commission_amount || 0);

				const_var.BuildingPriceArrar["custom_subTotal"] =
					(const_var.thirdPartyPricesObj?.garage?.garage_subtotal || 0) +
					(const_var.thirdPartyComponent?.surcharge?.garage?.additionalValue || 0) +
					((const_var.thirdPartyPricesObj?.insulation?.inc_subtotal || 0) + (const_var.thirdPartyComponent?.surcharge?.insulation?.additionalValue || 0));

				post_data.building.insulation_calculation["custom_insulation_down_payment_total"] = const_var.thirdPartyComponent?.commissions?.insulation?.totalPrice || 0;
				post_data.building.custom_insulation_down_payment_total = parseFloat(Number(const_var.thirdPartyComponent?.commissions?.insulation?.totalPrice).toFixed(2)) || 0;

				post_data.building.insulation_calculation["custom_insulation_total_amount"] = const_var.thirdPartyComponent?.commissions?.insulation?.incTotalValue || 0;
			}
		}

		if (params.p_s_n == 29 && (params.m_s_n == 3 || params.m_s_n == 9)) {
			post_data["building"].due_upon_installation =
				parseFloat(const_var.BuildingPriceArrar["new_sub_order_total"]) +
				parseFloat(const_var.BuildingPriceArrar["custom_subTotal"]) +
				parseFloat(const_var.BuildingPriceArrar["labor_fee"]) +
				parseFloat(const_var.BuildingPriceArrar["additional_charges"]) +
				parseFloat(post_data["building"].all_tax_amount) -
				parseFloat(const_var.BuildingPriceArrar["custom_down_payment_total"]);
		} else {
			post_data["building"].due_upon_installation =
				parseFloat(const_var.BuildingPriceArrar["new_sub_order_total"]) +
				parseFloat(const_var.BuildingPriceArrar["custom_subTotal"]) +
				parseFloat(const_var.BuildingPriceArrar["additional_charges"]) +
				parseFloat(post_data["building"].all_tax_amount) -
				parseFloat(const_var.BuildingPriceArrar["custom_down_payment_total"]);
		}
		const_var.BuildingPriceArrar["grand_total"] = post_data["building"].grand_total + post_data["building"].tax_amount;
		post_data["building"].grand_total =
			post_data["building"].due_upon_installation + const_var.BuildingPriceArrar["new_down_payment_total"] + const_var.BuildingPriceArrar["custom_down_payment_total"] + const_var.BuildingPriceArrar["grvy_value"];
		post_data["building"].dealer_deposit = const_var.BuildingPriceArrar["new_down_payment_total"] + const_var.BuildingPriceArrar["grvy_value"];

		if (params.m_s_n == 184) {
			let checkAppliedForCS = true;
			let checkAppliedForUS = true;
			if (const_var.crmSetting.is_Edit == true && const_var.isFromCompare != true) {
				if (const_var.editAPIDataByResponse.data?.request_data?.building?.additionalFeaturesArray?.length > 0) {
					let colorScrewIndex = extra_items.findIndex((value) => value.item_name.toLowerCase().includes("colored screws"));
					checkAppliedForCS = const_var.editAPIDataByResponse.data.request_data.building.additionalFeaturesArray.find((obj) => obj && obj.additional_feature.toLowerCase().includes("colored screws"));
					if (checkAppliedForCS != undefined && colorScrewIndex != undefined && extra_items[colorScrewIndex] != undefined) {
						extra_items[colorScrewIndex]["is_disabled"] = checkAppliedForCS.is_disabled || false;
					}

					let upgradeScrewIndex = extra_items.findIndex((value) => value.item_name.toLowerCase().includes("upgraded screws"));
					checkAppliedForUS =
						const_var.editAPIDataByResponse.data.request_data.building.additionalFeaturesArray.find((obj) => obj && obj.additional_feature.toLowerCase().includes("upgraded screws")) != undefined;
					if (checkAppliedForUS != undefined && upgradeScrewIndex != undefined && extra_items[upgradeScrewIndex] != undefined) {
						extra_items[upgradeScrewIndex]["is_disabled"] = true;
					}
				}
			} else {
				let colorScrewIndex = extra_items.findIndex((value) => value.item_name.toLowerCase().includes("colored screws"));
				if (colorScrewIndex != undefined && extra_items[colorScrewIndex] != undefined) {
					extra_items[colorScrewIndex]["is_disabled"] = true;
				}
				let upgradeScrewIndex = extra_items.findIndex((value) => value.item_name.toLowerCase().includes("upgraded screws"));

				if (upgradeScrewIndex != undefined && extra_items[upgradeScrewIndex] != undefined) {
					extra_items[upgradeScrewIndex]["is_disabled"] = true;
				}
			}
		}

		extraItems.centerBuilding = structuredClone(extra_items ?? []);
		post_data["building"]["extra_items"] = [...extraItems.centerBuilding];

		post_data["building"].leanto.forEach((lean) => {
			lean.extra_items = extraItems[LEAN_TYPE_NUM_TO_STR[lean.leanto_type]];
		});
		post_data["building"]["entry_points"] = const_var.entry_points;
		post_data["building"]["newDoorsArray"] = const_var.newDoorsArray;
		post_data["building"]["hide_price_calculation"] = const_var.hide_price_calculation;

		if (const_var.crmSetting.is_Edit) {
			if (
				const_var.callFromDoorAddOrRemove &&
				post_data["building"].down_payment_discount_rate != undefined &&
				post_data["building"].down_payment_total != undefined &&
				parseFloat(post_data["building"].down_payment_discount_rate) > parseFloat(post_data["building"].down_payment_total) &&
				post_data["building"].down_payment_type
			) {
				post_data["building"].down_payment_discount_type = "per";
				post_data["building"].down_payment_discount_rate = 0;
				post_data["building"].down_payment_discount_total = 0;
				const_var.UpdatedPriceData["down_payment_discount_total"] = 0;
				const_var.UpdatedPriceData["down_payment_discount_rate"] = 0;
				const_var.BuildingPriceArrar["down_payment_discount_total"] = 0;
			}
		} else if (
			post_data["building"].down_payment_discount_rate != undefined &&
			post_data["building"].down_payment_total != undefined &&
			parseFloat(post_data["building"].down_payment_discount_rate) > parseFloat(post_data["building"].down_payment_total) &&
			post_data["building"].down_payment_type
		) {
			post_data["building"].down_payment_discount_type = "per";
			post_data["building"].down_payment_discount_rate = 0;
			post_data["building"].down_payment_discount_total = 0;
			const_var.UpdatedPriceData["down_payment_discount_total"] = 0;
			const_var.UpdatedPriceData["down_payment_discount_rate"] = 0;
			const_var.BuildingPriceArrar["down_payment_discount_total"] = 0;
		}

		if (const_var.defaultBuildingArr.length > 0 && const_var.BuldingIDforReset != undefined) {
			post_data["building"]["default_building_image_name"] = const_var.defaultBuildingArr[const_var.BuldingIDforReset] != undefined ? const_var.defaultBuildingArr[const_var.BuldingIDforReset].image_name : "";
			const_var.default_building_imageName = post_data["building"]["default_building_image_name"];
		}

		var newJsonData = const_var.crmSetting.pre_quote_form == true && const_var.loginSession == false && const_var.preQuoteApiCalled == true && const_var.preQuoteError == false ? { ...const_var.post_data } : {};
		newJsonData["building"] = { ...const_var.order_extra_items, ...post_data["building"] };
		newJsonData.building_total = t_c;
		const_var.post_data = newJsonData;
		const_var.UpdatedPriceData = post_data["building"];
		const_var.UpdatedPriceData.elements = [];

		const_var.post_data = { ...const_var.post_data, ...const_var.LeadCustomerData };
		const_var.post_data.custom_building = const_var.b_o_J_1[params.p_b_t] != "Custom Buildings" ? 0 : 1;

		if (const_var.crmSetting.parent_api_token != const_var.crmSetting.api_token) {
			const_var.post_data["edomain"] = const_var.crmSetting.main_domain_url;
			const_var.post_data.building["edomain"] = const_var.crmSetting.main_domain_url;
		}
		if (
			const_var.editAPIDataByResponse != undefined &&
			const_var.editAPIDataByResponse.data != undefined &&
			const_var.editAPIDataByResponse.data.request_data != undefined &&
			const_var.editAPIDataByResponse.data.request_data.edomain != undefined
		) {
			const_var.post_data["edomain"] = const_var.editAPIDataByResponse.data.request_data.edomain;
			const_var.post_data.building["edomain"] = const_var.editAPIDataByResponse.data.request_data.edomain;
		}
		filtterArrayElements();
		let allUpdatedPriceElements = {};
		Object.entries(extraItems).forEach(([key, value]) => {
			allUpdatedPriceElements[key] = {};
			value.forEach((item) => {
				allUpdatedPriceElements[key][item.item_name] = item;
			});
		});

		const currentExtraItems = extraItems[const_var.selectedLeanType || "centerBuilding"];
		for (var i = currentExtraItems.length - 1; i >= 0; i--) {
			if (currentExtraItems[i].item_name) {
				const_var.UpdatedPriceData["elements"][currentExtraItems[i].item_name.toString()] = currentExtraItems[i];
			}
		}

		if (const_var.isLTBuilding && const_var.post_data?.building?.leanto) {
			const_var.post_data?.building?.leanto.forEach((lean) => {
				lean.additionalFeaturesArray = JSON.parse(JSON.stringify(const_var.lNTBuildingData.additionalFeaturesArray[LEAN_TYPE_NUM_TO_STR[lean.leanto_type]]));
				lean.ExtraItemsFeaturesArray = JSON.parse(JSON.stringify(const_var.lNTBuildingData.ExtraItemsFeaturesArray[LEAN_TYPE_NUM_TO_STR[lean.leanto_type]]));
				lean.ExtraItemsFeaturesQuantityArray = JSON.parse(JSON.stringify(const_var.lNTBuildingData.ExtraItemsFeaturesQuantityArray[LEAN_TYPE_NUM_TO_STR[lean.leanto_type]]));
				lean.extraAddOnItemsArray = JSON.parse(JSON.stringify(const_var.lNTBuildingData.extraAddOnItemsArray[LEAN_TYPE_NUM_TO_STR[lean.leanto_type]]));
			});
		}

		if (const_var.post_data?.building?.discount_rate != undefined) {
			const_var.post_data.building["discount_rate_updated"] = const_var.post_data?.building?.discount_rate;
		}

		if (const_var.post_data.building.connection_fee_side == undefined) {
			const_var.post_data.building["connection_fee_side"] = 0;
		}
		if (const_var.post_data.building.connection_fee_end == undefined) {
			const_var.post_data.building["connection_fee_end"] = 0;
		}

		if (const_var.isLTBuilding) {
			utlis.backupUpdatedPriceDataElements(const_var, allUpdatedPriceElements);
		}

		if (const_var.post_data?.building?.tax?.length > 0) {
			let garage = Object.values(const_var.thirdPartyComponent?.tax?.garage);
			let insulation = Object.values(const_var.thirdPartyComponent?.tax?.insulation);

			const_var.post_data.building?.tax?.forEach((tax, index) => {
				if (tax?.overhead_tax_amount && garage) {
					tax.overhead_tax_amount = garage[index]?.tax_amount ? parseFloat(garage[index]?.tax_amount).toFixed(2) || 0 : 0;
				}
				if (tax?.insulation_tax_amount && insulation) {
					tax.insulation_tax_amount = insulation[index]?.tax_amount ? parseFloat(insulation[index]?.tax_amount).toFixed(2) || 0 : 0;
				}
			});
		}
	};
	return {
		cP
	};
};
